<template>
  <div>
    <div id="errosGerais" ref="errosGerais">
      <div
        v-if="loading"
        class="ms-7 mb-7"
        v-bind:data-kt-indicator="loading ? 'on' : 'off'"
      >
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
      </div>
      <div
        v-if="this.errosGerais.Message"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              {{ this.errosGerais.Message }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="this.errosValidacaoGeral.length && !this.loading"
        class="notice d-flex bg-light-danger rounded border-danger border border-dashed ms-0 me-0 mb-9 p-6"
      >
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <inline-svg src="media/icons/duotune/general/gen044.svg" />
        </span>
        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <h4 class="text-gray-800 fw-bolder">Aviso</h4>
            <div class="fs-6 text-gray-600">
              <ul>
                <li v-for="value in this.errosValidacaoGeral" :key="value">
                  <button
                    class="btn btn-link p-0"
                    v-if="value.error"
                    @click="focusAviso(value)"
                  >
                    {{ value.error }}
                  </button>
                  <a v-else>
                    {{ value }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex flex-column flex-xl-row">
        <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
          <div class="card">
            <div class="card-body pt-9 pb-0">
              <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
                <div class="flex-grow-1">
                  <div
                    class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                  >
                    <div class="d-flex flex-column mb-4">
                      <h2>
                        Pedido Nº
                        {{ this.pedido.id > 0 ? this.pedido.id : "EDIÇÃO" }}
                      </h2>
                      <div
                        v-if="this.pedido.id === 0"
                        class="d-flex text-muted fs-7 align-items-center"
                      >
                        <div class="badge badge-light-info text-info">
                          {{ "NOVO PEDIDO" }}
                        </div>
                      </div>
                      <div
                        v-else
                        class="d-flex text-muted fs-7 align-items-center"
                      >
                        GUID:
                        <div class="badge badge-light-info text-info ms-2">
                          {{ this.pedido.guid }}
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <button
                        class="btn btn-danger svg-icon-white me-2 mb-2"
                        @click="this.cancelarPedido()"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr015.svg"
                            class="me-2"
                          />Cancelar
                        </span>
                      </button>
                      <button
                        class="btn btn-success svg-icon-white mb-2"
                        @click="confirmarPedido()"
                        v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
                      >
                        <span class="indicator-progress">
                          <span
                            class="spinner-border spinner-border-sm align-middle ms-1"
                          ></span>
                          Aguarde...
                        </span>
                        <span class="svg-icon svg-icon-1" v-if="!this.loading">
                          <inline-svg
                            src="media/icons/duotune/arrows/arr016.svg"
                            class="me-2"
                          />Confirmar
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="separator"></div>
              <div class="d-flex overflow-auto h-55px">
                <ul
                  class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap"
                >
                  <li class="nav-item">
                    <a
                      ref="tabGeral"
                      id="tabGeral"
                      class="nav-link text-active-primary pb-4 active nav-link-pedido"
                      data-bs-toggle="tab"
                      href="#kt_pedido_geral"
                      >Pedido</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      ref="tabProduto"
                      id="tabProduto"
                      class="nav-link text-active-primary pb-4 nav-link-pedido"
                      data-bs-toggle="tab"
                      href="#kt_pedido_produto"
                      >Produtos</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      ref="tabPagamento"
                      id="tabPagamento"
                      class="nav-link text-active-primary pb-4 nav-link-pedido"
                      data-bs-toggle="tab"
                      href="#kt_pedido_pagamento"
                      >Duplicatas</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="tab-content">
            <div
              class="tab-pane fade show active tab-pane-pedido"
              id="kt_pedido_geral"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="pedido_geral">
                      <h2>Geral</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div class="col-xl-6 col-xxl-2 fv-row mb-6">
                        <label class="form-label">Ped. Vendedor</label>
                        <input
                          :id="`n_ped_mobile`"
                          type="text"
                          class="form-control form-control-solid"
                          v-model="this.pedido.n_ped_mobile"
                          readonly
                          :class="[
                            getErrorByID(`n_ped_mobile`) ? 'is-invalid' : '',
                          ]"
                        />
                        <div
                          v-if="getErrorByID(`n_ped_mobile`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`n_ped_mobile`) }}
                        </div>
                      </div>
                      <div class="col-xl-6 col-xxl-2 fv-row mb-6">
                        <label class="form-label">Prazo / Dias</label>
                        <input
                          :id="`prazo_dias`"
                          type="number"
                          class="form-control"
                          v-model="this.pedido.prazo_dias"
                          @change="atualizaDataSaida()"
                          :class="[
                            getErrorByID(`prazo_dias`) ? 'is-invalid' : '',
                          ]"
                        />
                        <div
                          v-if="getErrorByID(`prazo_dias`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`prazo_dias`) }}
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label class="form-label">Data de Emissão</label>
                          <el-date-picker
                            :id="`data_emissao`"
                            v-model="this.pedido.data_emissao"
                            type="datetime"
                            name="dtpDataEmissao"
                            placeholder="Selecione uma data"
                            class="w-100"
                            format="DD/MM/YYYY HH:mm:ss"
                            size="large"
                          />
                          <div
                            v-if="getErrorByID(`data_emissao`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`data_emissao`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label class="form-label">Data Saída/Entrega</label>
                          <el-date-picker
                            :id="`data_entrega`"
                            v-model.sync="this.pedido.data_entrega"
                            type="datetime"
                            name="dtpDataEntrega"
                            placeholder="Selecione uma data"
                            class="w-100"
                            format="DD/MM/YYYY HH:mm:ss"
                            size="large"
                          />
                          <div
                            v-if="getErrorByID(`data_entrega`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`data_entrega`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6">
                          <div class="d-flex justify-content-between">
                            <label class="form-label me-4">Situação</label>
                            <div class="card-toolbar">
                              <button
                                v-if="this.consultarSituacaoPedido"
                                @click="modalSituacoesPedido(true)"
                                class="btn btn-sm btn-secondary px-2 py-0 m-0"
                              >
                                <span class="svg-icon svg-icon-1 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen041.svg"
                                /></span>
                              </button>
                            </div>
                          </div>
                          <select
                            :id="`situacao`"
                            class="form-select mb-0"
                            data-placeholder="Selecione uma opção"
                            v-model="pedido.situacao"
                            :class="[
                              getErrorByID(`situacao`) ? 'is-invalid' : '',
                            ]"
                          >
                            <template
                              v-for="situacao in this.situacoes"
                              :key="situacao"
                            >
                              <option
                                :value="situacao.descricao"
                                v-bind:selected="[
                                  situacao.descricao === pedido.situacao
                                    ? 'selected'
                                    : '',
                                ]"
                              >
                                {{ situacao.descricao }}
                              </option>
                            </template>
                          </select>
                          <div
                            v-if="getErrorByID(`situacao`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`situacao`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <div class="d-flex justify-content-between">
                            <label class="form-label me-4">Categoria</label>
                            <div class="card-toolbar">
                              <button
                                v-if="this.consultarCategoriaPedido"
                                @click="modalCategoriasPedido(true)"
                                class="btn btn-sm btn-secondary px-2 py-0 m-0"
                              >
                                <span class="svg-icon svg-icon-1 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen041.svg"
                                /></span>
                              </button>
                            </div>
                          </div>
                          <select
                            :id="`categoria`"
                            class="form-select mb-0"
                            data-placeholder="Selecione uma opção"
                            v-model="pedido.categoria"
                            :class="[
                              getErrorByID(`categoria`) ? 'is-invalid' : '',
                            ]"
                          >
                            <template
                              v-for="categoria in this.categorias"
                              :key="categoria"
                            >
                              <option
                                :value="categoria.descricao"
                                v-bind:selected="[
                                  categoria.descricao === pedido.categoria
                                    ? 'selected'
                                    : '',
                                ]"
                              >
                                {{ categoria.descricao }}
                              </option>
                            </template>
                          </select>
                          <div
                            v-if="getErrorByID(`categoria`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`categoria`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <div class="d-flex justify-content-between">
                            <label class="form-label me-4">Tipo</label>
                            <div class="card-toolbar">
                              <button
                                v-if="this.consultarTipoPedido"
                                @click="modalTiposPedido(true)"
                                class="btn btn-sm btn-secondary px-2 py-0 m-0"
                              >
                                <span class="svg-icon svg-icon-1 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen041.svg"
                                /></span>
                              </button>
                            </div>
                          </div>
                          <select
                            :id="`tipo`"
                            class="form-select mb-0"
                            data-placeholder="Selecione uma opção"
                            v-model="pedido.tipo"
                            :class="[getErrorByID(`tipo`) ? 'is-invalid' : '']"
                          >
                            <template v-for="tipo in this.tipos" :key="tipo">
                              <option
                                :value="tipo.descricao"
                                v-bind:selected="[
                                  tipo.descricao === pedido.tipo
                                    ? 'selected'
                                    : '',
                                ]"
                              >
                                {{ tipo.descricao }}
                              </option>
                            </template>
                          </select>
                          <div
                            v-if="getErrorByID(`tipo`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`tipo`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <div class="d-flex justify-content-between">
                            <label class="form-label me-4">Local</label>
                            <div class="card-toolbar">
                              <button
                                v-if="this.consultarLocalPedido"
                                @click="modalLocaisPedido(true)"
                                class="btn btn-sm btn-secondary px-2 py-0 m-0"
                              >
                                <span class="svg-icon svg-icon-1 m-0">
                                  <inline-svg
                                    src="media/icons/duotune/general/gen041.svg"
                                /></span>
                              </button>
                            </div>
                          </div>
                          <select
                            :id="`local`"
                            class="form-select mb-0"
                            data-placeholder="Selecione uma opção"
                            v-model="pedido.local"
                            :class="[getErrorByID(`local`) ? 'is-invalid' : '']"
                          >
                            <template v-for="local in this.locais" :key="local">
                              <option
                                :value="local.descricao"
                                v-bind:selected="[
                                  local.descricao === pedido.local
                                    ? 'selected'
                                    : '',
                                ]"
                              >
                                {{ local.descricao }}
                              </option>
                            </template>
                          </select>
                          <div
                            v-if="getErrorByID(`local`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`local`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label class="form-label">Conta</label>
                          <div class="input-group">
                            <input
                              :id="`id_conta`"
                              type="text"
                              class="form-control"
                              v-model="this.pedido.id_conta"
                              :class="[
                                getErrorByID(`id_conta`) ? 'is-invalid' : '',
                              ]"
                              readonly
                            />
                            <button
                              class="input-group-text"
                              @click="this.modalContas(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`id_conta`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`id_conta`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-3 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label class="form-label">Custo</label>
                          <div class="input-group">
                            <input
                              :id="`id_custo`"
                              type="text"
                              class="form-control"
                              v-model="this.pedido.id_custo"
                              :class="[
                                getErrorByID(`id_custo`) ? 'is-invalid' : '',
                              ]"
                              readonly
                            />
                            <button
                              class="input-group-text"
                              @click="this.modalCustos(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`id_custo`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`id_custo`) }}
                          </div>
                        </div>
                      </div>
                      <div class="col-auto mb-2 mt-xl-8 mt-xxl-8">
                        <button
                          @click="this.modalEditarPedidoCompra(true)"
                          class="btn btn-light svg-icon-white me-2 mb-2 min-w-150px"
                        >
                          <i class="bi bi-journal-text me-2 fs-3"></i>P. Compra
                        </button>
                      </div>
                      <div class="col-auto mb-2 mt-xl-8 mt-xxl-8">
                        <button
                          v-if="this.consultarPedidoAnexo"
                          @click="this.modalEditarPedidoAnexo(true)"
                          class="btn btn-light svg-icon-white me-2 mb-2 min-w-150px"
                        >
                          <div v-if="this.pedido.PedidoAnexo.length > 0">
                            <i class="bi bi-paperclip me-2 fs-3"></i
                            >{{
                              "Anexos (" + this.pedido.PedidoAnexo.length + ")"
                            }}
                          </div>
                          <div v-else>
                            <i class="bi bi-paperclip me-2 fs-3"></i>Anexos
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="pedido_cliente">
                      <h2>Dados do Cliente</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-3 col-md-3 col-lg-2 col-xl-3 col-xxl-2 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label class="form-label">Código</label>
                          <input
                            :id="`PedidoClienteid_cliente`"
                            type="text"
                            class="form-control form-control-solid"
                            v-model="this.pedido.PedidoCliente.id_cliente"
                            :class="[
                              getErrorByID(`PedidoClienteid_cliente`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="getErrorByID(`PedidoClienteid_cliente`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClienteid_cliente`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-9 col-md-9 col-lg-10 col-xl-9 col-xxl-10 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientenome`"
                            class="required form-label"
                            >Nome / Razão social</label
                          >
                          <div class="input-group mb-2">
                            <input
                              type="text"
                              :id="`PedidoClientenome`"
                              :value="
                                (this.pedido.PedidoCliente.nome = this.pedido
                                  .PedidoCliente.nome
                                  ? this.pedido.PedidoCliente.nome.toUpperCase()
                                  : '')
                              "
                              @input="
                                this.pedido.PedidoCliente.nome =
                                  $event.target.value.toUpperCase()
                              "
                              class="form-control"
                              :class="[
                                getErrorByID(`PedidoClientenome`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              readonly
                            />
                            <button
                              type="button"
                              class="input-group-text"
                              @click="modalClientes(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`PedidoClientenome`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClientenome`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-xxl-7 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientecpf_cnpj`"
                            class="form-label"
                            >CPF / CNPJ</label
                          >
                          <input
                            type="text"
                            :id="`PedidoClientecpf_cnpj`"
                            class="form-control"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            v-model="this.pedido.PedidoCliente.cpf_cnpj"
                            :class="[
                              getErrorByID(`PedidoClientecpf_cnpj`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="getErrorByID(`PedidoClientecpf_cnpj`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClientecpf_cnpj`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label :for="`PedidoClienterg_ie`" class="form-label"
                            >RG / IE</label
                          >
                          <input
                            type="text"
                            :id="`PedidoClienterg_ie`"
                            class="form-control"
                            v-model="this.pedido.PedidoCliente.rg_ie"
                            :class="[
                              getErrorByID(`PedidoClienterg_ie`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="getErrorByID(`PedidoClienterg_ie`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClienterg_ie`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-5 col-lg-5 col-xl-12 col-xxl-5 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientetelefone`"
                            class="form-label"
                            >Telefone</label
                          >
                          <div class="input-group">
                            <button
                              @click="exibirTelefones()"
                              class="input-group-text"
                              id="basic-addon3"
                            >
                              <i class="bi bi-telephone fs-3"></i>
                            </button>
                            <input
                              type="text"
                              :id="`PedidoClientetelefone`"
                              class="form-control"
                              :class="[
                                getErrorByID(`PedidoClientetelefone`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              v-mask="['(##) ####-####', '(##) #####-####']"
                              v-model="this.pedido.PedidoCliente.telefone"
                              readonly
                            />
                          </div>
                          <div
                            v-if="getErrorByID(`PedidoClientetelefone`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClientetelefone`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-7 col-lg-7 col-xl-12 col-xxl-7 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label :for="`PedidoClienteemail`" class="form-label"
                            >Email</label
                          >
                          <div class="input-group">
                            <button
                              @click="exibirEmails()"
                              class="input-group-text"
                              id="basic-addon3"
                            >
                              <i class="bi bi-at fs-3"></i>
                            </button>
                            <input
                              type="text"
                              :id="`PedidoClienteemail`"
                              class="form-control"
                              :class="[
                                getErrorByID(`PedidoClienteemail`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              v-model="this.pedido.PedidoCliente.email"
                              readonly
                            />
                          </div>
                          <div
                            v-if="getErrorByID(`PedidoClienteemail`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClienteemail`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-4 col-lg-4 col-xl-12 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecocep`"
                            class="form-label fw-bold fs-6"
                            >CEP</label
                          >
                          <div class="input-group">
                            <input
                              :id="`PedidoClientePedidoEnderecocep`"
                              type="text"
                              @keydown.stop.prevent.enter="pesquisarCep(0)"
                              class="form-control"
                              v-mask="'#####-###'"
                              v-model="
                                this.pedido.PedidoCliente.PedidoEndereco.cep
                              "
                              :class="[
                                getErrorByID(`PedidoClientePedidoEnderecocep`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              readonly
                            />
                          </div>
                          <div
                            v-if="
                              getErrorByID(`PedidoClientePedidoEnderecocep`)
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClientePedidoEnderecocep`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-8 col-lg-8 col-xl-12 col-xxl-8 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecoendereco`"
                            class="form-label fw-bold fs-6"
                            >Endereço</label
                          >
                          <div class="input-group">
                            <button
                              @click="exibirEnderecos(0)"
                              class="input-group-text"
                              id="basic-addon3"
                            >
                              <i class="bi bi-postcard fs-3"></i>
                            </button>
                            <input
                              :id="`PedidoClientePedidoEnderecoendereco`"
                              type="text"
                              class="form-control"
                              v-model="
                                this.pedido.PedidoCliente.PedidoEndereco
                                  .endereco
                              "
                              :class="[
                                getErrorByID(
                                  `PedidoClientePedidoEnderecoendereco`
                                )
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              readonly
                            />
                          </div>
                          <div
                            v-if="
                              getErrorByID(
                                `PedidoClientePedidoEnderecoendereco`
                              )
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(
                                `PedidoClientePedidoEnderecoendereco`
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-4 col-md-2 col-lg-4 col-xl-4 col-xxl-2 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEndereconumero`"
                            class="form-label fw-bold fs-6"
                            >Número</label
                          >
                          <input
                            :id="`PedidoClientePedidoEndereconumero`"
                            type="text"
                            class="form-control"
                            v-model="
                              this.pedido.PedidoCliente.PedidoEndereco.numero
                            "
                            :class="[
                              getErrorByID(`PedidoClientePedidoEndereconumero`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="
                              getErrorByID(`PedidoClientePedidoEndereconumero`)
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(`PedidoClientePedidoEndereconumero`)
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-8 col-md-6 col-lg-8 col-xl-8 col-xxl-6 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecobairro`"
                            class="form-label fw-bold fs-6"
                            >Bairro</label
                          >
                          <input
                            :id="`PedidoClientePedidoEnderecobairro`"
                            type="text"
                            class="form-control"
                            v-model="
                              this.pedido.PedidoCliente.PedidoEndereco.bairro
                            "
                            :class="[
                              getErrorByID(`PedidoClientePedidoEnderecobairro`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="
                              getErrorByID(`PedidoClientePedidoEnderecobairro`)
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(`PedidoClientePedidoEnderecobairro`)
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-9 col-md-4 col-lg-9 col-xl-9 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecocomplemento`"
                            class="form-label fw-bold fs-6"
                            >Complemento</label
                          >
                          <input
                            :id="`PedidoClientePedidoEnderecocomplemento`"
                            type="text"
                            class="form-control"
                            v-model="
                              this.pedido.PedidoCliente.PedidoEndereco
                                .complemento
                            "
                            :class="[
                              getErrorByID(
                                `PedidoClientePedidoEnderecocomplemento`
                              )
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="
                              getErrorByID(
                                `PedidoClientePedidoEnderecocomplemento`
                              )
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(
                                `PedidoClientePedidoEnderecocomplemento`
                              )
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-3 col-md-2 col-lg-3 col-xl-3 col-xxl-2 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecouf`"
                            class="form-label required fw-bold fs-6"
                            >UF</label
                          >
                          <input
                            :id="`PedidoClientePedidoEnderecouf`"
                            type="text"
                            class="form-control"
                            :value="
                              this.pedido.PedidoCliente.PedidoEndereco.uf
                                ? this.pedido.PedidoCliente.PedidoEndereco.uf.toUpperCase()
                                : ''
                            "
                            @input="
                              this.pedido.PedidoCliente.PedidoEndereco.uf =
                                $event.target.value.toUpperCase()
                            "
                            :class="[
                              getErrorByID(`PedidoClientePedidoEnderecouf`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            readonly
                          />
                          <div
                            v-if="getErrorByID(`PedidoClientePedidoEnderecouf`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoClientePedidoEnderecouf`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-7 col-md-5 col-lg-7 col-xl-7 col-xxl-5 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecocidade`"
                            class="form-label fw-bold fs-6"
                            >Cidade</label
                          >
                          <div class="input-group">
                            <input
                              :id="`PedidoClientePedidoEnderecocidade`"
                              type="text"
                              class="form-control"
                              :class="[
                                getErrorByID(
                                  `PedidoClientePedidoEnderecocidade`
                                )
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              :value="
                                this.pedido.PedidoCliente.PedidoEndereco.cidade
                                  ? this.pedido.PedidoCliente.PedidoEndereco.cidade.toUpperCase()
                                  : ''
                              "
                              @input="
                                this.pedido.PedidoCliente.PedidoEndereco.cidade =
                                  $event.target.value.toUpperCase()
                              "
                              readonly
                            />
                          </div>
                          <div
                            v-if="
                              getErrorByID(`PedidoClientePedidoEnderecocidade`)
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(`PedidoClientePedidoEnderecocidade`)
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-5 col-md-4 col-lg-5 col-xl-5 col-xxl-4 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecopais`"
                            class="form-label fw-bold fs-6"
                            >País</label
                          >
                          <div class="input-group">
                            <input
                              :id="`PedidoClientePedidoEnderecopais`"
                              type="text"
                              class="form-control"
                              :class="[
                                getErrorByID(`PedidoClientePedidoEnderecopais`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              :value="
                                this.pedido.PedidoCliente.PedidoEndereco.pais
                                  ? this.pedido.PedidoCliente.PedidoEndereco.pais.toUpperCase()
                                  : ''
                              "
                              @input="
                                this.pedido.PedidoCliente.PedidoEndereco.pais =
                                  $event.target.value.toUpperCase()
                              "
                              readonly
                            />
                          </div>
                          <div
                            v-if="
                              getErrorByID(`PedidoClientePedidoEnderecopais`)
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(`PedidoClientePedidoEnderecopais`)
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title" ref="pedido_endereco_entrega">
                      <h2>Endereços</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                      >
                        <div class="mb-6 fv-row">
                          <label
                            :for="`PedidoClientePedidoEnderecoEntregaendereco`"
                            class="form-label"
                            >Endereço de entrega</label
                          >
                          <div class="input-group mb-2">
                            <input
                              :id="`PedidoClientePedidoEnderecoEntregaendereco`"
                              type="text"
                              class="form-control"
                              :class="[
                                getErrorByID(
                                  `PedidoClientePedidoEnderecoEntregaendereco`
                                )
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              :value="
                                this.pedido.PedidoCliente &&
                                this.pedido.PedidoCliente
                                  .PedidoEnderecoEntrega &&
                                this.pedido.PedidoCliente.PedidoEnderecoEntrega
                                  .id_cliente_endereco > 0
                                  ? this.pedido.PedidoCliente
                                      .PedidoEnderecoEntrega.descricao
                                  : ''
                              "
                              readonly
                            />
                            <span
                              type="button"
                              class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                              @click="limparEnderecoEntregaPedido()"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr061.svg"
                              />
                            </span>
                            <button
                              type="button"
                              class="input-group-text"
                              @click="exibirEnderecos(1)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="
                              getErrorByID(
                                `PedidoClientePedidoEnderecoEntregaendereco`
                              )
                            "
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              getErrorByID(
                                `PedidoClientePedidoEnderecoEntregaendereco`
                              )
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Observações</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="mb-6 fv-row">
                      <label :for="`observacao`" class="form-label"
                        >Observações</label
                      >
                      <textarea
                        :id="`observacao`"
                        class="form-control mb-2"
                        placeholder="Observações do pedido"
                        maxlength="300"
                        style="height: 250px"
                        v-model="pedido.observacao"
                        :class="[
                          getErrorByID(`observacao`) ? 'is-invalid' : '',
                        ]"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            v-if="getErrorByID(`observacao`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`observacao`) }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              pedido.observacao
                                ? pedido.observacao.length
                                : "0"
                            }}/300 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-7 gap-lg-10 mb-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Transportadora</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7 align-self-end"
                      >
                        <div class="mb-8 fv-row">
                          <label :for="`id_transportadora`" class="form-label"
                            >Transportadora / Entregador</label
                          >
                          <div class="input-group mb-2">
                            <input
                              type="text"
                              :id="`id_transportadora`"
                              :value="
                                this.pedido.Transportadora
                                  ? (this.pedido.Transportadora.nome = this
                                      .pedido.Transportadora.nome
                                      ? this.pedido.Transportadora.nome.toUpperCase()
                                      : '')
                                  : ''
                              "
                              @input="
                                this.pedido.Transportadora.nome =
                                  $event.target.value.toUpperCase()
                              "
                              class="form-control"
                              :class="[
                                getErrorByID(`id_transportadora`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              readonly
                            />
                            <span
                              type="button"
                              class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                              @click="limparTransportadoraPedido()"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr061.svg"
                              />
                            </span>
                            <button
                              type="button"
                              class="input-group-text"
                              @click="modalTransportadoras(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`id_transportadora`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`id_transportadora`) }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5 mb-7"
                      >
                        <label :for="`frete`" class="form-label">Frete</label>
                        <select
                          :id="`frete`"
                          class="form-select"
                          :class="[getErrorByID(`frete`) ? 'is-invalid' : '']"
                          v-model="this.pedido.frete"
                        >
                          <option value="0">Emitente</option>
                          <option value="1">Destinatário</option>
                          <option value="2">Terceiros</option>
                          <option value="9">Sem Frete</option>
                        </select>
                        <div
                          v-if="getErrorByID(`frete`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`frete`) }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7 align-self-end"
                      >
                        <div class="mb-8 fv-row">
                          <label :for="`id_motorista`" class="form-label"
                            >Motorista</label
                          >
                          <div class="input-group mb-2">
                            <input
                              type="text"
                              :id="`id_motorista`"
                              :value="
                                this.pedido.Motorista
                                  ? (this.pedido.Motorista.nome = this.pedido
                                      .Motorista.nome
                                      ? this.pedido.Motorista.nome.toUpperCase()
                                      : '')
                                  : ''
                              "
                              @input="
                                this.pedido.Motorista.nome =
                                  $event.target.value.toUpperCase()
                              "
                              class="form-control"
                              :class="[
                                getErrorByID(`id_motorista`)
                                  ? 'is-invalid'
                                  : '',
                              ]"
                              readonly
                            />
                            <span
                              type="button"
                              class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                              @click="limparMotoristaPedido()"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr061.svg"
                              />
                            </span>
                            <button
                              type="button"
                              class="input-group-text"
                              @click="modalMotoristas(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`id_motorista`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`id_motorista`) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Vendedor</h2>
                    </div>
                  </div>
                  <div class="card-body pt-0 pb-0">
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-6"
                      >
                        <div class="mb-8 fv-row">
                          <label :for="`id_vendedor`" class="form-label"
                            >Vendedor</label
                          >
                          <div class="input-group mb-2">
                            <input
                              type="text"
                              :id="`id_vendedor`"
                              :value="
                                this.pedido.Vendedor
                                  ? (this.pedido.Vendedor.nome = this.pedido
                                      .Vendedor.nome
                                      ? this.pedido.Vendedor.nome.toUpperCase()
                                      : '')
                                  : ''
                              "
                              @input="
                                this.pedido.Vendedor.nome =
                                  $event.target.value.toUpperCase()
                              "
                              class="form-control"
                              :class="[
                                getErrorByID(`id_vendedor`) ? 'is-invalid' : '',
                              ]"
                              readonly
                            />
                            <span
                              type="button"
                              class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                              @click="limparVendedorPedido()"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr061.svg"
                              />
                            </span>
                            <button
                              type="button"
                              class="input-group-text"
                              @click="modalVendedores(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            v-if="getErrorByID(`id_vendedor`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`id_vendedor`) }}
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-6 col-xxl-3 fv-row mb-4">
                        <label :for="`comissao_per`" class="form-label"
                          >Comissão %</label
                        >
                        <CurrencyInput
                          :id="`comissao_per`"
                          class="form-control mb-2 text-primary"
                          placeholder="Comissão %"
                          style="text-align: right"
                          v-model="this.pedido.comissao_per"
                          :class="[
                            getErrorByID(`comissao_per`) ? 'is-invalid' : '',
                          ]"
                          :options="options"
                          @change="recalcularValores()"
                        ></CurrencyInput>
                        <div
                          v-if="getErrorByID(`comissao_per`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`comissao_per`) }}
                        </div>
                      </div>
                      <div class="col-lg-6 col-xl-6 col-xxl-3 fv-row mb-4">
                        <label :for="`comissao_valor`" class="form-label"
                          >Comissão R$</label
                        >
                        <CurrencyInput
                          :id="`comissao_valor`"
                          class="form-control mb-2 text-danger"
                          placeholder="Comissão R$"
                          style="text-align: right"
                          v-model="this.pedido.comissao_valor"
                          :class="[
                            getErrorByID(`comissao_valor`) ? 'is-invalid' : '',
                          ]"
                          :options="options"
                          @keydown.stop.prevent.enter="
                            calculaPercentualComissao()
                          "
                        ></CurrencyInput>
                        <div
                          v-if="getErrorByID(`comissao_valor`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`comissao_valor`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade tab-pane-pedido"
              id="kt_pedido_produto"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Produtos</h2>
                    </div>
                  </div>
                  <div class="card-body pt-4 pb-6">
                    <div class="row">
                      <div class="col-xl-7 col-xxl-5 col-lg-12 fv-row mb-6">
                        <div class="input-group h-45px">
                          <input
                            autocomplete="off"
                            type="search"
                            :id="`InclusaoRapida`"
                            :class="[
                              getErrorByID(`InclusaoRapida`)
                                ? 'is-invalid'
                                : '',
                            ]"
                            v-model="pesquisaProduto"
                            @keydown.stop.prevent.enter="
                              inclusaoRapidaProduto()
                            "
                            class="form-control"
                            placeholder="Informe o código do produto"
                          />
                          <button
                            type="button"
                            class="input-group-text py-0 px-2"
                            @click="inclusaoRapidaProduto()"
                          >
                            <span
                              class="svg-icon svg-icon-primary svg-icon-2hx"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr087.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          v-if="getErrorByID(`InclusaoRapida`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`InclusaoRapida`) }}
                        </div>
                      </div>
                      <div class="col-xl-3 col-xxl-3 col-lg-4 fv-row mb-6">
                        <div class="form-check form-check-custom form-check-sm">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="rbPesquisaRapida"
                            id="rbCodigo"
                            checked
                          />
                          <label class="form-check-label" for="rbCodigo">
                            <h6>Código</h6>
                          </label>
                        </div>
                        <div class="form-check form-check-custom form-check-sm">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="rbPesquisaRapida"
                            id="rbBarras"
                          />
                          <label class="form-check-label" for="rbBarras">
                            <h6>Barras</h6>
                          </label>
                        </div>
                      </div>
                      <div
                        class="col-xxl-4 col-xl-12 col-lg-8 fv-row mb-6 d-flex justify-content-lg-end justify-content-xl-end"
                      >
                        <button
                          @click="modalProdutos(true)"
                          type="button"
                          class="btn btn-primary min-w-175px h-45px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/ecommerce/ecm009.svg"
                            />
                            Pesquisar
                          </span>
                        </button>
                      </div>
                    </div>
                    <Datatable
                      :table-header="this.tableProdutoHeader"
                      :table-data="this.pedido.PedidoItem"
                      :rowsPerPage="1000"
                      :emptyTableText="'Nenhum produto adicionado'"
                      :enableItemsPerPageDropdown="false"
                      :loading="this.loadingProduto"
                    >
                      <template v-slot:cell-item="{ position: index }">
                        <div
                          :id="`PedidoItem[${index}]item`"
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]item`)
                              ? 'min-w-100px'
                              : '',
                          ]"
                          class="text-center"
                        >
                          {{ (this.pedido.PedidoItem[index].item = index + 1) }}
                        </div>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]item`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]item`) }}
                        </div>
                      </template>
                      <template v-slot:cell-id_produto="{ position: index }">
                        <div
                          :id="`PedidoItem[${index}]id_produto`"
                          v-if="
                            this.pedido.PedidoItem[index].em_branco === false ||
                            this.pedido.PedidoItem[index].em_branco ===
                              undefined
                          "
                          class="text-center"
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]id_produto`)
                              ? 'min-w-100px'
                              : '',
                          ]"
                        >
                          {{ this.pedido.PedidoItem[index].id_produto }}
                        </div>
                        <div
                          v-else
                          class="input-group"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]id_produto`)
                              ? 'min-w-200px'
                              : 'min-w-150px',
                          ]"
                        >
                          <input
                            :id="`PedidoItem[${index}]id_produto`"
                            placeholder="Código"
                            class="form-control autosized-input text-hover input-focus"
                            v-model="this.pedido.PedidoItem[index].id_produto"
                            @keydown.stop.prevent.enter="
                              adicionarProdutoCodigoGrid(index)
                            "
                            autocomplete="off"
                            type="search"
                            :class="[
                              getErrorByID(`PedidoItem[${index}]id_produto`)
                                ? 'is-invalid'
                                : '',
                            ]"
                          />
                          <button
                            type="button"
                            class="input-group-text"
                            @click="modalProdutos(true)"
                            data-bs-toggle="tooltip"
                            data-bs-dismiss="click"
                            title="(CTRL + S) (CMD + S) (F3) Pesquisar produtos"
                            tooltip="(CTRL + S) (CMD + S) (F3) Pesquisar produtos"
                          >
                            <span class="svg-icon svg-icon-2">
                              <inline-svg
                                src="media/icons/duotune/general/gen004.svg"
                              />
                            </span>
                          </button>
                        </div>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]id_produto`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]id_produto`) }}
                        </div>
                      </template>
                      <template v-slot:cell-imagem="{ row: pedidoItem }">
                        <div
                          v-if="
                            pedidoItem.Produto && pedidoItem.Produto.imagem
                              ? pedidoItem.Produto.imagem
                              : ''
                          "
                          class="symbol symbol-50px"
                        >
                          <div
                            class="symbol-label fs-2 fw-bold bg-light-dark"
                            :style="{
                              'background-image': `url(${
                                this.$utils.getUrl() + pedidoItem.Produto.imagem
                              })`,
                            }"
                          ></div>
                        </div>
                        <div v-else class="symbol symbol-50px">
                          <div
                            :class="[
                              'symbol-label fs-2 fw-bold ' + pedidoItem.color,
                            ]"
                          >
                            {{
                              pedidoItem.nome
                                ? pedidoItem.nome.substring(0, 1).toUpperCase()
                                : ""
                            }}
                          </div>
                        </div>
                      </template>
                      <template
                        v-slot:cell-nome="{ row: pedidoItem, position: index }"
                      >
                        <div class="min-w-200px align-middle">
                          <FocusTextInput
                            :id="`PedidoItem[${index}]nome`"
                            class="min-w-200px"
                            placeholder="Descrição do produto"
                            v-model="this.pedido.PedidoItem[index].nome"
                            @keydown.stop.prevent.enter="
                              nextFocus(`PedidoItem[${index}]und`)
                            "
                            :hasError="
                              getErrorByID(`PedidoItem[${index}]nome`)
                                ? true
                                : false
                            "
                          ></FocusTextInput>
                          <div
                            v-if="pedidoItem.observacao"
                            class="ps-4 text-quebrar-linha fs-7"
                          >
                            {{ pedidoItem.observacao }}
                          </div>
                          <div
                            v-if="getErrorByID(`PedidoItem[${index}]nome`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoItem[${index}]nome`) }}
                          </div>
                        </div>
                      </template>
                      <template v-slot:cell-und="{ position: index }">
                        <FocusTextInput
                          :id="`PedidoItem[${index}]und`"
                          placeholder="UND"
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]und`)
                              ? true
                              : false
                          "
                          :class="[
                            getErrorByID(`PedidoItem[${index}]und`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          v-model="this.pedido.PedidoItem[index].und"
                          :maxlength="3"
                          :upper="true"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="
                            nextFocus(`PedidoItem[${index}]qtd`)
                          "
                        ></FocusTextInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]und`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]und`) }}
                        </div>
                      </template>
                      <template v-slot:cell-qtd="{ position: index }">
                        <FocusCurrencyInput
                          :id="`PedidoItem[${index}]qtd`"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]qtd`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]qtd`)
                              ? true
                              : false
                          "
                          placeholder="QTD"
                          v-model="this.pedido.PedidoItem[index].qtd"
                          :options="options"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="
                            nextFocus(`PedidoItem[${index}]preco`)
                          "
                          @change="recalcularValores()"
                        ></FocusCurrencyInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]qtd`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]qtd`) }}
                        </div>
                      </template>
                      <template v-slot:cell-preco="{ position: index }">
                        <FocusCurrencyInput
                          :id="`PedidoItem[${index}]preco`"
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]preco`)
                              ? true
                              : false
                          "
                          :class="[
                            getErrorByID(`PedidoItem[${index}]preco`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          placeholder="Preço"
                          v-model="this.pedido.PedidoItem[index].preco"
                          :options="options"
                          style="text-align: right"
                          @keydown.stop.prevent.enter="
                            nextFocus(`PedidoItem[${index}]ipi`)
                          "
                          @change="recalcularValores()"
                        ></FocusCurrencyInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]preco`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]preco`) }}
                        </div>
                      </template>
                      <template
                        v-slot:cell-total_sub_itens="{
                          row: pedidoItem,
                          position: index,
                        }"
                      >
                        <div
                          :id="`PedidoItem[${index}]total_sub_itens`"
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]total_sub_itens`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          class="text-end"
                        >
                          {{
                            this.$utils.formatarNumero(
                              pedidoItem.total_sub_itens
                            )
                          }}
                        </div>
                        <div
                          v-if="
                            getErrorByID(`PedidoItem[${index}]total_sub_itens`)
                          "
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            getErrorByID(`PedidoItem[${index}]total_sub_itens`)
                          }}
                        </div>
                      </template>
                      <template
                        v-slot:cell-total="{ row: pedidoItem, position: index }"
                      >
                        <div
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]total`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          :id="`PedidoItem[${index}]total`"
                          class="text-end"
                        >
                          {{ this.$utils.formatarNumero(pedidoItem.total) }}
                        </div>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]total`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]total`) }}
                        </div>
                      </template>
                      <template v-slot:cell-tipo_prod="{ position: index }">
                        <div
                          :class="[
                            getErrorByID(`PedidoItem[${index}]tipo_prod`)
                              ? 'min-w-225px'
                              : 'min-w-175px',
                          ]"
                        >
                          <select
                            :id="`PedidoItem[${index}]tipo_prod`"
                            class="form-select"
                            v-model="this.pedido.PedidoItem[index].tipo_prod"
                            :class="[
                              getErrorByID(`PedidoItem[${index}]tipo_prod`)
                                ? 'is-invalid'
                                : '',
                            ]"
                          >
                            <option
                              v-for="tipo in tiposProduto"
                              v-bind:key="tipo.descricao"
                              v-bind:value="tipo.descricao"
                            >
                              {{ tipo.descricao }}
                            </option>
                          </select>
                          <div
                            v-if="getErrorByID(`PedidoItem[${index}]tipo_prod`)"
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ getErrorByID(`PedidoItem[${index}]tipo_prod`) }}
                          </div>
                        </div>
                      </template>
                      <template v-slot:cell-ipi="{ position: index }">
                        <FocusCurrencyInput
                          :id="`PedidoItem[${index}]ipi`"
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]ipi`)
                              ? true
                              : false
                          "
                          :class="[
                            getErrorByID(`PedidoItem[${index}]ipi`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          placeholder="IPI"
                          v-model="this.pedido.PedidoItem[index].ipi"
                          :options="options"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="
                            this.user.User.Emitente.crt != 1
                              ? nextFocus(`PedidoItem[${index}]st`)
                              : nextFocus(`PedidoItem[${index}]csosn`)
                          "
                          @change="recalcularValores()"
                        ></FocusCurrencyInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]ipi`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]ipi`) }}
                        </div>
                      </template>
                      <template
                        v-slot:cell-desconto="{
                          row: pedidoItem,
                          position: index,
                        }"
                      >
                        <div
                          :id="`PedidoItem[${index}]desconto`"
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]desconto`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          class="text-end"
                        >
                          {{ this.$utils.formatarNumero(pedidoItem.desconto) }}
                        </div>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]desconto`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]desconto`) }}
                        </div>
                      </template>
                      <template
                        v-slot:cell-acrescimo="{
                          row: pedidoItem,
                          position: index,
                        }"
                      >
                        <div
                          :id="`PedidoItem[${index}]acrescimo`"
                          tabindex="0"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]acrescimo`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          class="text-end"
                        >
                          {{ this.$utils.formatarNumero(pedidoItem.acrescimo) }}
                        </div>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]acrescimo`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]acrescimo`) }}
                        </div>
                      </template>
                      <template v-slot:cell-cst="{ position: index }">
                        <FocusTextInput
                          :id="`PedidoItem[${index}]st`"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]st`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          placeholder="CST"
                          v-model="this.pedido.PedidoItem[index].st"
                          :maxlength="3"
                          :upper="true"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="
                            verificarCST(`PedidoItem[${index}]st`, index, false)
                          "
                          @change="
                            recalcularValores();
                            verificarCST(
                              `PedidoItem[${index}]st`,
                              index,
                              false
                            );
                          "
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]st`)
                              ? true
                              : false
                          "
                        ></FocusTextInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]st`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]st`) }}
                        </div>
                      </template>
                      <template v-slot:cell-csosn="{ position: index }">
                        <FocusTextInput
                          :id="`PedidoItem[${index}]csosn`"
                          :class="[
                            getErrorByID(`PedidoItem[${index}]csosn`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          placeholder="CSOSN"
                          v-model="this.pedido.PedidoItem[index].csosn"
                          :maxlength="4"
                          :upper="true"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="
                            verificarCSOSN(
                              `PedidoItem[${index}]csosn`,
                              index,
                              false
                            )
                          "
                          @change="
                            recalcularValores();
                            verificarCSOSN(
                              `PedidoItem[${index}]csosn`,
                              index,
                              false
                            );
                          "
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]csosn`)
                              ? true
                              : false
                          "
                        ></FocusTextInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]csosn`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]csosn`) }}
                        </div>
                      </template>
                      <template v-slot:cell-icms="{ position: index }">
                        <FocusCurrencyInput
                          :id="`PedidoItem[${index}]icms`"
                          :hasError="
                            getErrorByID(`PedidoItem[${index}]icms`)
                              ? true
                              : false
                          "
                          :class="[
                            getErrorByID(`PedidoItem[${index}]icms`)
                              ? 'min-w-100px'
                              : 'min-w-60px',
                          ]"
                          placeholder="ICMS"
                          v-model="this.pedido.PedidoItem[index].icms"
                          :options="options"
                          style="text-align: center"
                          @keydown.stop.prevent.enter="adicionarProdutoPedido()"
                          @change="recalcularValores()"
                        ></FocusCurrencyInput>
                        <div
                          v-if="getErrorByID(`PedidoItem[${index}]icms`)"
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ getErrorByID(`PedidoItem[${index}]icms`) }}
                        </div>
                      </template>
                      <template
                        v-slot:cell-acoes="{ row: pedidoItem, position: index }"
                      >
                        <div>
                          <button
                            class="btn btn-sm btn-light btn-active-light-primary"
                            data-kt-menu-trigger="click"
                            data-kt-menu-placement="bottom-end"
                            data-kt-menu-flip="top-end"
                            tabindex="-1"
                          >
                            Ações
                            <span class="svg-icon svg-icon-5 m-0">
                              <inline-svg
                                src="media/icons/duotune/arrows/arr072.svg"
                              />
                            </span>
                          </button>
                          <div
                            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-150px py-4"
                            data-kt-menu="true"
                          >
                            <div class="menu-item px-3">
                              <a
                                @click="editarPedidoVendedorProduto(index)"
                                class="menu-link px-3"
                                >Vendedor</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarPedidoCompraProduto(index)"
                                class="menu-link px-3"
                                >P. Compra</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarEstoque(index)"
                                class="menu-link px-3"
                                >Estoque</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                v-if="pedidoItem.Produto.Adicional"
                                @click="editarAdicional(index)"
                                class="menu-link px-3"
                                >Adicionais</a
                              >
                              <a
                                v-else
                                @click="editarObservacoesProduto(index)"
                                class="menu-link px-3"
                                >Observações</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarPedidoPesoProduto(index)"
                                class="menu-link px-3"
                                >Peso</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarDetalhesProduto(index)"
                                class="menu-link px-3"
                                >Detalhes</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarTotalProduto(index)"
                                class="menu-link px-3"
                                >Desconto</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="editarPedidoTabelaEstadosProduto(index)"
                                class="menu-link px-3"
                                >Tabela Estados</a
                              >
                            </div>
                            <div class="menu-item px-3">
                              <a
                                @click="removerProduto(pedidoItem.id, index)"
                                class="menu-link px-3"
                                >Excluír</a
                              >
                            </div>
                          </div>
                        </div>
                      </template>
                    </Datatable>
                    <div class="fs-6 mt-4">
                      <b class="">{{ "Qtd Itens: " }}</b>
                      <b class="text-primary">{{
                        this.pedido.PedidoItem.length
                      }}</b>
                      <b class="ms-4">{{ "Qtd Produtos: " }}</b>
                      <b class="text-primary">{{ this.somaQtdProdutos() }}</b>
                    </div>
                  </div>
                  <div class="card-footer d-flex justify-content-end">
                    <div class="row">
                      <div class="col-auto">
                        <button
                          data-bs-placement="top"
                          title="(F10) Recalcula outras opções de valores cadastradas no produto.  Ex.:
Preço a vista
Preço Revenda;
Preço Distribuidora;"
                          @click="this.modalPedidoRecalcularValores(true)"
                          type="button"
                          class="btn btn-active-light svg-icon-white mb-2"
                        >
                          Recalcular Valores
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="(F11) Esta função permite acrescentar ou deduzir um determinado valor do (preço de venda)
de todos os itens ao mesmo tempo. Ex.: se informar 1 real e for deduzir irá subtrair este valor 
de todos os itens. Este processo remove desconto ou acréscimos anteriores."
                          @click="modalAlterarPrecoVenda(true)"
                          type="button"
                          class="btn btn-active-light svg-icon-white mb-2"
                        >
                          Alterar preço de venda
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          v-if="this.consultarTipoProduto"
                          @click="modalTiposProduto(true)"
                          type="button"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/general/gen022.svg"
                            />
                            Tipo Prod.
                          </span>
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          @click="recalcularItensPedido()"
                          type="button"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/finance/fin007.svg"
                            />
                            Recalcular
                          </span>
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          @click="adicionarProdutoPedido()"
                          type="button"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                          data-bs-toggle="tooltip"
                          data-bs-dismiss="click"
                          title="(CTRL + A) (CMD + A) (F5) Adicionar produto"
                          tooltip="(CTRL + A) (CMD + A) (F5) Adicionar produto"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/general/gen041.svg"
                            />
                            Adicionar
                          </span>
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          @click="pedidoAdicionarExcluirProduto(0)"
                          type="button"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="(+) Incluír / (-) Excluír"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/ecommerce/ecm002.svg"
                            />
                            Incluír / Excluír
                          </span>
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          @click="this.modalKits(true)"
                          type="button"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/art/art002.svg"
                            />
                            Adicionar Kits
                          </span>
                        </button>
                      </div>
                      <div class="col-auto">
                        <button
                          @click="adicionarPedidoBrinde()"
                          type="button"
                          class="btn btn-light svg-icon-white mb-2 min-w-150px"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/ecommerce/ecm007.svg"
                            />
                            Brindes
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade tab-pane-pedido"
              id="kt_pedido_pagamento"
              role="tab-panel"
            >
              <div class="d-flex flex-column gap-7 gap-lg-10">
                <div class="card card-flush py-4">
                  <div class="card-header">
                    <div class="card-title">
                      <h2>Duplicatas</h2>
                    </div>
                    <div class="card-toolbar">
                      <div
                        class="d-flex justify-content-end"
                        data-kt-customer-table-toolbar="base"
                      >
                        <button
                          v-if="exibirPagamento"
                          @click="adicionarPedidoPagamento()"
                          type="button"
                          class="btn btn-sm btn-light-primary"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/finance/fin008.svg" /></span
                          >Adicionar Pagamento
                        </button>
                        <button
                          v-if="exibirPedidoReceberModal"
                          @click="adicionarPedidoReceber()"
                          type="button"
                          class="btn btn-sm btn-light-info ms-2"
                        >
                          <span class="svg-icon svg-icon-1">
                            <inline-svg
                              src="media/icons/duotune/finance/fin005.svg" /></span
                          >Parcelamento
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-4 pb-6">
                    <PedidoReceberModal
                      v-if="
                        exibirPedidoReceberModal === false
                          ? true
                          : exibirPedidoReceber
                      "
                      :pedido="this.pedido"
                      :errosValidacao="this.errosValidacao"
                      :errosValidacaoGeral="this.errosValidacaoGeral"
                      :modal="exibirPedidoReceberModal"
                      @exibirModalPedidoReceber="modalPedidoReceber"
                      @confirmarParcelamento="confirmarParcelamento"
                    >
                    </PedidoReceberModal>
                    <div v-if="exibirPagamento" class="table-responsive">
                      <table
                        :class="[loadingPagamento && 'overlay overlay-block']"
                        class="table align-middle table-row-dashed fs-6 gy-5 gs-7 text-gray-600 fw-bold dataTable no-footer table-hover"
                        id="kt_table_pagamentos"
                      >
                        <tbody>
                          <template
                            v-if="this.pedido.PedidoPagamento.length > 0"
                          >
                            <template
                              v-for="(pagamento, i) in this.pedido
                                .PedidoPagamento"
                              :key="i"
                            >
                              <tr>
                                <td class="align-middle">
                                  <div>
                                    <span class="svg-icon svg-icon-2qx"
                                      ><inline-svg
                                        :src="
                                          getEspeciePagamento(
                                            pagamento.cod_especie
                                          )
                                        "
                                    /></span>
                                  </div>
                                </td>
                                <td class="ps-0">
                                  <div class="min-w-150px align-middle">
                                    <div>
                                      <span
                                        class="text-dark text-hover-primary mb-1"
                                      >
                                        {{ pagamento.descricao }}
                                      </span>
                                      <span class="text-muted fw-bold d-block">
                                        {{ pagamento.emissor }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td class="min-w-125px text-success">
                                  R$
                                  {{
                                    this.$utils.formatarNumero(
                                      pagamento.valor_recebido
                                    )
                                  }}
                                </td>
                                <td>
                                  <div>
                                    <div>
                                      <span
                                        v-if="pagamento.tipo"
                                        class="badge badge-light-dark d-block mb-2"
                                        >{{ pagamento.tipo }}</span
                                      >
                                      <span
                                        v-if="pagamento.pendente === '0'"
                                        class="badge badge-light-success d-block"
                                        >Aprovado</span
                                      >
                                      <span
                                        v-else
                                        class="badge badge-light-danger d-block"
                                        >Pendente</span
                                      >
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  {{
                                    this.$utils.formatarDataHora(
                                      pagamento.createdAt
                                    )
                                  }}
                                </td>
                                <td>
                                  <div class="min-w-85px align-middle">
                                    <div>
                                      <span
                                        class="text-dark text-hover-primary mb-1"
                                      >
                                        Troco para
                                      </span>
                                      <span
                                        class="text-primary fw-bold d-block"
                                      >
                                        R$
                                        {{
                                          this.$utils.formatarNumero(
                                            pagamento.troco_entrega
                                          )
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </td>
                                <td class="min-w-125px pe-5 text-end">
                                  <button
                                    class="btn btn-sm btn-light btn-active-light-primary"
                                    data-kt-menu-trigger="click"
                                    data-kt-menu-placement="bottom-end"
                                    data-kt-menu-flip="top-end"
                                  >
                                    Ações
                                    <span class="svg-icon svg-icon-5 m-0">
                                      <inline-svg
                                        src="media/icons/duotune/arrows/arr072.svg"
                                      />
                                    </span>
                                  </button>
                                  <div
                                    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
                                    data-kt-menu="true"
                                  >
                                    <div class="menu-item px-3">
                                      <a
                                        @click="editarPedidoPagamento(i)"
                                        class="menu-link px-3"
                                        >Editar</a
                                      >
                                    </div>
                                    <div class="menu-item px-3">
                                      <a
                                        @click="
                                          removerPagamento(pagamento.id, i)
                                        "
                                        class="menu-link px-3"
                                        >Excluír</a
                                      >
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </template>
                          <template v-else>
                            <tr class="odd">
                              <td :colSpan="12" class="dataTables_empty">
                                {{
                                  "Nenhuma forma de pagamento foi adicionada"
                                }}
                              </td>
                            </tr>
                          </template>
                        </tbody>
                        <div
                          v-if="loadingPagamento"
                          class="overlay-layer card-rounded bg-dark bg-opacity-5"
                        >
                          <div
                            class="spinner-border text-primary"
                            role="status"
                          ></div>
                          <span class="ms-2">Aguarde, carregando...</span>
                        </div>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-column flex-lg-row-auto w-100 w-xl-350px ms-xl-10">
          <div class="card card-flush py-4 mb-10">
            <div class="card-header">
              <div class="card-title">
                <h2>Totalizadores</h2>
              </div>
            </div>
            <div class="card-body pt-0">
              <label class="form-label">Total do Pedido</label>
              <div class="input-group mb-2">
                <button
                  type="button"
                  class="btn btn-warning py-0 ps-4 pe-2"
                  @click="editarTotalPedido()"
                >
                  <span class="svg-icon svg-icon-1">
                    <inline-svg src="media/icons/duotune/finance/fin010.svg" />
                  </span>
                </button>
                <CurrencyInput
                  :id="`total`"
                  class="form-control form-control-solid text-danger"
                  :class="[getErrorByID(`total`) ? 'is-invalid' : '']"
                  placeholder="Total do Pedido"
                  style="text-align: right"
                  v-model="this.pedido.total"
                  :options="options"
                  readonly
                ></CurrencyInput>
                <div
                  v-if="getErrorByID(`total`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`total`) }}
                </div>
              </div>
              <label class="form-label">Total dos produtos</label>
              <CurrencyInput
                :id="`total_produtos`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`total_produtos`) ? 'is-invalid' : '']"
                placeholder="Total dos produtos"
                style="text-align: right"
                v-model="this.pedido.total_produtos"
                :options="options"
                readonly
              >
              </CurrencyInput>
              <div
                v-if="getErrorByID(`total_produtos`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_produtos`) }}
              </div>
              <label class="form-label">Descontos</label>
              <CurrencyInput
                :id="`total_descontos`"
                class="form-control form-control-solid mb-2 text-primary"
                :class="[getErrorByID(`total_descontos`) ? 'is-invalid' : '']"
                placeholder="Descontos"
                style="text-align: right"
                v-model="this.pedido.total_descontos"
                :options="options"
                readonly
              >
              </CurrencyInput>
              <div
                v-if="getErrorByID(`total_descontos`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_descontos`) }}
              </div>
              <label class="form-label">Acréscimos</label>
              <CurrencyInput
                :id="`total_acrescimo`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`total_acrescimo`) ? 'is-invalid' : '']"
                placeholder="Acréscimos"
                style="text-align: right"
                v-model="this.pedido.total_acrescimo"
                :options="options"
                readonly
              >
              </CurrencyInput>
              <div
                v-if="getErrorByID(`total_acrescimo`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_acrescimo`) }}
              </div>
              <label class="form-label">Valor do Frete</label>
              <CurrencyInput
                :id="`total_frete`"
                class="form-control mb-2"
                :class="[getErrorByID(`total_frete`) ? 'is-invalid' : '']"
                placeholder="Valor do Frete"
                style="text-align: right"
                v-model="this.pedido.total_frete"
                :options="options"
                @change="recalcularValores()"
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`total_frete`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_frete`) }}
              </div>
              <label class="form-label">Valor do Seguro</label>
              <CurrencyInput
                :id="`total_seguro`"
                class="form-control mb-2"
                :class="[getErrorByID(`total_seguro`) ? 'is-invalid' : '']"
                placeholder="Valor do Seguro"
                style="text-align: right"
                v-model="this.pedido.total_seguro"
                :options="options"
                @change="recalcularValores()"
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`total_seguro`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_seguro`) }}
              </div>
              <label class="form-label">Outras Despesas</label>
              <CurrencyInput
                :id="`total_outras`"
                class="form-control mb-2"
                :class="[getErrorByID(`total_outras`) ? 'is-invalid' : '']"
                placeholder="Outras Despesas"
                style="text-align: right"
                v-model="this.pedido.total_outras"
                :options="options"
                @change="recalcularValores()"
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`total_outras`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_outras`) }}
              </div>
              <label class="form-label">Base ICMS</label>
              <CurrencyInput
                :id="`base_icms`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`base_icms`) ? 'is-invalid' : '']"
                placeholder="Base ICMS"
                style="text-align: right"
                v-model="this.pedido.base_icms"
                :options="options"
                readonly
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`base_icms`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`base_icms`) }}
              </div>
              <label class="form-label">Valor ICMS</label>
              <CurrencyInput
                :id="`total_icms`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`total_icms`) ? 'is-invalid' : '']"
                placeholder="Valor ICMS"
                style="text-align: right"
                v-model="this.pedido.total_icms"
                :options="options"
                readonly
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`total_icms`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_icms`) }}
              </div>
              <label class="form-label">Base ICMS Substituição</label>
              <CurrencyInput
                :id="`base_icms_sub`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`base_icms_sub`) ? 'is-invalid' : '']"
                placeholder="Base ICMS Substituição"
                style="text-align: right"
                v-model="this.pedido.base_icms_sub"
                :options="options"
                readonly
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`base_icms_sub`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`base_icms_sub`) }}
              </div>
              <div class="fv-row">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">Valor ICMS Substituição</label>
                  <div class="card-toolbar">
                    <div class="form-check form-check-custom form-check-sm">
                      <input
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Somar Valor do Icms Substituição ao Total do Pedido"
                        class="form-check-input"
                        type="checkbox"
                        v-model="this.pedido.utiliza_icms_sub"
                        id="ckUtilizaIcmsSub"
                        tabindex="-1"
                        @change="this.recalcularValores()"
                      />
                    </div>
                  </div>
                </div>
                <CurrencyInput
                  :id="`total_icms_sub`"
                  class="form-control form-control-solid mb-2"
                  :class="[getErrorByID(`total_icms_sub`) ? 'is-invalid' : '']"
                  placeholder="Valor ICMS Substituição"
                  style="text-align: right"
                  v-model="this.pedido.total_icms_sub"
                  :options="options"
                  readonly
                >
                </CurrencyInput>
                <div
                  v-if="getErrorByID(`total_icms_sub`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`total_icms_sub`) }}
                </div>
              </div>
              <label class="form-label">Total do IPI</label>
              <CurrencyInput
                :id="`total_ipi`"
                class="form-control form-control-solid mb-2"
                :class="[getErrorByID(`total_ipi`) ? 'is-invalid' : '']"
                placeholder="Total do IPI"
                style="text-align: right"
                v-model="this.pedido.total_ipi"
                :options="options"
                readonly
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`total_ipi`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`total_ipi`) }}
              </div>
              <div v-if="false">
                <label class="form-label">Quantidade</label>
                <input
                  :id="`quantidade`"
                  type="text"
                  class="form-control mb-2 text-end"
                  v-model="this.pedido.quantidade"
                  :class="[getErrorByID(`quantidade`) ? 'is-invalid' : '']"
                />
                <div
                  v-if="getErrorByID(`quantidade`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`quantidade`) }}
                </div>
              </div>
              <label class="form-label">Peso Bruto</label>
              <CurrencyInput
                :id="`peso_bruto`"
                class="form-control mb-2"
                :class="[getErrorByID(`peso_bruto`) ? 'is-invalid' : '']"
                placeholder="Peso Bruto"
                style="text-align: right"
                v-model="this.pedido.peso_bruto"
                :options="options"
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`peso_bruto`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`peso_bruto`) }}
              </div>
              <label class="form-label">Peso Líquido</label>
              <CurrencyInput
                :id="`peso_liquido`"
                class="form-control mb-2"
                :class="[getErrorByID(`peso_liquido`) ? 'is-invalid' : '']"
                placeholder="Peso Líquido"
                style="text-align: right"
                v-model="this.pedido.peso_liquido"
                :options="options"
              ></CurrencyInput>
              <div
                v-if="getErrorByID(`peso_liquido`)"
                class="fv-plugins-message-container invalid-feedback"
              >
                {{ getErrorByID(`peso_liquido`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarProdutoObservacoes" class="modal-overlay">
    <div
      ref="kt_modal_produto_observacoes"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_produto_observacoes"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg
                  src="media/icons/duotune/communication/com003.svg"
                />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Observações do Produto</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarProdutoObservacoes(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-5">
            <textarea
              :id="`PedidoItem[${indexEdicaoPedidoItem}]observacao`"
              class="form-control mb-2"
              :class="[
                getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]observacao`)
                  ? 'is-invalid'
                  : '',
              ]"
              maxlength="300"
              style="height: 150px"
              v-model="this.observacaoPedidoItem"
            />
            <div class="row">
              <div class="col-6 pe-0">
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]observacao`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]observacao`
                    )
                  }}
                </div>
              </div>
              <div class="col-6 ps-2">
                <div class="text-end text-muted fs-7">
                  {{
                    this.observacaoPedidoItem
                      ? this.observacaoPedidoItem.length
                      : "0"
                  }}/300 caracteres
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarProdutoObservacoes(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              type="button"
              class="btn btn-success svg-icon-white mb-2"
              data-bs-dismiss="modal"
              @click="confirmarObservacoesProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarProdutoDetalhes" class="modal-overlay">
    <div
      ref="kt_modal_produto_detalhes"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_produto_detalhes"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg src="media/icons/duotune/general/gen025.svg" />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Detalhes do Produto</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarProdutoDetalhes(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-5">
            <div class="col-12 mb-2">
              <div class="mb-6">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">{{
                    this.retornaLabelDescricao(
                      "79a00056-12d0-4c8f-b3f4-d95d183ff7f6"
                    )
                  }}</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarPedidoItemDetPesagem"
                      @click="modalPedidoItemDetPesagens(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]det_pesagem`"
                  class="form-select mb-0"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_pesagem`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  data-placeholder="Selecione uma opção"
                  v-model="this.detPesagemPedidoItem"
                >
                  <template v-for="pesagem in this.pesagens" :key="pesagem">
                    <option
                      :value="pesagem.descricao"
                      v-bind:selected="[
                        pesagem.descricao === this.detPesagemPedidoItem
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ pesagem.descricao }}
                    </option>
                  </template>
                </select>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_pesagem`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_pesagem`
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="mb-6">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">{{
                    this.retornaLabelDescricao(
                      "685ed62c-38c5-4fb3-a1aa-bf63265d324d"
                    )
                  }}</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarPedidoItemDetTolerancia"
                      @click="modalPedidoItemDetTolerancias(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]det_tolerancia`"
                  class="form-select mb-0"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tolerancia`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  data-placeholder="Selecione uma opção"
                  v-model="this.detToleranciaPedidoItem"
                >
                  <template
                    v-for="tolerancia in this.tolerancias"
                    :key="tolerancia"
                  >
                    <option
                      :value="tolerancia.descricao"
                      v-bind:selected="[
                        tolerancia.descricao === this.detToleranciaPedidoItem
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ tolerancia.descricao }}
                    </option>
                  </template>
                </select>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tolerancia`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tolerancia`
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="mb-6">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">{{
                    this.retornaLabelDescricao(
                      "056ce5f8-b997-4a72-85c9-f8162c6139da"
                    )
                  }}</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarPedidoItemDetTipoEmbalagem"
                      @click="modalPedidoItemDetTipoEmbalagens(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]det_tipo_embalagem`"
                  class="form-select mb-0"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tipo_embalagem`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  data-placeholder="Selecione uma opção"
                  v-model="this.detTipoEmbalagemPedidoItem"
                >
                  <template
                    v-for="tipoEmbalagem in this.tipoEmbalagens"
                    :key="tipoEmbalagem"
                  >
                    <option
                      :value="tipoEmbalagem.descricao"
                      v-bind:selected="[
                        tipoEmbalagem.descricao ===
                        this.detTipoEmbalagemPedidoItem
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ tipoEmbalagem.descricao }}
                    </option>
                  </template>
                </select>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tipo_embalagem`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_tipo_embalagem`
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="mb-6">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">{{
                    this.retornaLabelDescricao(
                      "b5be0812-fe1b-465d-8757-d7599ad55464"
                    )
                  }}</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarPedidoItemDetCodBarras"
                      @click="modalPedidoItemDetCodBarras(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]det_cod_barras`"
                  class="form-select mb-0"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_cod_barras`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  data-placeholder="Selecione uma opção"
                  v-model="this.detCodBarrasPedidoItem"
                >
                  <template v-for="codBarra in this.codBarras" :key="codBarra">
                    <option
                      :value="codBarra.descricao"
                      v-bind:selected="[
                        codBarra.descricao === this.detCodBarrasPedidoItem
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ codBarra.descricao }}
                    </option>
                  </template>
                </select>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_cod_barras`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_cod_barras`
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="col-12 mb-2">
              <div class="mb-6">
                <div class="d-flex justify-content-between">
                  <label class="form-label me-4">{{
                    this.retornaLabelDescricao(
                      "0b1beec4-f93b-4150-b2ba-5eaa93e51159"
                    )
                  }}</label>
                  <div class="card-toolbar">
                    <button
                      v-if="this.consultarPedidoItemDetMetragem"
                      @click="modalPedidoItemDetMetragens(true)"
                      class="btn btn-sm btn-secondary px-2 py-0 m-0"
                    >
                      <span class="svg-icon svg-icon-1 m-0">
                        <inline-svg
                          src="media/icons/duotune/general/gen041.svg"
                      /></span>
                    </button>
                  </div>
                </div>
                <select
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]det_metragem`"
                  class="form-select mb-0"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_metragem`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  data-placeholder="Selecione uma opção"
                  v-model="this.detMetragemPedidoItem"
                >
                  <template v-for="metragem in this.metragens" :key="metragem">
                    <option
                      :value="metragem.descricao"
                      v-bind:selected="[
                        metragem.descricao === this.detMetragemPedidoItem
                          ? 'selected'
                          : '',
                      ]"
                    >
                      {{ metragem.descricao }}
                    </option>
                  </template>
                </select>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_metragem`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]det_metragem`
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarProdutoDetalhes(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              type="button"
              class="btn btn-success svg-icon-white mb-2"
              data-bs-dismiss="modal"
              @click="confirmarDetalhesProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoCompra" class="modal-overlay">
    <div
      id="kt_modal_pedido_compra_editar"
      ref="kt_modal_pedido_compra_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Número Pedido de Compra</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoCompra(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-md-6 fv-row mb-4">
                <label class="form-label">Número Ped. de Compra</label>
                <input
                  :id="`ped_compra`"
                  type="text"
                  class="form-control mb-2"
                  :class="[getErrorByID(`ped_compra`) ? 'is-invalid' : '']"
                  placeholder="Número do pedido"
                  maxlength="15"
                  v-model="this.pedido.ped_compra"
                  @keydown.stop.prevent.enter="
                    nextFocus(`btnConfirmarPedidoCompra`)
                  "
                />
                <div
                  v-if="getErrorByID(`ped_compra`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`ped_compra`) }}
                </div>
              </div>
              <div class="col-md-6 fv-row mb-4">
                <label class="form-label">Data do Ped. de Compra</label>
                <el-date-picker
                  :id="`data_ped_compra`"
                  v-model="this.pedido.data_ped_compra"
                  type="datetime"
                  name="dtpDataPedidoCompra"
                  placeholder="Selecione uma data"
                  class="w-100"
                  format="DD/MM/YYYY"
                  size="large"
                />
                <div
                  v-if="getErrorByID(`data_ped_compra`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`data_ped_compra`) }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoCompra(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarPedidoCompra"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoCompra(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoPesoItem" class="modal-overlay">
    <div
      id="kt_modal_pedido_peso_item_editar"
      ref="kt_modal_pedido_peso_item_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Peso</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoPesoItem(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-md-6 fv-row mb-4">
                <label
                  :for="`PedidoItem[${indexEdicaoPedidoItem}]peso_bruto`"
                  class="form-label"
                  >Peso Bruto</label
                >
                <CurrencyInput
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]peso_bruto`"
                  class="form-control mb-2"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_bruto`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  placeholder="Peso Bruto"
                  style="text-align: right"
                  v-model="this.pesoBrutoPedidoItem"
                  :options="options"
                  @keydown.stop.prevent.enter="
                    nextFocus(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`
                    )
                  "
                ></CurrencyInput>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_bruto`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_bruto`
                    )
                  }}
                </div>
              </div>
              <div class="col-md-6 fv-row mb-4">
                <label
                  :for="`PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`"
                  class="form-label"
                  >Peso Líquido</label
                >
                <CurrencyInput
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`"
                  class="form-control mb-2"
                  :class="[
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`
                    )
                      ? 'is-invalid'
                      : '',
                  ]"
                  placeholder="Peso Líquido"
                  style="text-align: right"
                  v-model="this.pesoLiquidoPedidoItem"
                  :options="options"
                  @keydown.stop.prevent.enter="
                    nextFocus(`btnConfirmarPedidoPesoItem`)
                  "
                ></CurrencyInput>
                <div
                  v-if="
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`
                    )
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(
                      `PedidoItem[${indexEdicaoPedidoItem}]peso_liquido`
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoPesoItem(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarPedidoPesoItem"
              data-bs-dismiss="modal"
              @click="confirmarPedidoPesoProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirPedidoIncluirExcluir" class="modal-overlay">
    <div
      id="kt_modal_pedido_incluir_excluir"
      ref="kt_modal_pedido_incluir_excluir"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Adicionar / Excluír Produto</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalPedidoIncluirExcluir(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="card border border-rounded border-gray-300 mb-4 p-6">
              <div class="row">
                <div class="col-auto fv-row d-flex justify-content-start mb-4">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbIncluirExcluir"
                      id="rbAdicionar"
                      @change="atualizarAdicionarExcluirProduto()"
                      checked
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbAdicionar"
                    >
                      Adicionar
                    </label>
                  </div>
                </div>
                <div class="col-auto fv-row d-flex justify-content-start mb-4">
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbIncluirExcluir"
                      ref="rbExcluir"
                      id="rbExcluir"
                      @change="atualizarAdicionarExcluirProduto()"
                    />
                    <label
                      class="form-check-label fs-6 fw-bold"
                      for="rbExcluir"
                    >
                      Excluír
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-xl-8 col-xxl-8 col-lg-8 col-md-8 fv-row mb-0 mt-6"
                >
                  <div class="input-group h-45px">
                    <input
                      :id="`pesquisaAdicionarExcluirProduto`"
                      type="text"
                      v-model="pesquisaAdicionarExcluirProduto"
                      @keydown.stop.prevent.enter="adicionarExcluirProduto()"
                      class="form-control"
                      :class="[
                        getErrorByID(`pesquisaAdicionarExcluirProduto`)
                          ? 'is-invalid'
                          : '',
                      ]"
                      placeholder="Informe o código"
                    />
                    <button
                      type="button"
                      class="input-group-text py-0 px-2"
                      @click="adicionarExcluirProduto()"
                    >
                      <span class="svg-icon svg-icon-primary svg-icon-2hx">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr087.svg"
                        />
                      </span>
                    </button>
                  </div>
                  <div
                    v-if="getErrorByID(`pesquisaAdicionarExcluirProduto`)"
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{ getErrorByID(`pesquisaAdicionarExcluirProduto`) }}
                  </div>
                </div>
                <div
                  class="col-xl-4 col-xxl-4 col-lg-4 col-md-4 fv-row mb-0 mt-6"
                >
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbPesquisaAdicionarExcluirProduto"
                      id="rbCodigoPesquisaAdicionarExcluirProduto"
                      @change="atualizarAdicionarExcluirProduto()"
                      checked
                    />
                    <label
                      class="form-check-label"
                      for="rbCodigoPesquisaAdicionarExcluirProduto"
                    >
                      <h6>Código</h6>
                    </label>
                  </div>
                  <div class="form-check form-check-custom form-check-sm">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="rbPesquisaAdicionarExcluirProduto"
                      id="rbBarrasPesquisaAdicionarExcluirProduto"
                      @change="atualizarAdicionarExcluirProduto()"
                    />
                    <label
                      class="form-check-label"
                      for="rbBarrasPesquisaAdicionarExcluirProduto"
                    >
                      <h6>Barras</h6>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="this.exibirLabelRadioExcluir" class="fs-7 mt-2 mb-2">
              <div class="text-dark">
                {{
                  "Se existir mais de um produto igual na grid, a exclusão será realizada de forma sequencial."
                }}
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalPedidoIncluirExcluir(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Sair
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirAdicionarPedidoBrinde" class="modal-overlay">
    <div
      id="kt_modal_pedido_brinde_adicionar"
      ref="kt_modal_pedido_brinde_adicionar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Adicionar Brindes</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalAdicionarPedidoBrinde(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
                <div class="mb-8 fv-row">
                  <label :for="`nomeProdutoBrinde`" class="form-label"
                    >Selecione o produto</label
                  >
                  <div class="input-group mb-2">
                    <input
                      type="text"
                      :id="`nomeProdutoBrinde`"
                      v-model="this.nomeProdutoBrinde"
                      class="form-control"
                      :class="[
                        getErrorByID(`nomeProdutoBrinde`) ? 'is-invalid' : '',
                      ]"
                      readonly
                    />
                    <button
                      type="button"
                      class="input-group-text"
                      @click="modalProdutosBrinde(true)"
                    >
                      <span class="svg-icon svg-icon-2">
                        <inline-svg
                          src="media/icons/duotune/general/gen004.svg"
                        />
                      </span>
                    </button>
                  </div>
                  <div
                    v-if="getErrorByID(`nomeProdutoBrinde`)"
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{ getErrorByID(`nomeProdutoBrinde`) }}
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3 fv-row mb-4"
              >
                <label class="form-label">Quantidade</label>
                <CurrencyInput
                  :id="`qtdProdutoBrinde`"
                  class="form-control mb-2"
                  :class="[
                    getErrorByID(`qtdProdutoBrinde`) ? 'is-invalid' : '',
                  ]"
                  placeholder="Quantidade"
                  style="text-align: right"
                  v-model="this.qtdProdutoBrinde"
                  :options="options"
                  @keydown.stop.prevent.enter="
                    nextFocus(`btnConfirmarProdutoBrinde`)
                  "
                ></CurrencyInput>
                <div
                  v-if="getErrorByID(`qtdProdutoBrinde`)"
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`qtdProdutoBrinde`) }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalAdicionarPedidoBrinde(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarProdutoBrinde"
              @click="confirmarProdutoBrinde()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoVendedorItem" class="modal-overlay">
    <div
      id="kt_modal_pedido_vendedor_item_editar"
      ref="kt_modal_pedido_vendedor_item_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Vendedor</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoVendedorItem(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-9">
                <div class="mb-8 fv-row">
                  <label
                    :for="`PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`"
                    class="form-label"
                    >Vendedor</label
                  >
                  <div class="input-group mb-2">
                    <input
                      type="text"
                      :id="`PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`"
                      v-model="this.nomeVendedorPedidoItem"
                      class="form-control"
                      :class="[
                        getErrorByID(
                          `PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`
                        )
                          ? 'is-invalid'
                          : '',
                      ]"
                      readonly
                    />
                    <span
                      class="svg-icon svg-icon-1 position-absolute end-0 mt-3"
                      :style="[
                        getErrorByID(
                          `PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`
                        )
                          ? 'margin-right: 6.50rem;'
                          : 'margin-right: 4.50rem;',
                      ]"
                      @click="limparVendedorPedidoItem()"
                    >
                      <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                    </span>
                    <button
                      type="button"
                      class="input-group-text"
                      @click="modalVendedoresItem(true)"
                    >
                      <span class="svg-icon svg-icon-2">
                        <inline-svg
                          src="media/icons/duotune/general/gen004.svg"
                        />
                      </span>
                    </button>
                  </div>
                  <div
                    v-if="
                      getErrorByID(
                        `PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`
                      )
                    "
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{
                      getErrorByID(
                        `PedidoItem[${indexEdicaoPedidoItem}]id_vendedor`
                      )
                    }}
                  </div>
                </div>
              </div>
              <div
                class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3 fv-row mb-4"
              >
                <label
                  :for="`PedidoItem[${indexEdicaoPedidoItem}]comissao`"
                  class="form-label"
                  >Comissão %</label
                >
                <CurrencyInput
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]comissao`"
                  class="form-control mb-2 text-primary"
                  :class="[
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]comissao`)
                      ? 'is-invalid'
                      : '',
                  ]"
                  placeholder="Comissão %"
                  style="text-align: right"
                  v-model="this.comissaoVendedorPedidoItem"
                  :options="options"
                  @keydown.stop.prevent.enter="
                    nextFocus(`btnConfirmarPedidoVendedorItem`)
                  "
                ></CurrencyInput>
                <div
                  v-if="
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]comissao`)
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]comissao`)
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoVendedorItem(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarPedidoVendedorItem"
              data-bs-dismiss="modal"
              @click="confirmarPedidoVendedorProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoCompraItem" class="modal-overlay">
    <div
      id="kt_modal_pedido_compra_item_editar"
      ref="kt_modal_pedido_compra_item_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Pedido de Compra</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoCompraItem(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-md-6 fv-row mb-4">
                <label
                  :for="`PedidoItem[${indexEdicaoPedidoItem}]xped`"
                  class="form-label"
                  >Número do Pedido de Compra</label
                >
                <input
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]xped`"
                  type="text"
                  class="form-control mb-2"
                  :class="[
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]xped`)
                      ? 'is-invalid'
                      : '',
                  ]"
                  placeholder="Número do pedido"
                  maxlength="15"
                  v-model="this.numeroPedidoCompraPedidoItem"
                  @keydown.stop.prevent.enter="
                    nextFocus(`PedidoItem[${indexEdicaoPedidoItem}]nitemped`)
                  "
                />
                <div
                  v-if="
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]xped`)
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{ getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]xped`) }}
                </div>
              </div>
              <div class="col-md-6 fv-row mb-4">
                <label
                  :for="`PedidoItem[${indexEdicaoPedidoItem}]nitemped`"
                  class="form-label"
                  >Item do Pedido de Compra</label
                >
                <input
                  :id="`PedidoItem[${indexEdicaoPedidoItem}]nitemped`"
                  type="text"
                  class="form-control mb-2"
                  :class="[
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]nitemped`)
                      ? 'is-invalid'
                      : '',
                  ]"
                  placeholder="Item do pedido"
                  maxlength="6"
                  v-model="this.itemPedidoCompraPedidoItem"
                  @keydown.stop.prevent.enter="
                    nextFocus(`btnConfirmarPedidoCompraItem`)
                  "
                />
                <div
                  v-if="
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]nitemped`)
                  "
                  class="fv-plugins-message-container invalid-feedback"
                >
                  {{
                    getErrorByID(`PedidoItem[${indexEdicaoPedidoItem}]nitemped`)
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoCompraItem(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarPedidoCompraItem"
              data-bs-dismiss="modal"
              @click="confirmarPedidoCompraProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoTabelaEstadosItem" class="modal-overlay">
    <div
      id="kt_modal_pedido_tabela_estados_item_editar"
      ref="kt_modal_pedido_tabela_estados_item_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Tabela de Estados</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoTabelaEstadosItem(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div class="mb-8 fv-row">
                  <label
                    :for="`PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`"
                    class="form-label"
                    >Tabela selecionada</label
                  >
                  <div class="input-group mb-2">
                    <input
                      type="text"
                      :id="`PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`"
                      :value="
                        this.estoqueStPedidoItem
                          ? this.estoqueStPedidoItem.id +
                            ' - ' +
                            this.estoqueStPedidoItem.descricao
                          : ''
                      "
                      class="form-control"
                      :class="[
                        getErrorByID(
                          `PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`
                        )
                          ? 'is-invalid'
                          : '',
                      ]"
                      readonly
                    />
                    <span
                      class="svg-icon svg-icon-1 position-absolute end-0 mt-3"
                      :style="[
                        getErrorByID(
                          `PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`
                        )
                          ? 'margin-right: 6.50rem;'
                          : 'margin-right: 4.50rem;',
                      ]"
                      @click="limparTabelaEstadosPedidoItem()"
                    >
                      <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
                    </span>
                    <button
                      type="button"
                      class="input-group-text"
                      @click="modalTabelaEstados(true)"
                    >
                      <span class="svg-icon svg-icon-2">
                        <inline-svg
                          src="media/icons/duotune/general/gen004.svg"
                        />
                      </span>
                    </button>
                  </div>
                  <div
                    v-if="
                      getErrorByID(
                        `PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`
                      )
                    "
                    class="fv-plugins-message-container invalid-feedback"
                  >
                    {{
                      getErrorByID(
                        `PedidoItem[${indexEdicaoPedidoItem}]id_estoque_st`
                      )
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoTabelaEstadosItem(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              id="btnConfirmarPedidoTabelaEstadosItem"
              data-bs-dismiss="modal"
              @click="confirmarPedidoTabelaEstadosProduto()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirEditarPedidoAnexo" class="modal-overlay">
    <div
      id="kt_modal_pedido_anexo_editar"
      ref="kt_modal_pedido_anexo_editar"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Anexos</h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalEditarPedidoAnexo(false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-8">
            <div class="row">
              <div
                class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
              >
                <div
                  class="mb-10 fv-row text-center bg-light-secondary rounded border-secondary border-2 border-dashed p-3"
                >
                  <el-upload
                    :id="`uploadRef`"
                    action="#"
                    :on-preview="handlePreview"
                    :on-change="handleBeforeUpload"
                    :on-exceed="handleLimitExceed"
                    :before-remove="handleRemove"
                    v-model:file-list="this.pedido.PedidoAnexo"
                    :auto-upload="false"
                    multiple
                    drag
                    :limit="10"
                    :disabled="disableUpload"
                  >
                    <el-icon class="el-icon--upload"><upload-filled /></el-icon>
                    <div class="el-upload__text">
                      Solte o documento aqui ou
                      <em>clique para fazer o upload</em>
                    </div>
                  </el-upload>
                  <div class="mt-6">
                    Anexe os documentos do pedido.
                    <br />Permitido até
                    <b class="text-primary">10 documentos</b> por pedido.
                    <br />Tamanho máximo permitido de
                    <b class="text-danger">10MB</b>
                    por anexo.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirPedidoRecalcularValores" class="modal-overlay">
    <div
      ref="kt_modal_pedido_recalcular_valores"
      data-bs-backdrop="static"
      data-bs-focus="false"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      id="kt_modal_pedido_recalcular_valores"
    >
      <div
        class="modal-dialog modal-md mw-400px modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="card-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg src="media/icons/duotune/finance/fin010.svg" />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Alteração de Preço</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.modalPedidoRecalcularValores(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body p-4">
            <div class="row">
              <div class="col-12 pt-0">
                <button
                  data-bs-dismiss="modal"
                  class="btn btn-secondary svg-icon-white w-100"
                  @click="confirmarRecalcularValores(1)"
                >
                  1 -
                  {{
                    this.retornaLabelDescricao(
                      "b05eb8ed-b413-4a7f-8bba-efdbf3182d6c"
                    )
                  }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  data-bs-dismiss="modal"
                  class="btn btn-warning svg-icon-white w-100"
                  @click="confirmarRecalcularValores(2)"
                >
                  2 -
                  {{
                    this.retornaLabelDescricao(
                      "5a453ca4-9f76-44c3-b603-11ea1ab3e4fd"
                    )
                  }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  data-bs-dismiss="modal"
                  class="btn btn-danger svg-icon-white w-100"
                  @click="confirmarRecalcularValores(3)"
                >
                  3 -
                  {{
                    this.retornaLabelDescricao(
                      "f03cc6d6-99dd-4d15-abc9-f803fc39b26f"
                    )
                  }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  data-bs-dismiss="modal"
                  class="btn btn-primary svg-icon-white w-100"
                  @click="confirmarRecalcularValores(4)"
                >
                  4 -
                  {{
                    this.retornaLabelDescricao(
                      "53a025c0-9c12-4843-85dd-2c32af180720"
                    )
                  }}
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pt-4">
                <button
                  data-bs-dismiss="modal"
                  class="btn btn-success svg-icon-white w-100"
                  @click="confirmarRecalcularValores(5)"
                >
                  5 -
                  {{
                    this.retornaLabelDescricao(
                      "808c0401-b5f5-4fe6-9ab5-69e76cfc842b"
                    )
                  }}
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end">
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.modalPedidoRecalcularValores(false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <CidadesModal
    v-if="exibirCidades"
    @exibirModalCidades="modalCidades"
    @confirmarCidade="confirmarCidade"
  ></CidadesModal>
  <PaisesModal
    v-if="exibirPaises"
    @exibirModalPaises="modalPaises"
    @confirmarPais="confirmarPais"
  ></PaisesModal>
  <ClientesModal
    v-if="exibirClientes"
    @exibirModalClientes="modalClientes"
    @selecionarCliente="selecionarCliente"
  >
  </ClientesModal>
  <TransportadorasModal
    v-if="exibirTransportadoras"
    @exibirModalTransportadora="modalTransportadoras"
    @selecionarTransportadora="selecionarTransportadora"
  ></TransportadorasModal>
  <MotoristasModal
    v-if="exibirMotoristas"
    @exibirModalMotoristas="modalMotoristas"
    @selecionarMotorista="selecionarMotorista"
  ></MotoristasModal>
  <VendedoresModal
    v-if="exibirVendedores"
    @exibirModalVendedores="modalVendedores"
    @selecionarVendedor="selecionarVendedor"
  ></VendedoresModal>
  <VendedoresModal
    v-if="exibirVendedoresItem"
    @exibirModalVendedores="modalVendedoresItem"
    @selecionarVendedor="selecionarVendedorItem"
  ></VendedoresModal>
  <ClienteModal
    v-if="exibirCliente"
    :idModal="idModalCliente"
    :idCliente="idCliente"
    @exibirModalCliente="modalCliente"
    @selecionarTelefone="selecionarTelefone"
    @selecionarEmail="selecionarEmail"
    @selecionarEndereco="selecionarEndereco"
  >
  </ClienteModal>
  <PedidoPagamentoModal
    v-if="exibirPedidoPagamento"
    :index="indexPedidoPagamento"
    :pedido="this.pedido"
    @exibirModalPedidoPagamento="modalPedidoPagamento"
    @adicionarPagamento="adicionarPagamento"
    @editarPagamento="editarPagamento"
  ></PedidoPagamentoModal>
  <component
    :is="modalComponent"
    v-if="exibirProdutos"
    @exibirModalProdutos="modalProdutos"
    @selecionarProduto="selecionarProduto"
  ></component>
  <component
    :is="modalComponent"
    v-if="exibirProdutosBrinde"
    @exibirModalProdutos="modalProdutosBrinde"
    @selecionarProduto="selecionarProdutoBrinde"
  ></component>
  <AdicionalModal
    v-if="exibirAdicional"
    :produto="this.adicionalProduto"
    :add="this.addPedidoItem"
    :indexEdicao="this.indexEdicaoPedidoItem"
    @exibirModalAdicional="modalAdicional"
    @confirmarAdicional="confirmarAdicional"
  ></AdicionalModal>
  <DescontoModal
    v-if="exibirDesconto"
    :total="totalDescontoModal"
    :labelTotal="labelTotal"
    :exibirRemoverDesconto="exibirRemoverDesconto"
    @exibirModalDesconto="modalDesconto"
    @confirmarDesconto="confirmarDesconto"
    @removerDesconto="removerDesconto"
  ></DescontoModal>
  <AlterarPrecoVendaModal
    v-if="exibirAlterarPrecoVenda"
    :pedido="this.pedido"
    @exibirModalAlterarPrecoVenda="modalAlterarPrecoVenda"
    @confirmarAlterarPrecoVenda="recalcularValores"
  >
  </AlterarPrecoVendaModal>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
  <SituacoesPedidoModal
    v-if="exibirSituacoesPedido"
    @exibirModalSituacoesPedido="modalSituacoesPedido"
    @confirmarSituacaoPedido="carregarSituacoes"
  ></SituacoesPedidoModal>
  <CategoriasPedidoModal
    v-if="exibirCategoriasPedido"
    @exibirModalCategoriasPedido="modalCategoriasPedido"
    @confirmarCategoriaPedido="carregarCategorias"
  ></CategoriasPedidoModal>
  <TiposPedidoModal
    v-if="exibirTiposPedido"
    @exibirModalTiposPedido="modalTiposPedido"
    @confirmarTipoPedido="carregarTipos"
  ></TiposPedidoModal>
  <LocaisPedidoModal
    v-if="exibirLocaisPedido"
    @exibirModalLocaisPedido="modalLocaisPedido"
    @confirmarLocalPedido="carregarLocais"
  ></LocaisPedidoModal>
  <TiposProdutoModal
    v-if="exibirTiposProduto"
    @exibirModalTiposProduto="modalTiposProduto"
    @confirmarTipoProduto="carregarTiposProduto"
  ></TiposProdutoModal>
  <PedidoItemDetMetragensModal
    v-if="exibirPedidoItemDetMetragens"
    @exibirModalPedidoItemDetMetragens="modalPedidoItemDetMetragens"
    @confirmarPedidoItemDetMetragem="carregarPedidoItemDetMetragens"
  ></PedidoItemDetMetragensModal>
  <PedidoItemDetCodBarrasModal
    v-if="exibirPedidoItemDetCodBarras"
    @exibirModalPedidoItemDetCodBarras="modalPedidoItemDetCodBarras"
    @confirmarPedidoItemDetCodBarras="carregarPedidoItemDetCodBarras"
  ></PedidoItemDetCodBarrasModal>
  <PedidoItemDetTipoEmbalagensModal
    v-if="exibirPedidoItemDetTipoEmbalagens"
    @exibirModalPedidoItemDetTipoEmbalagens="modalPedidoItemDetTipoEmbalagens"
    @confirmarPedidoItemDetTipoEmbalagem="carregarPedidoItemDetTipoEmbalagens"
  ></PedidoItemDetTipoEmbalagensModal>
  <PedidoItemDetToleranciasModal
    v-if="exibirPedidoItemDetTolerancias"
    @exibirModalPedidoItemDetTolerancias="modalPedidoItemDetTolerancias"
    @confirmarPedidoItemDetTolerancia="carregarPedidoItemDetTolerancias"
  ></PedidoItemDetToleranciasModal>
  <PedidoItemDetPesagensModal
    v-if="exibirPedidoItemDetPesagens"
    @exibirModalPedidoItemDetPesagens="modalPedidoItemDetPesagens"
    @confirmarPedidoItemDetPesagem="carregarPedidoItemDetPesagens"
  ></PedidoItemDetPesagensModal>
  <KitsModal
    v-if="exibirKits"
    :showSelection="true"
    @exibirModalKits="modalKits"
    @selecionarKit="selecionarKit"
  >
  </KitsModal>
  <EstoquesModal
    v-if="exibirEstoques"
    :produto="this.produtoEstoque"
    :add="this.addPedidoItem"
    :indexEdicao="this.indexEdicaoPedidoItem"
    @exibirModalEstoques="modalEstoques"
    @confirmarEstoque="confirmarEstoque"
  ></EstoquesModal>
  <TabelaEstadosModal
    v-if="exibirTabelaEstados"
    @exibirModalTabelaEstados="modalTabelaEstados"
    @selecionarTabelaEstado="selecionarTabelaEstado"
  ></TabelaEstadosModal>
</template>

<script>
import { markRaw } from "vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";
import { MenuComponent } from "@/assets/ts/components";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CurrencyInput from "@/components/text/CurrencyInput";
import FocusCurrencyInput from "@/components/text/FocusCurrencyInput";
import FocusTextInput from "@/components/text/FocusTextInput";
import CidadesModal from "@/views/cidades/CidadesModal.vue";
import PaisesModal from "@/views/paises/PaisesModal";
import ClientesModal from "@/views/clientes/ClientesModal.vue";
import ClienteModal from "@/views/clientes/ClienteModal.vue";
import PedidoPagamentoModal from "@/views/pedidos/PedidoPagamentoModal.vue";
import PedidoReceberModal from "@/views/pedidos/PedidoReceberModal.vue";
import TransportadorasModal from "@/views/transportadoras/TransportadorasModal.vue";
import MotoristasModal from "@/views/motoristas/MotoristasModal.vue";
import VendedoresModal from "@/views/vendedores/VendedoresModal.vue";
import EstoquesModal from "@/views/produtos/EstoquesModal.vue";
import AdicionalModal from "@/views/adicionais/AdicionalModal.vue";
import DescontoModal from "@/views/pedidos/DescontoModal.vue";
import AlterarPrecoVendaModal from "@/views/pedidos/AlterarPrecoVendaModal.vue";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import SituacoesPedidoModal from "@/views/pedidos/SituacoesPedidoModal.vue";
import CategoriasPedidoModal from "@/views/pedidos/CategoriasPedidoModal.vue";
import TiposPedidoModal from "@/views/pedidos/TiposPedidoModal.vue";
import LocaisPedidoModal from "@/views/pedidos/LocaisPedidoModal.vue";
import TiposProdutoModal from "@/views/pedidos/TiposProdutoModal.vue";
import PedidoItemDetMetragensModal from "@/views/pedidos/PedidoItemDetMetragensModal.vue";
import PedidoItemDetCodBarrasModal from "@/views/pedidos/PedidoItemDetCodBarrasModal.vue";
import PedidoItemDetTipoEmbalagensModal from "@/views/pedidos/PedidoItemDetTipoEmbalagensModal.vue";
import PedidoItemDetToleranciasModal from "@/views/pedidos/PedidoItemDetToleranciasModal.vue";
import PedidoItemDetPesagensModal from "@/views/pedidos/PedidoItemDetPesagensModal.vue";
import TabelaEstadosModal from "@/views/produtos/TabelaEstadosModal.vue";
import KitsModal from "../produtos/KitsModal.vue";
import { UploadFilled } from "@element-plus/icons-vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
import * as math from "mathjs";
import _ from "lodash";
const toast = useToast();

const pedidoMapper = {
  InclusaoRapida: ["tabProduto", "kt_pedido_produto"],
  n_ped_mobile: ["tabGeral", "kt_pedido_geral"],
  prazo_dias: ["tabGeral", "kt_pedido_geral"],
  data_emissao: ["tabGeral", "kt_pedido_geral"],
  data_entrega: ["tabGeral", "kt_pedido_geral"],
  situacao: ["tabGeral", "kt_pedido_geral"],
  categoria: ["tabGeral", "kt_pedido_geral"],
  tipo: ["tabGeral", "kt_pedido_geral"],
  local: ["tabGeral", "kt_pedido_geral"],
  id_conta: ["tabGeral", "kt_pedido_geral"],
  id_custo: ["tabGeral", "kt_pedido_geral"],
  PedidoClienteid_cliente: ["tabGeral", "kt_pedido_geral"],
  PedidoClientenome: ["tabGeral", "kt_pedido_geral"],
  PedidoClientecpf_cnpj: ["tabGeral", "kt_pedido_geral"],
  PedidoClienterg_ie: ["tabGeral", "kt_pedido_geral"],
  PedidoClientetelefone: ["tabGeral", "kt_pedido_geral"],
  PedidoClienteemail: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecodescricao: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecocep: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoendereco: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEndereconumero: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecocomplemento: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecobairro: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecouf: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecocidade: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecopais: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecolatitude: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecolongitude: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregadescricao: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregacep: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregaendereco: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntreganumero: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregacomplemento: [
    "tabGeral",
    "kt_pedido_geral",
  ],
  PedidoClientePedidoEnderecoEntregabairro: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregauf: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregacidade: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregapais: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregalatitude: ["tabGeral", "kt_pedido_geral"],
  PedidoClientePedidoEnderecoEntregalongitude: ["tabGeral", "kt_pedido_geral"],
  observacao: ["tabGeral", "kt_pedido_geral"],
  id_transportadora: ["tabGeral", "kt_pedido_geral"],
  frete: ["tabGeral", "kt_pedido_geral"],
  id_motorista: ["tabGeral", "kt_pedido_geral"],
  id_vendedor: ["tabGeral", "kt_pedido_geral"],
  comissao_per: ["tabGeral", "kt_pedido_geral"],
  comissao_valor: ["tabGeral", "kt_pedido_geral"],
  PedidoItemitem: ["tabProduto", "kt_pedido_produto"],
  PedidoItemid_produto: ["tabProduto", "kt_pedido_produto"],
  PedidoItemnome: ["tabProduto", "kt_pedido_produto"],
  PedidoItemund: ["tabProduto", "kt_pedido_produto"],
  PedidoItemqtd: ["tabProduto", "kt_pedido_produto"],
  PedidoItempreco: ["tabProduto", "kt_pedido_produto"],
  PedidoItemtotal_sub_itens: ["tabProduto", "kt_pedido_produto"],
  PedidoItemtotal: ["tabProduto", "kt_pedido_produto"],
  PedidoItemtipo_prod: ["tabProduto", "kt_pedido_produto"],
  PedidoItemipi: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdesconto: ["tabProduto", "kt_pedido_produto"],
  PedidoItemacrescimo: ["tabProduto", "kt_pedido_produto"],
  PedidoItemst: ["tabProduto", "kt_pedido_produto"],
  PedidoItemcsosn: ["tabProduto", "kt_pedido_produto"],
  PedidoItemicms: ["tabProduto", "kt_pedido_produto"],
  total: ["", ""],
  total_produtos: ["", ""],
  total_descontos: ["", ""],
  total_acrescimo: ["", ""],
  total_frete: ["", ""],
  total_seguro: ["", ""],
  total_outras: ["", ""],
  base_icms: ["", ""],
  total_icms: ["", ""],
  base_icms_sub: ["", ""],
  total_icms_sub: ["", ""],
  total_ipi: ["", ""],
  quantidade: ["", ""],
  peso_bruto: ["", ""],
  peso_liquido: ["", ""],
  PedidoReceberordem: ["tabPagamento", "kt_pedido_pagamento"],
  PedidoRecebervencimento: ["tabPagamento", "kt_pedido_pagamento"],
  PedidoRecebervalor: ["tabPagamento", "kt_pedido_pagamento"],
  PedidoReceberespecie: ["tabPagamento", "kt_pedido_pagamento"],
  PedidoReceberbanco: ["tabPagamento", "kt_pedido_pagamento"],
  ped_compra: ["tabGeral", "kt_pedido_geral"],
  data_ped_compra: ["tabGeral", "kt_pedido_geral"],
  PedidoItemid_vendedor: ["tabProduto", "kt_pedido_produto"],
  PedidoItemcomissao: ["tabProduto", "kt_pedido_produto"],
  PedidoItemxped: ["tabProduto", "kt_pedido_produto"],
  PedidoItemnitemped: ["tabProduto", "kt_pedido_produto"],
  PedidoItemobservacao: ["tabProduto", "kt_pedido_produto"],
  PedidoItempeso_bruto: ["tabProduto", "kt_pedido_produto"],
  PedidoItempeso_liquido: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdet_pesagem: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdet_tolerancia: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdet_tipo_embalagem: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdet_cod_barras: ["tabProduto", "kt_pedido_produto"],
  PedidoItemdet_metragem: ["tabProduto", "kt_pedido_produto"],
  PedidoItemid_estoque_st: ["tabProduto", "kt_pedido_produto"],
};

const pedidoInicializado = {
  id: 0,
  guid: "",
  tipo: "",
  total_frete: 0,
  total_descontos: 0,
  total_acrescimo: 0,
  total_outras: 0,
  total_produtos: 0,
  total: 0,
  agendado: "0",
  finalizado: "0",
  cancelado: "0",
  impresso: "0",
  pedido_confirmado: "0",
  saiu_entrega: "0",
  situacao: "Pendente",
  qtd_impressao: 0,
  data_emissao: null,
  data_entrega: null,
  data_inicio_preparo: null,
  tempo_preparo: null,
  data_cancelamento: null,
  usuario_cancelou: null,
  cod_cancelamento: 0,
  motivo_cancelamento: null,
  id_transportadora: null,
  id_vendedor: null,
  id_condicao: null,
  observacao: null,
  mesa: null,
  mesa_comanda: null,
  prazo_dias: 0,
  total_seguro: 0,
  total_ipi: 0,
  operador: null,
  categoria: "",
  id_motorista: null,
  comissao_per: 0,
  comissao_valor: 0,
  qtd_alteracoes: 0,
  base_icms: 0,
  total_icms: 0,
  base_icms_sub: 0,
  total_icms_sub: 0,
  utiliza_icms_sub: true,
  peso_bruto: 0,
  peso_liquido: 0,
  quantidade: "",
  ped_compra: "",
  data_ped_compra: null,
  frete: "0",
  n_ped_mobile: "",
  local: "",
  id_conta: null,
  id_custo: null,
  PedidoCliente: {
    id: 0,
    id_pedido: 0,
    id_cliente: null,
    nome: "",
    cpf_cnpj: "",
    rg_ie: "",
    telefone: "",
    email: "",
    PedidoEnderecoEntrega: {
      id: 0,
      id_pedido: 0,
      id_pedido_cliente: 0,
      id_cliente_endereco: null,
      descricao: "Casa",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
    },
    PedidoEndereco: {
      id: 0,
      id_pedido: 0,
      id_pedido_cliente: 0,
      id_cliente_endereco: null,
      descricao: "Casa",
      endereco: "",
      complemento: "",
      bairro: "",
      numero: "",
      cep: "",
      cidade: "",
      cod_cidade: "",
      uf: "SP",
      pais: "",
      cod_pais: "",
      latitude: "",
      longitude: "",
    },
  },
  PedidoPagamento: [],
  PedidoReceber: [],
  PedidoItem: [],
  PedidoAnexo: [],
  Transportadora: {
    nome: "",
  },
  Motorista: {
    nome: "",
  },
  Vendedor: {
    nome: "",
  },
  Condicao: {
    condicoes: "",
  },
};

export default {
  emits: ["cancelarPedido", "confirmarPedido"],
  components: {
    CidadesModal,
    PaisesModal,
    ClientesModal,
    TransportadorasModal,
    MotoristasModal,
    VendedoresModal,
    ClienteModal,
    CurrencyInput,
    FocusCurrencyInput,
    FocusTextInput,
    PedidoPagamentoModal,
    PedidoReceberModal,
    Datatable,
    EstoquesModal,
    AdicionalModal,
    DescontoModal,
    AlterarPrecoVendaModal,
    ContasModal,
    CustosModal,
    SituacoesPedidoModal,
    CategoriasPedidoModal,
    TiposPedidoModal,
    LocaisPedidoModal,
    TiposProdutoModal,
    PedidoItemDetMetragensModal,
    PedidoItemDetCodBarrasModal,
    PedidoItemDetTipoEmbalagensModal,
    PedidoItemDetToleranciasModal,
    PedidoItemDetPesagensModal,
    UploadFilled,
    KitsModal,
    TabelaEstadosModal,
  },
  props: {
    idPedido: { type: Number, required: false, default: 0 },
    modal: { type: Boolean, required: false, default: false },
  },
  methods: {
    modalTabelaEstados(exibir) {
      this.exibirTabelaEstados = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tabela_estados_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEstoqueSts");
          },
          /*close*/ () => {
            this.modalTabelaEstados(false);
          }
        );
      }
    },
    selecionarTabelaEstado(estoqueSt) {
      this.estoqueStPedidoItem = estoqueSt;
      this.modalTabelaEstados(false);
    },
    async selecionarKit(kit, qtd) {
      try {
        var ret = await this.$store.dispatch("kit/getKit", kit.id);
        if (ret.Success === true) {
          kit = ret.Data;
          for (var i = 0; i < kit.ProdKit.length; i++) {
            var prod = kit.ProdKit[i].Produto;
            prod.brinde = "N";
            prod.promocaoAtiva = false;
            prod.qtd = qtd * kit.ProdKit[i].qtd;
            prod.preco = kit.ProdKit[i].valor;
            if (prod.Estoque != null && prod.Estoque.length > 0) {
              prod.id_estoque = prod.Estoque[0].id;
            }
            this.preencheProdutoSelecionado(prod, true, -1);
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalKits(exibir) {
      this.exibirKits = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_kits_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarKits");
          },
          /*close*/ () => {
            this.modalKits(false);
          }
        );
      }
    },
    atualizaDataSaida() {
      delete this.errosValidacao[`prazo_dias`];
      if (this.$utils.isInteger(this.pedido.prazo_dias)) {
        var dataEmissao = new Date(this.pedido.data_emissao);
        dataEmissao.setDate(
          dataEmissao.getDate() + parseInt(this.pedido.prazo_dias, 10)
        );
        this.pedido.data_entrega = dataEmissao;
      } else {
        this.errosValidacao[`prazo_dias`] = "O prazo de dias é inválido";
      }
    },
    modalPedidoRecalcularValores(exibir) {
      this.exibirPedidoRecalcularValores = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_recalcular_valores",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_pedido_recalcular_valores");
            document.addEventListener(
              "keydown",
              this.handleEventKeyRecalcularValores
            );
          },
          /*close*/ () => {
            this.modalPedidoRecalcularValores(false);
            document.removeEventListener(
              "keydown",
              this.handleEventKeyRecalcularValores
            );
          }
        );
      }
    },
    handleEventKeyRecalcularValores(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.key === "1") {
        this.confirmarRecalcularValores(1);
        hideModal(this.$refs.kt_modal_pedido_recalcular_valores);
      } else if (event.key === "2") {
        this.confirmarRecalcularValores(2);
        hideModal(this.$refs.kt_modal_pedido_recalcular_valores);
      } else if (event.key === "3") {
        this.confirmarRecalcularValores(3);
        hideModal(this.$refs.kt_modal_pedido_recalcular_valores);
      } else if (event.key === "4") {
        this.confirmarRecalcularValores(4);
        hideModal(this.$refs.kt_modal_pedido_recalcular_valores);
      } else if (event.key === "5") {
        this.confirmarRecalcularValores(5);
        hideModal(this.$refs.kt_modal_pedido_recalcular_valores);
      }
    },
    confirmarRecalcularValores(opcao) {
      for (var i = 0; i < this.pedido.PedidoItem.length; i++) {
        //1 - Preço à Vista
        if (opcao === 1) {
          this.pedido.PedidoItem[i].preco =
            this.pedido.PedidoItem[i].Produto.preco;
          //2 - Preço Revenda
        } else if (opcao === 2) {
          this.pedido.PedidoItem[i].preco =
            this.pedido.PedidoItem[i].Produto.preco_revenda;
          //3 - Preço Distribuidora
        } else if (opcao === 3) {
          this.pedido.PedidoItem[i].preco =
            this.pedido.PedidoItem[i].Produto.preco_distribuidora;
          //4 - Preço à Prazo
        } else if (opcao === 4) {
          this.pedido.PedidoItem[i].preco =
            this.pedido.PedidoItem[i].Produto.preco_venda_prazo;
          //5 - Preço Prazo Revenda
        } else if (opcao === 5) {
          this.pedido.PedidoItem[i].preco =
            this.pedido.PedidoItem[i].Produto.preco_prazo_revenda;
        }
      }
      this.modalPedidoRecalcularValores(false);
      this.recalcularValores();
    },
    async handleLimitExceed() {
      this.disableUpload = true;
      await this.$swal.showInvalidAlert(
        "Excedido o limite máximo de documentos permitidos por pedido!",
        (alert) => {
          this.disableUpload = false;
        }
      );
    },
    async handleBeforeUpload(file) {
      let result = true;
      if (this.adicionarPedidoAnexo === false) {
        await this.$swal.showInvalidAlert(
          "Usuário não tem permissão para adicionar anexo!",
          (alert) => {
            result = false;
          }
        );
      } else {
        const reader = new FileReader();
        reader.onload = (event) => {
          file.url = event.target.result;
        };
        reader.readAsDataURL(file.raw);
        if (file.size > 10000000) {
          const index = Object.keys(this.pedido.PedidoAnexo).find(
            (key) => this.pedido.PedidoAnexo[key].uid === file.uid
          );
          this.pedido.PedidoAnexo.splice(index, 1);
          this.disableUpload = true;
          await this.$swal.showErrorAlert(
            "Documento excede o tamanho máximo permido de 10MB!",
            (alert) => {
              this.disableUpload = false;
            }
          );
        }
      }
      return result;
    },
    async handlePreview(file) {
      if (file.id !== 0 && file.id !== undefined && file.status !== "delete") {
        this.disableUpload = true;
        await this.$swal.showQuestionAlert("Deseja abrir o anexo?", (alert) => {
          if (alert.isConfirmed) {
            window.open(file.caminho_arquivo, "_blank");
          }
          this.disableUpload = false;
        });
      }
    },
    async handleRemove(file) {
      var result = true;
      if (this.excluirPedidoAnexo === false) {
        await this.$swal.showInvalidAlert(
          "Usuário não tem permissão para excluir anexo!",
          (alert) => {
            result = false;
          }
        );
      } else {
        if (file.status !== "delete") {
          this.disableUpload = true;
          await this.$swal.showQuestionAlert(
            "Deseja remover o anexo?",
            (alert) => {
              if (alert.isConfirmed) {
                if (file.id !== 0 && file.id !== undefined) {
                  file.status = "delete";
                  file.name =
                    file.name +
                    " - Aguardando a gravação do pedido para remoção";
                  result = false;
                }
              } else {
                result = false;
              }
              this.disableUpload = false;
            }
          );
        } else {
          result = false;
        }
      }
      return result;
    },
    async carregarAnexos() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoAnexo/getPedidoAnexoOData",
          "?$filter=id_pedido eq " + this.pedido.id
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.pedido.PedidoAnexo.push(...ret.value);

          if (this.pedido.PedidoAnexo.length > 0) {
            for (var i = 0; i < this.pedido.PedidoAnexo.length; i++) {
              this.pedido.PedidoAnexo[i].name =
                this.pedido.PedidoAnexo[i].nome_arquivo;
              if (
                this.pedido.PedidoAnexo[i].caminho_arquivo !== null &&
                this.pedido.PedidoAnexo[i].caminho_arquivo !== ""
              ) {
                this.pedido.PedidoAnexo[i].caminho_arquivo =
                  this.$utils.getUrl() +
                  this.pedido.PedidoAnexo[i].caminho_arquivo;
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarSituacoes() {
      this.situacoes = [
        {
          descricao: "Pendente",
        },
        {
          descricao: "Atrasado",
        },
        {
          descricao: "Entregue",
        },
        {
          descricao: "Cancelado",
        },
        {
          descricao: "Faturado",
        },
        {
          descricao: "Consignação",
        },
        {
          descricao: "Orçamento",
        },
        {
          descricao: "Devolvido",
        },
      ];
      try {
        var ret = await this.$store.dispatch(
          "situacaoPedido/getSituacaoPedidoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.situacoes.push(...ret.value);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarCategorias() {
      try {
        var ret = await this.$store.dispatch(
          "categoriaPedido/getCategoriaPedidoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.categorias = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarTipos() {
      try {
        var ret = await this.$store.dispatch(
          "tipoPedido/getTipoPedidoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tipos = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarLocais() {
      try {
        var ret = await this.$store.dispatch(
          "localPedido/getLocalPedidoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.locais = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    limparEnderecoEntregaPedido() {
      this.pedido.PedidoCliente.PedidoEnderecoEntrega = JSON.parse(
        JSON.stringify(pedidoInicializado.PedidoCliente.PedidoEnderecoEntrega)
      );
    },
    limparTransportadoraPedido() {
      this.pedido.Transportadora = null;
      this.pedido.id_transportadora = null;
    },
    limparMotoristaPedido() {
      this.pedido.Motorista = null;
      this.pedido.id_motorista = null;
    },
    limparVendedorPedido() {
      this.pedido.Vendedor = null;
      this.pedido.id_vendedor = null;
    },
    limparVendedorPedidoItem() {
      this.idVendedorPedidoItem = null;
      this.comissaoVendedorPedidoItem = 0;
      this.nomeVendedorPedidoItem = "";
    },
    async recalcularItensPedido() {
      await this.$swal.showQuestionAlert(
        "Deseja recalcular todos os itens do pedido?",
        (alert) => {
          if (alert.isConfirmed) {
            this.recalcularValores();
          }
        }
      );
    },
    modalEditarPedidoAnexo(exibir) {
      this.exibirEditarPedidoAnexo = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_anexo_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_pedido_anexo_editar");
          },
          /*close*/ () => {
            this.modalEditarPedidoAnexo(false);
          }
        );
      }
    },
    modalEditarPedidoCompra(exibir) {
      this.exibirEditarPedidoCompra = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_compra_editar",
          /*open*/ () => {
            this.$utils.requestFocus("ped_compra");
          },
          /*close*/ () => {
            this.modalEditarPedidoCompra(false);
          }
        );
      }
    },
    modalPedidoIncluirExcluir(exibir) {
      this.exibirPedidoIncluirExcluir = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_incluir_excluir",
          /*open*/ () => {
            this.$utils.requestFocus("pesquisaAdicionarExcluirProduto");
            document.addEventListener(
              "keydown",
              this.handleEventKeyPedidoIncluirExcluir
            );
          },
          /*close*/ () => {
            this.modalPedidoIncluirExcluir(false);
            document.removeEventListener(
              "keydown",
              this.handleEventKeyPedidoIncluirExcluir
            );
          }
        );
      }
    },
    handleEventKeyPedidoIncluirExcluir(event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.key === "+") {
        let radio = document.getElementsByName("rbIncluirExcluir");
        if (radio.length > 0) {
          radio[0].checked = true;
          this.$utils.requestFocus("pesquisaAdicionarExcluirProduto");
        }
      } else if (event.key === "-") {
        let radio = document.getElementsByName("rbIncluirExcluir");
        if (radio.length > 0) {
          radio[1].checked = true;
          this.$utils.requestFocus("pesquisaAdicionarExcluirProduto");
        }
      }
    },
    pedidoAdicionarExcluirProduto(opcao) {
      this.errosValidacao = [];
      this.pesquisaAdicionarExcluirProduto = "";
      this.modalPedidoIncluirExcluir(true);
      setTimeout(() => {
        let radio = document.getElementsByName("rbIncluirExcluir");
        if (radio.length > 0) {
          radio[opcao].checked = true;
        }
      }, 800);
    },
    modalAdicionarPedidoBrinde(exibir) {
      this.exibirAdicionarPedidoBrinde = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_brinde_adicionar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_pedido_brinde_adicionar");
            this.errosValidacao = {};
          },
          /*close*/ () => {
            this.modalAdicionarPedidoBrinde(false);
          }
        );
      }
    },
    adicionarPedidoBrinde() {
      this.nomeProdutoBrinde = "";
      this.qtdProdutoBrinde = 0;
      this.produtoBrinde = null;
      this.modalAdicionarPedidoBrinde(true);
    },
    async confirmarProdutoBrinde() {
      this.errosValidacao = {};
      if ((await this.validarProdutoBrinde()) === true) {
        this.produtoBrinde.brinde = "S";
        this.produtoBrinde.qtd = this.qtdProdutoBrinde;
        this.selecionarProduto(this.produtoBrinde);
        hideModal(this.$refs.kt_modal_pedido_brinde_adicionar);
        this.modalAdicionarPedidoBrinde(false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }
    },
    async validarProdutoBrinde() {
      let result = true;

      if (this.produtoBrinde === null) {
        this.errosValidacao[`nomeProdutoBrinde`] =
          "Nenhum Produto foi informado!";
        result = false;
      }

      if (!this.$utils.isNumeric(this.qtdProdutoBrinde)) {
        this.errosValidacao[`qtdProdutoBrinde`] =
          "A quantidade do produto é inválida!";
        result = false;
      }

      return result;
    },
    modalEditarPedidoPesoItem(exibir) {
      this.exibirEditarPedidoPesoItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_peso_item_editar",
          /*open*/ () => {
            this.$utils.requestFocus(
              `PedidoItem[${this.indexEdicaoPedidoItem}]peso_bruto`
            );
          },
          /*close*/ () => {
            this.modalEditarPedidoPesoItem(false);
          }
        );
      }
    },
    editarPedidoPesoProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.pesoBrutoPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].peso_bruto;
      this.pesoLiquidoPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].peso_liquido;
      this.modalEditarPedidoPesoItem(true);
    },
    confirmarPedidoPesoProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].peso_bruto =
        this.pesoBrutoPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].peso_liquido =
        this.pesoLiquidoPedidoItem;
      this.indexEdicaoPedidoItem = -1;
      this.modalEditarPedidoPesoItem(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    modalEditarPedidoVendedorItem(exibir) {
      this.exibirEditarPedidoVendedorItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_vendedor_item_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_pedido_vendedor_item_editar");
          },
          /*close*/ () => {
            this.modalEditarPedidoVendedorItem(false);
          }
        );
      }
    },
    async editarPedidoVendedorProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.nomeVendedorPedidoItem = "";
      this.idVendedorPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].id_vendedor;
      this.comissaoVendedorPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].comissao;
      try {
        var ret = await this.$store.dispatch(
          "vendedor/getVendedorOData",
          "?$filter=id eq " + this.idVendedorPedidoItem
        );
        if (ret.value != null && ret.value.length > 0) {
          this.nomeVendedorPedidoItem = ret.value[0].nome.toUpperCase();
        }
      } catch (error) {
        console.log(error);
      }
      this.modalEditarPedidoVendedorItem(true);
    },
    confirmarPedidoVendedorProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].id_vendedor =
        this.idVendedorPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].comissao =
        this.comissaoVendedorPedidoItem;
      this.nomeVendedorPedidoItem = "";
      this.indexEdicaoPedidoItem = -1;
      this.modalEditarPedidoVendedorItem(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    modalEditarPedidoCompraItem(exibir) {
      this.exibirEditarPedidoCompraItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_compra_item_editar",
          /*open*/ () => {
            this.$utils.requestFocus(
              `PedidoItem[${this.indexEdicaoPedidoItem}]xped`
            );
          },
          /*close*/ () => {
            this.modalEditarPedidoCompraItem(false);
          }
        );
      }
    },
    editarPedidoCompraProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.numeroPedidoCompraPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].xped;
      this.itemPedidoCompraPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].nitemped;
      this.modalEditarPedidoCompraItem(true);
    },
    confirmarPedidoCompraProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].xped =
        this.numeroPedidoCompraPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].nitemped =
        this.itemPedidoCompraPedidoItem;
      this.indexEdicaoPedidoItem = -1;
      this.modalEditarPedidoCompraItem(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    async editarPedidoTabelaEstadosProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.estoqueStPedidoItem = null;
      try {
        var ret = await this.$store.dispatch(
          "estoqueSt/getEstoqueStOData",
          "?$filter=id eq " +
            this.pedido.PedidoItem[this.indexEdicaoPedidoItem].id_estoque_st
        );
        if (ret.value != null && ret.value.length > 0) {
          this.estoqueStPedidoItem = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
      this.modalEditarPedidoTabelaEstadosItem(true);
    },
    modalEditarPedidoTabelaEstadosItem(exibir) {
      this.exibirEditarPedidoTabelaEstadosItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_tabela_estados_item_editar",
          /*open*/ () => {
            this.$utils.requestFocus(
              "kt_modal_pedido_tabela_estados_item_editar"
            );
          },
          /*close*/ () => {
            this.modalEditarPedidoTabelaEstadosItem(false);
          }
        );
      }
    },
    limparTabelaEstadosPedidoItem() {
      this.estoqueStPedidoItem = null;
    },
    async confirmarPedidoTabelaEstadosProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].id_estoque_st = this
        .estoqueStPedidoItem
        ? this.estoqueStPedidoItem.id
        : null;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].EstoqueSt =
        this.estoqueStPedidoItem;

      if (this.estoqueStPedidoItem) {
        let tabelaEstados = await this.retornarTabelaEstados(
          this.estoqueStPedidoItem.id
        );
        if (tabelaEstados !== null) {
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].aliqi =
            tabelaEstados.aliqi;
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].icms =
            tabelaEstados.aliq;
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].mva =
            tabelaEstados.mva;
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].reducao =
            tabelaEstados.reducao;
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].st =
            tabelaEstados.st;
          this.pedido.PedidoItem[this.indexEdicaoPedidoItem].csosn =
            tabelaEstados.csosn;
        }
      }

      await this.recalcularValores();

      this.indexEdicaoPedidoItem = -1;
      this.modalEditarPedidoTabelaEstadosItem(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    async carregarLabelDescricao() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$select=campo,descricao&$filter=modulo eq 'Pedidos' or modulo eq 'Produtos'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricao = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    retornaLabelDescricao(campo) {
      var label = this.labelDescricao.find(
        (element) => element.campo === campo
      );
      return label ? label.descricao : "";
    },
    modalEditarProdutoDetalhes(exibir) {
      this.exibirEditarProdutoDetalhes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produto_detalhes",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_produto_detalhes");
          },
          /*close*/ () => {
            this.modalEditarProdutoDetalhes(false);
          }
        );
      }
    },
    editarDetalhesProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.detPesagemPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_pesagem;
      this.detToleranciaPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_tolerancia;
      this.detTipoEmbalagemPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_tipo_embalagem;
      this.detCodBarrasPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_cod_barras;
      this.detMetragemPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_metragem;
      this.modalEditarProdutoDetalhes(true);
    },
    confirmarDetalhesProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_pesagem =
        this.detPesagemPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_tolerancia =
        this.detToleranciaPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_tipo_embalagem =
        this.detTipoEmbalagemPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_cod_barras =
        this.detCodBarrasPedidoItem;
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].det_metragem =
        this.detMetragemPedidoItem;
      this.indexEdicaoPedidoItem = -1;
      this.modalEditarProdutoDetalhes(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    async carregarPedidoItemDetPesagens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetPesagem/getPedidoItemDetPesagemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.pesagens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetTolerancias() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetTolerancia/getPedidoItemDetToleranciaOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tolerancias = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetTipoEmbalagens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetTipoEmbalagem/getPedidoItemDetTipoEmbalagemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tipoEmbalagens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetCodBarras() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetCodBarras/getPedidoItemDetCodBarrasOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.codBarras = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedidoItemDetMetragens() {
      try {
        var ret = await this.$store.dispatch(
          "pedidoItemDetMetragem/getPedidoItemDetMetragemOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.metragens = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarTiposProduto() {
      try {
        var ret = await this.$store.dispatch(
          "tipoProduto/getTipoProdutoOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tiposProduto = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    somaQtdProdutos() {
      if (this.pedido.PedidoItem.length > 0) {
        return _.sumBy(this.pedido.PedidoItem, "qtd");
      } else {
        return 0;
      }
    },
    modalTiposProduto(exibir) {
      this.exibirTiposProduto = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tipos_produto_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTiposProduto");
          },
          /*close*/ () => {
            this.modalTiposProduto(false);
          }
        );
      }
    },
    modalPedidoItemDetMetragens(exibir) {
      this.exibirPedidoItemDetMetragens = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_metragens_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidoItemDetMetragens");
          },
          /*close*/ () => {
            this.modalPedidoItemDetMetragens(false);
          }
        );
      }
    },
    modalPedidoItemDetCodBarras(exibir) {
      this.exibirPedidoItemDetCodBarras = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_cod_barras_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidoItemDetCodBarras");
          },
          /*close*/ () => {
            this.modalPedidoItemDetCodBarras(false);
          }
        );
      }
    },
    modalPedidoItemDetTipoEmbalagens(exibir) {
      this.exibirPedidoItemDetTipoEmbalagens = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_tipo_embalagens_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidoItemDetTipoEmbalagens");
          },
          /*close*/ () => {
            this.modalPedidoItemDetTipoEmbalagens(false);
          }
        );
      }
    },
    modalPedidoItemDetTolerancias(exibir) {
      this.exibirPedidoItemDetTolerancias = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_tolerancias_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidoItemDetTolerancias");
          },
          /*close*/ () => {
            this.modalPedidoItemDetTolerancias(false);
          }
        );
      }
    },
    modalPedidoItemDetPesagens(exibir) {
      this.exibirPedidoItemDetPesagens = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_item_det_pesagens_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPedidoItemDetPesagens");
          },
          /*close*/ () => {
            this.modalPedidoItemDetPesagens(false);
          }
        );
      }
    },
    modalLocaisPedido(exibir) {
      this.exibirLocaisPedido = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_locais_pedido_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarLocaisPedido");
          },
          /*close*/ () => {
            this.modalLocaisPedido(false);
          }
        );
      }
    },
    modalTiposPedido(exibir) {
      this.exibirTiposPedido = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tipos_pedido_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTiposPedido");
          },
          /*close*/ () => {
            this.modalTiposPedido(false);
          }
        );
      }
    },
    modalCategoriasPedido(exibir) {
      this.exibirCategoriasPedido = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_categorias_pedido_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCategoriasPedido");
          },
          /*close*/ () => {
            this.modalCategoriasPedido(false);
          }
        );
      }
    },
    modalSituacoesPedido(exibir) {
      this.exibirSituacoesPedido = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_situacoes_pedido_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarSituacoesPedido");
          },
          /*close*/ () => {
            this.modalSituacoesPedido(false);
          }
        );
      }
    },
    selecionarConta(conta) {
      this.pedido.id_conta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_contas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarContas");
          },
          /*close*/ () => {
            this.modalContas(false);
          }
        );
      }
    },
    selecionarCusto(custo) {
      this.pedido.id_custo = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_custos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCustos");
          },
          /*close*/ () => {
            this.modalCustos(false);
          }
        );
      }
    },
    tabFocus(idTab, idPage) {
      if (
        document.getElementById(idTab) != null &&
        document.getElementById(idPage) != null
      ) {
        var tabs = document.getElementsByClassName("nav-link-pedido");
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].classList.remove("active");
        }

        var pages = document.getElementsByClassName("tab-pane-pedido");
        for (var y = 0; y < pages.length; y++) {
          pages[y].classList.remove("show");
          pages[y].classList.remove("active");
        }

        document.getElementById(idTab).classList.add("active");
        document.getElementById(idPage).classList.add("show");
        document.getElementById(idPage).classList.add("active");
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async removerProduto(id, index) {
      this.loadingProduto = true;
      await this.$swal.showQuestionAlert(
        "Você deseja remover o produto selecionado?",
        (alert) => {
          if (alert.isConfirmed) {
            this.pedido.PedidoItem.splice(index, 1);
            toast.success("Produto removido com sucesso!", { timeout: 3000 });
            this.recalcularValores();
            this.nextFocus("InclusaoRapida");
          }
        }
      );
      this.loadingProduto = false;
    },
    atualizarDescontoTotalProduto(desconto) {
      if (desconto < 0) {
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].desconto =
          desconto * -1;
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].acrescimo = 0;
      } else {
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].desconto = 0;
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].acrescimo = desconto;
      }

      this.recalcularValores();
    },
    atualizarDescontoTotalPedido(desconto) {
      for (var p = 0; p < this.pedido.PedidoItem.length; p++) {
        var valorDesconto = 0;
        var valorAcrescimo = 0;
        var percentualProporcional =
          (this.pedido.PedidoItem[p].total * 100) / this.pedido.total;

        if (desconto < 0) {
          valorDesconto = (desconto * -1 * percentualProporcional) / 100;
          this.pedido.PedidoItem[p].desconto = valorDesconto;
          this.pedido.PedidoItem[p].acrescimo = 0;
        } else if (desconto === 0) {
          this.pedido.PedidoItem[p].desconto = 0;
          this.pedido.PedidoItem[p].acrescimo = 0;
        } else {
          this.pedido.PedidoItem[p].desconto = 0;
          valorAcrescimo = (desconto * percentualProporcional) / 100;
          this.pedido.PedidoItem[p].acrescimo = valorAcrescimo;
        }
      }

      this.recalcularValores();
    },
    calculaPercentualComissao() {
      this.pedido.comissao_per =
        (this.pedido.comissao_valor * 100) / this.pedido.total;
      this.recalcularValores();
    },
    calculaBaseST(index) {
      try {
        var item = this.pedido.PedidoItem[index];
        if (this.user.User.Emitente.crt === 1) {
          if (
            item.csosn &&
            item.csosn !== null &&
            (item.csosn !== "") & (item.csosn.length === 4)
          ) {
            let csosn = item.csosn.substring(1, 4);
            if (csosn === "101") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (
              csosn === "102" ||
              csosn === "103" ||
              csosn === "300" ||
              csosn === "400"
            ) {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (csosn === "201") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
            } else if (csosn === "202") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
            } else if (csosn === "500") {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            } else if (csosn === "900") {
              if (this.configuracao.st_90 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
              item.base_icms_sub = this.calculaBCST(index);
              item.total_icms_sub = this.calculaICMSST(index);
            } else {
              item.base_icms = 0;
              item.total_icms = 0;
              item.base_icms_sub = 0;
              item.total_icms_sub = 0;
            }
          }
        } else {
          if (item.st !== null && item.st !== "" && item.st.length === 3) {
            let st = item.st.substring(1, 3);
            if (st === "00") {
              if (this.configuracao.st_00 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "10") {
              if (this.configuracao.st_10 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "20") {
              if (this.configuracao.st_20 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "30") {
              if (this.configuracao.st_30 === "1") {
                item.base_icms = item.total;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "40") {
              if (this.configuracao.st_40 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "41") {
              if (this.configuracao.st_41 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "50") {
              if (this.configuracao.st_50 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "51") {
              if (this.configuracao.st_51 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "60") {
              if (this.configuracao.st_60 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
                item.base_icms_sub = 0;
                item.total_icms_sub = 0;
              }
            } else if (st === "70") {
              if (this.configuracao.st_70 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            } else if (st === "90") {
              if (this.configuracao.st_90 === "1") {
                item.base_icms = item.total - (item.total * item.reducao) / 100;
                item.total_icms = (item.base_icms * item.icms) / 100;
                item.base_icms_sub = this.calculaBCST(index);
                item.total_icms_sub = this.calculaICMSST(index);
              } else {
                item.base_icms = 0;
                item.total_icms = 0;
              }
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    calculaBCST(index) {
      try {
        var item = this.pedido.PedidoItem[index];
        var VALOR_BASE_CALCULO_ICMS = item.base_icms;
        var ALIQ_ICMS = item.icms;
        var VALOR_ICMS = item.total_icms;
        var VALOR_TOTAL_PRODUTOS = this.pedido.total_produtos;
        var VALOR_TOTAL_NOTA = this.pedido.total;
        var MVA = item.mva;
        var VALOR_UNITARIO = item.preco;
        var QTD = item.qtd;
        var DESCONTO = item.desconto;
        var ACRESCIMO = item.acrescimo;
        var VALOR_TOTAL_ITEM = item.total;
        var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
        var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
        var VALOR_IPI = item.ipi;
        var ALIQI = item.aliqi;

        var formula = this.configuracao.formula_basecalculo;

        if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
        }

        if (formula.toString().includes("ALIQ_ICMS")) {
          formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
        }

        if (formula.toString().includes("VALOR_ICMS")) {
          formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
        }

        if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
        }

        if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
        }

        if (formula.toString().includes("MVA")) {
          formula = formula.toString().replaceAll("MVA", MVA);
        }

        if (formula.toString().includes("VALOR_UNITARIO")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
        }

        if (formula.toString().includes("QTD")) {
          formula = formula.toString().replaceAll("QTD", QTD);
        }

        if (formula.toString().includes("DESCONTO")) {
          formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
        }

        if (formula.toString().includes("ACRESCIMO")) {
          formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
        }

        if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
        }

        if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
          formula = formula
            .toString()
            .replaceAll(
              "BASE_CALCULO_ICMS_SUBSTITUICAO",
              BASE_CALCULO_ICMS_SUBSTITUICAO
            );
        }

        if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
        }

        if (formula.toString().includes("VALOR_IPI")) {
          formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
        }

        if (formula.toString().includes("ALIQI")) {
          formula = formula.toString().replaceAll("ALIQI", ALIQI);
        }

        formula = formula.toString().replaceAll(" ", "").trim();

        var resultado = math.evaluate(formula);

        return resultado;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    calculaICMSST(index) {
      try {
        var item = this.pedido.PedidoItem[index];
        var VALOR_BASE_CALCULO_ICMS = item.base_icms;
        var ALIQ_ICMS = item.icms;
        var VALOR_ICMS = item.total_icms;
        var VALOR_TOTAL_PRODUTOS = this.pedido.total_produtos;
        var VALOR_TOTAL_NOTA = this.pedido.total;
        var MVA = item.mva;
        var VALOR_UNITARIO = item.preco;
        var QTD = item.qtd;
        var DESCONTO = item.desconto;
        var ACRESCIMO = item.acrescimo;
        var VALOR_TOTAL_ITEM = item.total;
        var BASE_CALCULO_ICMS_SUBSTITUICAO = item.base_icms_sub;
        var VALOR_ICMS_SUBSTITUICAO = item.total_icms_sub;
        var VALOR_IPI = item.ipi;
        var ALIQI = item.aliqi;

        var formula = this.configuracao.formula_icms_sub;

        if (formula.toString().includes("VALOR_BASE_CALCULO_ICMS")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_BASE_CALCULO_ICMS", VALOR_BASE_CALCULO_ICMS);
        }

        if (formula.toString().includes("ALIQ_ICMS")) {
          formula = formula.toString().replaceAll("ALIQ_ICMS", ALIQ_ICMS);
        }

        if (formula.toString().includes("VALOR_ICMS")) {
          formula = formula.toString().replaceAll("VALOR_ICMS", VALOR_ICMS);
        }

        if (formula.toString().includes("VALOR_TOTAL_PRODUTOS")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_PRODUTOS", VALOR_TOTAL_PRODUTOS);
        }

        if (formula.toString().includes("VALOR_TOTAL_NOTA")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_NOTA", VALOR_TOTAL_NOTA);
        }

        if (formula.toString().includes("MVA")) {
          formula = formula.toString().replaceAll("MVA", MVA);
        }

        if (formula.toString().includes("VALOR_UNITARIO")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_UNITARIO", VALOR_UNITARIO);
        }

        if (formula.toString().includes("QTD")) {
          formula = formula.toString().replaceAll("QTD", QTD);
        }

        if (formula.toString().includes("DESCONTO")) {
          formula = formula.toString().replaceAll("DESCONTO", DESCONTO);
        }

        if (formula.toString().includes("ACRESCIMO")) {
          formula = formula.toString().replaceAll("ACRESCIMO", ACRESCIMO);
        }

        if (formula.toString().includes("VALOR_TOTAL_ITEM")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_TOTAL_ITEM", VALOR_TOTAL_ITEM);
        }

        if (formula.toString().includes("BASE_CALCULO_ICMS_SUBSTITUICAO")) {
          formula = formula
            .toString()
            .replaceAll(
              "BASE_CALCULO_ICMS_SUBSTITUICAO",
              BASE_CALCULO_ICMS_SUBSTITUICAO
            );
        }

        if (formula.toString().includes("VALOR_ICMS_SUBSTITUICAO")) {
          formula = formula
            .toString()
            .replaceAll("VALOR_ICMS_SUBSTITUICAO", VALOR_ICMS_SUBSTITUICAO);
        }

        if (formula.toString().includes("VALOR_IPI")) {
          formula = formula.toString().replaceAll("VALOR_IPI", VALOR_IPI);
        }

        if (formula.toString().includes("ALIQI")) {
          formula = formula.toString().replaceAll("ALIQI", ALIQI);
        }

        formula = formula.toString().replaceAll(" ", "").trim();

        var resultado = math.evaluate(formula);

        return resultado;
      } catch (error) {
        console.log(error);
        return 0;
      }
    },
    recalcularValores() {
      var totalProdutos = 0;
      var totalDescontos = 0;
      var totalAcrescimos = 0;
      var totalBaseICMS = 0;
      var totalValorICMS = 0;
      var totalBaseICMSST = 0;
      var totalValorICMSST = 0;
      var totalIPI = 0;
      var totalPesoBruto = 0;
      var totalPesoLiquido = 0;

      if (this.addItemBranco === false) {
        var itensRemover = this.pedido.PedidoItem.filter(function (obj) {
          return obj.em_branco === true;
        });

        if (itensRemover.length > 0) {
          itensRemover.forEach((item) => {
            this.pedido.PedidoItem.splice(
              this.pedido.PedidoItem.indexOf(item),
              1
            );
          });
        }
      }

      for (var i = 0; i < this.pedido.PedidoItem.length; i++) {
        var item = this.pedido.PedidoItem[i];
        var totalSubItens = 0;
        for (var y = 0; y < item.PedidoSubItem.length; y++) {
          var subItem = item.PedidoSubItem[y];
          subItem.total = subItem.qtd * subItem.preco;
          totalSubItens += subItem.total;
        }

        item.total_sub_itens = item.qtd * totalSubItens;

        item.total =
          item.qtd * item.preco +
          item.total_sub_itens -
          item.desconto +
          item.acrescimo;

        item.total_ipi = (item.total * item.ipi) / 100;

        totalProdutos += item.total;
        totalDescontos += item.desconto;
        totalAcrescimos += item.acrescimo;
        totalIPI += item.total_ipi;

        if (item.peso_bruto > 0) {
          totalPesoBruto += item.qtd * item.peso_bruto;
        } else {
          totalPesoBruto += item.qtd * item.Produto.peso;
        }

        if (item.peso_liquido > 0) {
          totalPesoLiquido += item.qtd * item.peso_liquido;
        } else {
          totalPesoLiquido += item.qtd * item.Produto.peso_liquido;
        }
      }

      this.pedido.total_produtos = totalProdutos;
      this.pedido.total_descontos = totalDescontos;
      this.pedido.total_acrescimo = totalAcrescimos;
      this.pedido.total_ipi = totalIPI;
      this.pedido.peso_bruto = totalPesoBruto;
      this.pedido.peso_liquido = totalPesoLiquido;

      this.pedido.total =
        this.pedido.total_produtos +
        this.pedido.total_outras +
        this.pedido.total_frete +
        this.pedido.total_seguro +
        this.pedido.total_ipi;

      //Ratear valores Frete, Seguro e Outras
      for (var p = 0; p < this.pedido.PedidoItem.length; p++) {
        var it = this.pedido.PedidoItem[p];
        var valorFrete = 0;
        var valorOutras = 0;
        var valorSeguro = 0;
        var percentualProporcional = (it.total * 100) / totalProdutos;

        valorFrete = (this.pedido.total_frete * percentualProporcional) / 100;
        it.valor_frete = valorFrete;

        valorOutras = (this.pedido.total_outras * percentualProporcional) / 100;
        it.valor_outras = valorOutras;

        valorSeguro = (this.pedido.total_seguro * percentualProporcional) / 100;
        it.valor_seguro = valorSeguro;

        this.calculaBaseST(p);
        totalBaseICMS += it.base_icms;
        totalValorICMS += it.total_icms;
        totalBaseICMSST += it.base_icms_sub;
        totalValorICMSST += it.total_icms_sub;
      }

      this.pedido.base_icms = totalBaseICMS;
      this.pedido.total_icms = totalValorICMS;
      this.pedido.base_icms_sub = totalBaseICMSST;
      this.pedido.total_icms_sub = totalValorICMSST;

      if (
        this.pedido.utiliza_icms_sub === true ||
        this.pedido.utiliza_icms_sub === "1"
      ) {
        this.pedido.total =
          this.pedido.total_produtos +
          this.pedido.total_outras +
          this.pedido.total_frete +
          this.pedido.total_seguro +
          this.pedido.total_ipi +
          this.pedido.total_icms_sub;
      }

      this.pedido.comissao_valor =
        (this.pedido.comissao_per * this.pedido.total) / 100;
    },
    modalAlterarPrecoVenda(exibir) {
      this.exibirAlterarPrecoVenda = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_alterar_preco_venda",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorAlteracao");
          },
          /*close*/ () => {
            this.modalAlterarPrecoVenda(false);
          }
        );
      }
    },
    modalDesconto(exibir) {
      this.exibirDesconto = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_desconto",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorDesconto");
          },
          /*close*/ () => {
            this.modalDesconto(false);
          }
        );
      }
    },
    editarTotalProduto(index) {
      this.indexEdicaoPedidoItem = index;
      var item = this.pedido.PedidoItem[index];
      if (item.qtd === 0) {
        toast.info("A quantidade do produto está zerada!", { timeout: 3000 });
      } else if (item.preco === 0) {
        toast.info("O valor do produto está zerado!", { timeout: 3000 });
      } else {
        this.labelTotal = "Valor Total do Produto";
        this.totalDescontoModal = item.total + item.desconto - item.acrescimo;
        this.exibirRemoverDesconto = false;
        this.modalDesconto(true);
      }
    },
    editarTotalPedido() {
      if (this.pedido.total === 0) {
        toast.info("O valor total do Pedido está zerado!", { timeout: 3000 });
      } else {
        this.labelTotal = "Valor Total do Pedido";
        this.totalDescontoModal =
          this.pedido.total +
          this.pedido.total_descontos -
          this.pedido.total_acrescimo;
        this.exibirRemoverDesconto = true;
        this.modalDesconto(true);
      }
    },
    confirmarDesconto(desconto, label) {
      if (label === "Valor Total do Pedido") {
        this.atualizarDescontoTotalPedido(desconto);
      } else if (label === "Valor Total do Produto") {
        this.atualizarDescontoTotalProduto(desconto);
      }
    },
    removerDesconto(label) {
      if (label === "Valor Total do Pedido") {
        this.atualizarDescontoTotalPedido(0);
      }
      this.modalDesconto(false);
    },
    adicionarPagamento(pagamento) {
      this.pedido.PedidoPagamento.push(pagamento);
      setTimeout(MenuComponent.reinitialization, 500);
      toast.success("Pagamento adicionado com sucesso!", { timeout: 2000 });
      this.recalcularValores();
    },
    editarPagamento() {
      toast.success("Pagamento alterado com sucesso!", { timeout: 2000 });
      this.recalcularValores();
    },
    modalPedidoPagamento(exibir) {
      this.exibirPedidoPagamento = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_pagamento_editar",
          /*open*/ () => {
            this.$utils.requestFocus("txtValorPagamento");
          },
          /*close*/ () => {
            this.modalPedidoPagamento(false);
          }
        );
      }
    },
    adicionarPedidoPagamento() {
      if (this.pedido.total === 0) {
        toast.info("O valor total do Pedido está zerado!", { timeout: 3000 });
      } else {
        this.indexPedidoPagamento = -1;
        this.modalPedidoPagamento(true);
      }
    },
    editarPedidoPagamento(index) {
      this.indexPedidoPagamento = index;
      this.modalPedidoPagamento(true);
    },
    async removerPagamento(id, index) {
      this.loadingPagamento = true;

      this.pedido.PedidoPagamento.splice(index, 1);
      toast.success("Pagamento excluído com sucesso!", { timeout: 2000 });
      this.recalcularValores();
      this.loadingPagamento = false;
    },
    adicionarPedidoReceber() {
      if (this.pedido.total === 0) {
        toast.info("O valor total do Pedido está zerado!", { timeout: 3000 });
      } else {
        this.modalPedidoReceber(true);
      }
    },
    modalPedidoReceber(exibir) {
      this.exibirPedidoReceber = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_pedido_receber_editar",
          /*open*/ () => {
            this.$utils.requestFocus("qtdParcelas");
          },
          /*close*/ () => {
            this.modalPedidoReceber(false);
          }
        );
      }
    },
    confirmarParcelamento(condicao) {
      if (condicao != null) {
        this.pedido.id_condicao = condicao.id_condicao;
        this.pedido.Condicao.condicoes = condicao.condicoes;
      } else {
        this.pedido.id_condicao = null;
        this.pedido.Condicao.condicoes = "";
      }
      this.modalPedidoReceber(false);
    },
    selecionarTelefone(telefone) {
      this.modalCliente(false);
      this.pedido.PedidoCliente.telefone = telefone;
      toast.info("Telefone selecionado com sucesso!", { timeout: 2000 });
    },
    selecionarEmail(email) {
      this.modalCliente(false);
      this.pedido.PedidoCliente.email = email;
      toast.info("Email selecionado com sucesso!", { timeout: 2000 });
    },
    selecionarEndereco(endereco) {
      if (this.pesquisaEnderecoIndex === 0) {
        this.pedido.PedidoCliente.PedidoEndereco.id_cliente_endereco =
          endereco.id;
        this.pedido.PedidoCliente.PedidoEndereco.descricao = endereco.descricao;
        this.pedido.PedidoCliente.PedidoEndereco.endereco = endereco.endereco;
        this.pedido.PedidoCliente.PedidoEndereco.complemento =
          endereco.complemento;
        this.pedido.PedidoCliente.PedidoEndereco.bairro = endereco.bairro;
        this.pedido.PedidoCliente.PedidoEndereco.numero = endereco.numero;
        this.pedido.PedidoCliente.PedidoEndereco.cep = endereco.cep;
        this.pedido.PedidoCliente.PedidoEndereco.cidade = endereco.cidade;
        this.pedido.PedidoCliente.PedidoEndereco.cod_cidade =
          endereco.cod_cidade;
        this.pedido.PedidoCliente.PedidoEndereco.uf = endereco.uf;
        this.pedido.PedidoCliente.PedidoEndereco.pais = endereco.pais;
        this.pedido.PedidoCliente.PedidoEndereco.cod_pais = endereco.cod_pais;
        this.pedido.PedidoCliente.PedidoEndereco.latitude = endereco.latitude;
        this.pedido.PedidoCliente.PedidoEndereco.longitude = endereco.longitude;
      }
      if (this.pesquisaEnderecoIndex === 1) {
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.id_cliente_endereco =
          endereco.id;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.descricao =
          endereco.descricao;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.endereco =
          endereco.endereco;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.complemento =
          endereco.complemento;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.bairro =
          endereco.bairro;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.numero =
          endereco.numero;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cep = endereco.cep;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cidade =
          endereco.cidade;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_cidade =
          endereco.cod_cidade;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.uf = endereco.uf;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.pais = endereco.pais;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_pais =
          endereco.cod_pais;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.latitude =
          endereco.latitude;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.longitude =
          endereco.longitude;
      }

      toast.info("Endereço selecionado com sucesso!", { timeout: 2000 });

      if (this.add === true && this.pedido.PedidoItem.length === 0) {
        this.tabFocus("tabProduto", "kt_pedido_produto");
        this.nextFocus("InclusaoRapida");
      }

      this.modalCliente(false);
    },
    modalCliente(exibir) {
      this.exibirCliente = exibir;
    },
    exibirTelefones() {
      this.idCliente = this.pedido.PedidoCliente.id_cliente;
      this.idModalCliente = 0;
      this.modalCliente(true);
      getOrCreateInstanceModal(
        "kt_modal_cliente_telefones",
        /*open*/ () => {
          this.$utils.requestFocus("kt_modal_cliente_telefones");
        },
        /*close*/ () => {
          this.modalCliente(false);
        }
      );
    },
    exibirEmails() {
      this.idCliente = this.pedido.PedidoCliente.id_cliente;
      this.idModalCliente = 1;
      this.modalCliente(true);
      getOrCreateInstanceModal(
        "kt_modal_cliente_emails",
        /*open*/ () => {
          this.$utils.requestFocus("kt_modal_cliente_emails");
        },
        /*close*/ () => {
          this.modalCliente(false);
        }
      );
    },
    exibirEnderecos(index) {
      this.pesquisaEnderecoIndex = index;
      this.idCliente = this.pedido.PedidoCliente.id_cliente;
      this.idModalCliente = 2;
      this.modalCliente(true);
      getOrCreateInstanceModal(
        "kt_modal_cliente_enderecos",
        /*open*/ () => {
          this.$utils.requestFocus("kt_modal_cliente_enderecos");
        },
        /*close*/ () => {
          this.modalCliente(false);
        }
      );
    },
    async cancelarPedido() {
      this.limparPedidoLocalStorage(this.user.User.id, this.pedido.id);
      if (this.pedido.id !== 0) {
        await this.deleteControleEdicao(this.pedido.id);
      }

      if (this.modal === true) {
        this.$emit("cancelarPedido", false);
      } else {
        this.$router.push("/movimentacao/pedidos/consultar");
      }
    },
    async confirmarPedido() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.loading = true;
      this.confirmouCadastro = true;

      if ((await this.validar()) === true) {
        this.pedido.PedidoCliente.cpf_cnpj = this.$utils.unMask(
          this.pedido.PedidoCliente.cpf_cnpj
        );
        this.pedido.PedidoCliente.rg_ie = this.$utils.unMask(
          this.pedido.PedidoCliente.rg_ie
        );

        this.pedido.peso_bruto =
          this.pedido.peso_bruto != null
            ? this.pedido.peso_bruto.toString()
            : "0";
        this.pedido.peso_liquido =
          this.pedido.peso_liquido != null
            ? this.pedido.peso_liquido.toString()
            : "0";

        this.pedido.prazo_dias =
          this.pedido.prazo_dias != null
            ? this.pedido.prazo_dias.toString()
            : "0";

        this.pedido.utiliza_icms_sub = this.$utils.booleanToString(
          this.pedido.utiliza_icms_sub
        );

        for (var y = 0; y < this.pedido.PedidoAnexo.length; y++) {
          if (this.pedido.PedidoAnexo[y].status === "ready") {
            this.pedido.PedidoAnexo[y].guid = this.$utils.generateUuidv4();
            this.pedido.PedidoAnexo[y].nome_arquivo =
              this.pedido.PedidoAnexo[y].name;
            this.pedido.PedidoAnexo[y].formFile =
              this.pedido.PedidoAnexo[y].raw;
          } else {
            this.pedido.PedidoAnexo[y].caminho_arquivo =
              this.pedido.PedidoAnexo[y].caminho_arquivo.replace(
                this.$utils.getUrl(),
                ""
              );
            if (this.pedido.PedidoAnexo[y].status === "delete") {
              this.pedido.PedidoAnexo[y].arquivoRemover =
                this.pedido.PedidoAnexo[y].caminho_arquivo.replace(
                  this.$utils.getUrl(),
                  ""
                );
            }
          }
        }

        if (this.pedido.id === 0) {
          this.pedido.guid = this.$utils.generateUuidv4();
          this.pedido.operador = this.user.User.id;
          var formData = this.$utils.convertModelToFormData(this.pedido);
          try {
            var ret = await this.$store.dispatch("pedido/postPedido", formData);
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJsonAtalho(error, pedidoMapper)
            );
            this.errosGerais = error;
            this.errosValidacao = error;
            this.confirmouCadastro = false;
          }
        } else {
          var formDataPut = this.$utils.convertModelToFormData(this.pedido);
          try {
            var retPut = await this.$store.dispatch(
              "pedido/putPedido",
              formDataPut
            );
          } catch (error) {
            this.errosValidacaoGeral.push(
              ...this.$utils.retornarValoresJsonAtalho(error, pedidoMapper)
            );
            this.errosGerais = error;
            this.errosValidacao = error;
            this.confirmouCadastro = false;
          }
        }

        if (this.errosGerais.Message) {
          this.scroll("errosGerais");
        }

        this.pedido.utiliza_icms_sub = this.$utils.stringToBoolean(
          this.pedido.utiliza_icms_sub
        );

        this.pedido.peso_bruto =
          this.pedido.peso_bruto != null
            ? parseFloat(this.pedido.peso_bruto)
            : 0;
        this.pedido.peso_liquido =
          this.pedido.peso_liquido != null
            ? parseFloat(this.pedido.peso_liquido)
            : 0;

        if (this.confirmouCadastro === true) {
          toast.success("Pedido salvo com sucesso!", { timeout: 2000 });
          setTimeout(async () => {
            this.limparPedidoLocalStorage(this.user.User.id, this.pedido.id);
            if (this.pedido.id !== 0) {
              await this.deleteControleEdicao(this.pedido.id);
            }
          }, 500);
          if (this.modal === true) {
            this.$emit("confirmarPedido");
          } else {
            this.$router.push("/movimentacao/pedidos/consultar");
          }
        } else {
          toast.error("Ocorreu uma falha ao gravar o pedido, verifique!", {
            timeout: 5000,
          });
        }
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }
      this.loading = false;
      setTimeout(MenuComponent.reinitialization, 500);
    },
    async validar() {
      let result = true;

      if (!this.$utils.isInteger(this.pedido.prazo_dias)) {
        this.atualizarErrosValidacao(
          `prazo_dias`,
          "O prazo de dias é inválido",
          pedidoMapper.prazo_dias[0],
          pedidoMapper.prazo_dias[1],
          ""
        );
        result = false;
      }

      if (
        this.pedido.data_emissao === null ||
        this.pedido.data_emissao === ""
      ) {
        this.atualizarErrosValidacao(
          `data_emissao`,
          "A data de emissão é inválida",
          pedidoMapper.data_emissao[0],
          pedidoMapper.data_emissao[1],
          ""
        );
        result = false;
      }

      if (
        this.pedido.data_entrega === null ||
        this.pedido.data_entrega === ""
      ) {
        this.atualizarErrosValidacao(
          `data_entrega`,
          "A data de saída/entrega é inválida",
          pedidoMapper.data_entrega[0],
          pedidoMapper.data_entrega[1],
          ""
        );
        result = false;
      }

      if (
        this.pedido.PedidoCliente.cpf_cnpj != null &&
        this.pedido.PedidoCliente.cpf_cnpj != "" &&
        !this.$utils.validarCPFCNPJ(this.pedido.PedidoCliente.cpf_cnpj)
      ) {
        this.atualizarErrosValidacao(
          `PedidoClientecpf_cnpj`,
          "O CPF / CNPJ é inválido",
          pedidoMapper.PedidoClientecpf_cnpj[0],
          pedidoMapper.PedidoClientecpf_cnpj[1],
          ""
        );
        result = false;
      }

      if (
        this.pedido.PedidoCliente.email != null &&
        this.pedido.PedidoCliente.email != "" &&
        this.$utils.checkEmail(this.pedido.PedidoCliente.email)
      ) {
        this.atualizarErrosValidacao(
          `PedidoClienteemail`,
          "O email é inválido",
          pedidoMapper.PedidoClienteemail[0],
          pedidoMapper.PedidoClienteemail[1],
          ""
        );
        result = false;
      }

      if (this.pedido.PedidoItem.length === 0) {
        this.atualizarErrosValidacao(
          `InclusaoRapida`,
          "Não é permitido gravar um pedido sem produtos!",
          pedidoMapper.InclusaoRapida[0],
          pedidoMapper.InclusaoRapida[1],
          ""
        );
        result = false;
      }

      for (let index in this.pedido.PedidoItem) {
        if (this.user.User.Emitente.crt !== 1) {
          await this.verificarCST(`PedidoItem[${index}]st`, index, true);
          if (this.getErrorByID(`PedidoItem[${index}]st`)) {
            this.atualizarErrosValidacao(
              `PedidoItem[${index}]st`,
              this.getErrorByID(`PedidoItem[${index}]st`),
              pedidoMapper.PedidoItemst[0],
              pedidoMapper.PedidoItemst[1],
              ""
            );
            result = false;
          }
        } else {
          await this.verificarCSOSN(`PedidoItem[${index}]csosn`, index, true);
          if (this.getErrorByID(`PedidoItem[${index}]csosn`)) {
            this.atualizarErrosValidacao(
              `PedidoItem[${index}]csosn`,
              this.getErrorByID(`PedidoItem[${index}]csosn`),
              pedidoMapper.PedidoItemcsosn[0],
              pedidoMapper.PedidoItemcsosn[1],
              ""
            );
            result = false;
          }
        }
      }

      for (let index in this.pedido.PedidoReceber) {
        let item = this.pedido.PedidoReceber[index];
        if (item.vencimento === null || item.vencimento === "") {
          this.atualizarErrosValidacao(
            `PedidoReceber[${index}]vencimento`,
            "A data de vencimento é inválida",
            pedidoMapper.PedidoRecebervencimento[0],
            pedidoMapper.PedidoRecebervencimento[1],
            ""
          );
          result = false;
        }
      }

      if (
        this.pedido.ped_compra != null &&
        this.pedido.ped_compra != "" &&
        (this.pedido.data_ped_compra === null ||
          this.pedido.data_ped_compra === "")
      ) {
        this.atualizarErrosValidacao(
          `data_ped_compra`,
          "A data do pedido de compra é inválida",
          pedidoMapper.data_ped_compra[0],
          pedidoMapper.data_ped_compra[1],
          pedidoMapper.data_ped_compra[2]
        );
        result = false;
      }

      return result;
    },
    atualizarErrosValidacao(id, error, idTab, idPage, click) {
      this.errosValidacao[id] = error;
      this.errosValidacaoGeral.push({
        error: this.getErrorByID(id),
        elemento: id,
        tab: idTab,
        tabID: idPage,
        onClick: click,
      });
    },
    async modalClientes(exibir) {
      this.exibirClientes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_clientes_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarClientes");
          },
          /*close*/ () => {
            this.modalClientes(false);
          }
        );
      } else {
        if (this.pedido.PedidoCliente.id_cliente === null) {
          await this.$swal.showQuestionAlert(
            "Para realizar o pedido um cliente deve ser informado! Deseja continuar?",
            (alert) => {
              if (alert.isConfirmed) {
                this.modalClientes(true);
              } else {
                this.cancelarPedido();
              }
            }
          );
        }
      }
    },
    async selecionarCliente(cliente) {
      this.pedido.PedidoCliente.id_cliente = cliente.id;
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("cliente/getCliente", cliente.id);
        if (ret.Success === true) {
          cliente = ret.Data;
          this.pedido.PedidoCliente.Cliente = cliente;
          this.pedido.PedidoCliente.id_cliente = cliente.id;
          this.pedido.PedidoCliente.nome = cliente.nome;
          this.pedido.PedidoCliente.cpf_cnpj = cliente.cpf_cnpj;
          this.pedido.PedidoCliente.rg_ie = cliente.rg_ie;

          if (cliente.ClienteTelefone.length > 0) {
            this.pedido.PedidoCliente.telefone =
              cliente.ClienteTelefone[0].telefone;
          } else {
            this.pedido.PedidoCliente.telefone = "";
          }

          if (cliente.ClienteEmail.length > 0) {
            this.pedido.PedidoCliente.email = cliente.ClienteEmail[0].email;
          } else {
            this.pedido.PedidoCliente.email = "";
          }

          if (cliente.ClienteEndereco.length > 0) {
            this.pedido.PedidoCliente.PedidoEndereco.id_cliente_endereco =
              cliente.ClienteEndereco[0].id;
            this.pedido.PedidoCliente.PedidoEndereco.descricao =
              cliente.ClienteEndereco[0].descricao;
            this.pedido.PedidoCliente.PedidoEndereco.endereco =
              cliente.ClienteEndereco[0].endereco;
            this.pedido.PedidoCliente.PedidoEndereco.complemento =
              cliente.ClienteEndereco[0].complemento;
            this.pedido.PedidoCliente.PedidoEndereco.bairro =
              cliente.ClienteEndereco[0].bairro;
            this.pedido.PedidoCliente.PedidoEndereco.numero =
              cliente.ClienteEndereco[0].numero;
            this.pedido.PedidoCliente.PedidoEndereco.cep =
              cliente.ClienteEndereco[0].cep;
            this.pedido.PedidoCliente.PedidoEndereco.cidade =
              cliente.ClienteEndereco[0].cidade;
            this.pedido.PedidoCliente.PedidoEndereco.cod_cidade =
              cliente.ClienteEndereco[0].cod_cidade;
            this.pedido.PedidoCliente.PedidoEndereco.uf =
              cliente.ClienteEndereco[0].uf;
            this.pedido.PedidoCliente.PedidoEndereco.pais =
              cliente.ClienteEndereco[0].pais;
            this.pedido.PedidoCliente.PedidoEndereco.cod_pais =
              cliente.ClienteEndereco[0].cod_pais;
            this.pedido.PedidoCliente.PedidoEndereco.latitude =
              cliente.ClienteEndereco[0].latitude;
            this.pedido.PedidoCliente.PedidoEndereco.longitude =
              cliente.ClienteEndereco[0].longitude;

            this.pedido.PedidoCliente.PedidoEnderecoEntrega.id_cliente_endereco =
              cliente.ClienteEndereco[0].id;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.descricao =
              cliente.ClienteEndereco[0].descricao;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.endereco =
              cliente.ClienteEndereco[0].endereco;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.complemento =
              cliente.ClienteEndereco[0].complemento;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.bairro =
              cliente.ClienteEndereco[0].bairro;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.numero =
              cliente.ClienteEndereco[0].numero;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.cep =
              cliente.ClienteEndereco[0].cep;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.cidade =
              cliente.ClienteEndereco[0].cidade;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_cidade =
              cliente.ClienteEndereco[0].cod_cidade;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.uf =
              cliente.ClienteEndereco[0].uf;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.pais =
              cliente.ClienteEndereco[0].pais;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_pais =
              cliente.ClienteEndereco[0].cod_pais;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.latitude =
              cliente.ClienteEndereco[0].latitude;
            this.pedido.PedidoCliente.PedidoEnderecoEntrega.longitude =
              cliente.ClienteEndereco[0].longitude;
          } else {
            this.pedido.PedidoCliente.PedidoEndereco = JSON.parse(
              JSON.stringify(pedidoInicializado.PedidoCliente.PedidoEndereco)
            );

            this.pedido.PedidoCliente.PedidoEnderecoEntrega = JSON.parse(
              JSON.stringify(
                pedidoInicializado.PedidoCliente.PedidoEnderecoEntrega
              )
            );
          }

          toast.info("Cliente selecionado com sucesso!", {
            timeout: 2000,
          });

          this.modalClientes(false);

          if (this.add === true && this.pedido.PedidoItem.length === 0) {
            this.tabFocus("tabProduto", "kt_pedido_produto");
            this.nextFocus("InclusaoRapida");
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    modalEditarProdutoObservacoes(exibir) {
      this.exibirEditarProdutoObservacoes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_produto_observacoes",
          /*open*/ () => {
            this.$utils.requestFocus(
              `PedidoItem[${this.indexEdicaoPedidoItem}]observacao`
            );
          },
          /*close*/ () => {
            this.modalEditarProdutoObservacoes(false);
          }
        );
      }
    },
    editarObservacoesProduto(index) {
      this.indexEdicaoPedidoItem = this.$utils.isInteger(index)
        ? index
        : this.indices[0];
      this.observacaoPedidoItem =
        this.pedido.PedidoItem[this.indexEdicaoPedidoItem].observacao;
      this.modalEditarProdutoObservacoes(true);
    },
    confirmarObservacoesProduto() {
      this.pedido.PedidoItem[this.indexEdicaoPedidoItem].observacao =
        this.observacaoPedidoItem;
      this.indexEdicaoPedidoItem = -1;
      this.modalEditarProdutoObservacoes(false);

      toast.info("Produto atualizado com sucesso!", {
        timeout: 2000,
      });
    },
    modalEstoques(exibir) {
      this.exibirEstoques = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_estoques",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEstoques");
          },
          /*close*/ () => {
            this.modalEstoques(false);
          }
        );
      }
    },
    async editarEstoque(index) {
      try {
        var ret = await this.$store.dispatch(
          "produto/getProduto",
          this.pedido.PedidoItem[index].id_produto
        );
        if (ret.Success === true) {
          var prod = ret.Data;
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.promocaoAtiva === true) {
            if (this.pedido.PedidoItem[index].preco !== prod.preco_promocao) {
              prod.promocaoAtiva = false;
              prod.preco = this.pedido.PedidoItem[index].preco;
            }
          } else {
            prod.preco = this.pedido.PedidoItem[index].preco;
          }
          prod.qtd = this.pedido.PedidoItem[index].qtd;
          prod.id_estoque = this.pedido.PedidoItem[index].id_estoque;
          prod.observacao = this.pedido.PedidoItem[index].observacao;
          this.produtoEstoque =
            prod.Adicional != null
              ? this.preencheAdicionalEdicao(prod, index)
              : prod;
          this.addPedidoItem = false;
          this.indexEdicaoPedidoItem = index;
          this.modalEstoques(true);
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    confirmarEstoque(produto, add, index) {
      this.modalEstoques(false);
      this.preencheProdutoSelecionado(produto, add, index);
    },
    modalAdicional(exibir) {
      this.exibirAdicional = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicional_produto",
          /*open*/ () => {
            this.$utils.requestFocusSelect(`Qtd`);
          },
          /*close*/ () => {
            this.modalAdicional(false);
          }
        );
      }
    },
    async editarAdicional(index) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch(
          "produto/getProduto",
          this.pedido.PedidoItem[index].id_produto
        );
        if (ret.Success === true) {
          var prod = ret.Data;
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.promocaoAtiva === true) {
            if (this.pedido.PedidoItem[index].preco !== prod.preco_promocao) {
              prod.promocaoAtiva = false;
              prod.preco = this.pedido.PedidoItem[index].preco;
            }
          } else {
            prod.preco = this.pedido.PedidoItem[index].preco;
          }
          prod.qtd = this.pedido.PedidoItem[index].qtd;
          prod.id_estoque = this.pedido.PedidoItem[index].id_estoque;
          this.adicionalProduto = this.preencheAdicionalEdicao(prod, index);
          this.addPedidoItem = false;
          this.indexEdicaoPedidoItem = index;
          this.modalAdicional(true);
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    preencheAdicionalEdicao(prod, index) {
      for (var i = 0; i < prod.Adicional.AdicionalGrupo.length; i++) {
        for (
          var y = 0;
          y < prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
          y++
        ) {
          for (
            var z = 0;
            z < this.pedido.PedidoItem[index].PedidoSubItem.length;
            z++
          ) {
            if (
              this.pedido.PedidoItem[index].PedidoSubItem[z]
                .id_adicional_grupo_item ===
              prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].id
            ) {
              prod.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y].qtd =
                this.pedido.PedidoItem[index].PedidoSubItem[z].qtd;
            }
          }
        }
      }

      prod.observacao =
        this.pedido.PedidoItem[index].observacao.split("Obs: ")[1];

      return prod;
    },
    async confirmarAdicional(produto, add, index) {
      this.modalAdicional(false);
      this.preencheProdutoSelecionado(produto, add, index);
    },

    modalProdutos(exibir) {
      this.exibirProdutos = exibir;
      import("@/views/produtos/ProdutosModal.vue").then((module) => {
        this.modalComponent = markRaw(module.default);
      });
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal(
            "kt_modal_produtos_consultar",
            /*open*/ () => {
              this.$utils.requestFocus("txtPesquisarProdutos");
            },
            /*close*/ () => {
              this.modalProdutos(false);
              this.$utils.requestFocus("InclusaoRapida");
            }
          );
        }, 100);
      }
    },
    modalProdutosBrinde(exibir) {
      this.exibirProdutosBrinde = exibir;
      import("@/views/produtos/ProdutosModal.vue").then((module) => {
        this.modalComponent = markRaw(module.default);
      });
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal(
            "kt_modal_produtos_consultar",
            /*open*/ () => {
              this.$utils.requestFocus("txtPesquisarProdutos");
            },
            /*close*/ () => {
              this.modalProdutosBrinde(false);
            }
          );
        }, 100);
      }
    },
    selecionarProdutoBrinde(produto) {
      this.nomeProdutoBrinde = produto.nome;
      this.qtdProdutoBrinde = 1;
      this.produtoBrinde = produto;
      setTimeout(() => {
        this.nextFocus("qtdProdutoBrinde");
      }, 500);
    },
    async selecionarProduto(produto) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("produto/getProduto", produto.id);
        if (ret.Success === true) {
          var prod = ret.Data;
          if (produto.brinde === undefined || produto.brinde === null) {
            prod.brinde = "N";
          } else {
            prod.brinde = produto.brinde;
            prod.qtd = produto.qtd;
          }
          prod.promocaoAtiva = this.verificarPromocaoAtiva(prod);
          if (prod.Estoque != null && prod.Estoque.length > 0) {
            prod.id_estoque = prod.Estoque[0].id;
          }
          if (prod.Adicional != null) {
            this.adicionalProduto = prod;
            this.addPedidoItem = true;
            this.indexEdicaoPedidoItem = -1;
            this.modalAdicional(true);
          } else {
            if (prod.Estoque != null && prod.Estoque.length > 1) {
              this.produtoEstoque = prod;
              this.addPedidoItem = true;
              this.indexEdicaoPedidoItem = -1;
              this.modalEstoques(true);
            } else {
              this.preencheProdutoSelecionado(prod, true, -1);
            }
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
    },
    atualizarAdicionarExcluirProduto() {
      this.nextFocus(`pesquisaAdicionarExcluirProduto`);

      var radioIncluirExcluir = document.getElementsByName("rbIncluirExcluir");
      if (radioIncluirExcluir[1].checked) {
        this.exibirLabelRadioExcluir = true;
      } else {
        this.exibirLabelRadioExcluir = false;
      }
    },
    async adicionarExcluirProduto() {
      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];
      if (this.pesquisaAdicionarExcluirProduto != "") {
        var radioIncluirExcluir =
          document.getElementsByName("rbIncluirExcluir");

        var radio = document.getElementsByName(
          "rbPesquisaAdicionarExcluirProduto"
        );

        if (
          radio[0].checked &&
          this.$utils.isNumber(this.pesquisaAdicionarExcluirProduto)
        ) {
          //Pesquisa código
          filterOdata =
            "&$filter=id eq " + this.pesquisaAdicionarExcluirProduto;
        }
        if (radio[1].checked) {
          //Pesquisa barras
          filterOdata =
            "&$filter=ean eq '" + this.pesquisaAdicionarExcluirProduto + "'";
        }
        if (filterOdata != "") {
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              var produto = retOdata.value[0];
              if (radioIncluirExcluir[0].checked) {
                this.selecionarProduto(produto);
              } else {
                const index = Object.keys(this.pedido.PedidoItem).find(
                  (key) => this.pedido.PedidoItem[key].Produto.id === produto.id
                );
                if (index !== undefined) {
                  await this.removerProduto(
                    this.pedido.PedidoItem[index].id,
                    index
                  );
                  this.pesquisaAdicionarExcluirProduto = "";
                  this.nextFocus("pesquisaAdicionarExcluirProduto");
                } else {
                  await this.$swal.showInvalidAlert(
                    "Nenhum Produto para exclusão foi encontrado com o código informado!",
                    (alert) => {
                      this.pesquisaAdicionarExcluirProduto = "";
                      this.$utils.requestFocus(
                        "pesquisaAdicionarExcluirProduto"
                      );
                    }
                  );
                }
              }
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!",
                (alert) => {
                  this.pesquisaAdicionarExcluirProduto = "";
                  this.$utils.requestFocus("pesquisaAdicionarExcluirProduto");
                }
              );
            }
          } catch (error) {
            this.errosGerais = error;
          }
        } else {
          this.errosValidacao = {
            pesquisaAdicionarExcluirProduto: "Verifique o código do produto",
          };
        }
      } else {
        this.errosValidacao = {
          pesquisaAdicionarExcluirProduto: "Informe o código do produto",
        };
      }
    },
    async inclusaoRapidaProduto() {
      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];
      if (this.pesquisaProduto != "") {
        var radio = document.getElementsByName("rbPesquisaRapida");
        if (radio[0].checked && this.$utils.isNumber(this.pesquisaProduto)) {
          //Pesquisa código
          filterOdata = "&$filter=id eq " + this.pesquisaProduto;
        }
        if (radio[1].checked) {
          //Pesquisa barras
          filterOdata = "&$filter=ean eq '" + this.pesquisaProduto + "'";
        }
        if (filterOdata != "") {
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              var produto = retOdata.value[0];
              this.selecionarProduto(produto);
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!"
              );
            }
          } catch (error) {
            this.errosGerais = error;
          }
        } else {
          this.errosValidacao = {
            InclusaoRapida: "Verifique o código do produto",
          };
        }
      } else {
        this.errosValidacao = { InclusaoRapida: "Informe o código do produto" };
      }
    },
    async adicionarProdutoPedido() {
      if (this.pedido.PedidoItem.length > 0) {
        if (
          this.pedido.PedidoItem[this.pedido.PedidoItem.length - 1]
            .em_branco === undefined ||
          this.pedido.PedidoItem[this.pedido.PedidoItem.length - 1]
            .em_branco === false
        ) {
          this.adicionarProdutoEmBranco();
        }
      } else {
        this.adicionarProdutoEmBranco();
      }
    },
    async adicionarProdutoEmBranco() {
      var produto = {
        codigo: "",
        nome: "",
        und: "",
        qtd: 0,
        preco: 0,
        preco_custo: 0,
        cod_referencia: "",
        ProdutoTributacao: {
          ipi: 0,
          icms: 0,
          st: "",
          csosn: "",
        },
        em_branco: true,
      };
      this.addItemBranco = true;
      await this.preencheProdutoSelecionado(produto, true, 0);

      setTimeout(() => {
        this.tabFocus(
          pedidoMapper.PedidoItemid_produto[0],
          pedidoMapper.PedidoItemid_produto[1]
        );
        this.nextFocus(
          `PedidoItem[${this.pedido.PedidoItem.length - 1}]id_produto`
        );
      }, 50);
      this.addItemBranco = false;
    },
    async adicionarProdutoCodigoGrid(index) {
      var codigo = this.pedido.PedidoItem[index].id_produto;

      var filterOdata = "";
      this.errosGerais = {};
      this.errosValidacao = [];
      if (codigo != "") {
        var radio = document.getElementsByName("rbPesquisaRapida");
        if (radio[0].checked && this.$utils.isNumber(codigo)) {
          filterOdata = "&$filter=id eq " + codigo;
        }
        if (radio[1].checked) {
          filterOdata = "&$filter=ean eq '" + codigo + "'";
        }
        if (filterOdata != "") {
          try {
            var retOdata = await this.$store.dispatch(
              "produto/getProdutoOData",
              "?$expand=Adicional($expand=AdicionalGrupo($expand=AdicionalGrupoItem)),ProdutoTributacao" +
                filterOdata
            );
            if (retOdata.value !== null && retOdata.value.length > 0) {
              this.pedido.PedidoItem.splice(index, 1);
              var produto = retOdata.value[0];
              this.selecionarProduto(produto);
            } else {
              await this.$swal.showInvalidAlert(
                "Nenhum Produto foi encontrado com o código informado!"
              );
            }
          } catch (error) {
            this.errosGerais = error;
          }
        } else {
          this.errosValidacao[`PedidoItem[${index}]id_produto`] =
            "Verifique o código do produto";
        }
      } else {
        this.errosValidacao[`PedidoItem[${index}]id_produto`] =
          "Informe o código do produto";
      }
    },
    getErrorByID(id) {
      return this.errosValidacao[id] &&
        this.errosValidacao[id] !== undefined &&
        this.errosValidacao[id] !== ""
        ? this.errosValidacao[id]
        : null;
    },
    async verificarCST(id, index, isValidacaoGeral) {
      try {
        var item = this.pedido.PedidoItem[index];
        if (item && item.st !== "") {
          let result = this.$utils.validarCST(item.st);
          if (result === true) {
            if (this.errosValidacao[id] !== undefined) {
              delete this.errosValidacao[id];
            }
          } else {
            if (this.errosValidacao[id] === undefined) {
              this.errosValidacao[id] = {};
            }
            this.errosValidacao[id] = "CST Inválida";
            if (!isValidacaoGeral) {
              await this.$swal.showInvalidAlert("CST Inválida", (alert) => {
                this.$utils.requestFocus(id);
              });
            }
          }
        } else {
          if (this.errosValidacao[id] === undefined) {
            this.errosValidacao[id] = {};
          }
          this.errosValidacao[id] = "CST Inválida";
          if (!isValidacaoGeral) {
            await this.$swal.showInvalidAlert("CST Inválida", (alert) => {
              this.$utils.requestFocus(id);
            });
          }
        }
      } catch (error) {
        console.log(error);
      }

      if (!this.getErrorByID(id)) {
        this.nextFocus(`PedidoItem[${index}]icms`);
      }
    },
    async verificarCSOSN(id, index, isValidacaoGeral) {
      try {
        var item = this.pedido.PedidoItem[index];
        if (item && item.csosn !== "") {
          let result = this.$utils.validarCSOSN(item.csosn);
          if (result === true) {
            if (this.errosValidacao[id] !== undefined) {
              delete this.errosValidacao[id];
            }
          } else {
            if (this.errosValidacao[id] === undefined) {
              this.errosValidacao[id] = {};
            }
            this.errosValidacao[id] = "CSOSN Inválido";
            if (!isValidacaoGeral) {
              await this.$swal.showInvalidAlert("CSOSN Inválido", (alert) => {
                this.$utils.requestFocus(id);
              });
            }
          }
        } else {
          if (this.errosValidacao[id] === undefined) {
            this.errosValidacao[id] = {};
          }
          this.errosValidacao[id] = "CSOSN Inválido";
          if (!isValidacaoGeral) {
            await this.$swal.showInvalidAlert("CSOSN Inválido", (alert) => {
              this.$utils.requestFocus(id);
            });
          }
        }
      } catch (error) {
        console.log(error);
      }

      if (!this.getErrorByID(id)) {
        this.nextFocus(`PedidoItem[${index}]icms`);
      }
    },
    verificarPromocaoAtiva(produto) {
      var promocaoAtiva = false;
      if (produto.promocao_ativa === "1" && produto.preco_promocao > 0) {
        if (new Date(produto.data_inicio_promocao) <= new Date()) {
          if (new Date(produto.data_fim_promocao) >= new Date()) {
            if (produto.promocao_tipo === "0") {
              promocaoAtiva = true;
            } else {
              if (produto.promocao_dias_semana !== null) {
                var diaDaSemana = new Date().getDay();
                if (produto.promocao_dias_semana.includes(diaDaSemana)) {
                  promocaoAtiva = true;
                }
              }
            }
          }
        }
      }
      return promocaoAtiva;
    },
    async preencheProdutoSelecionado(produto, add, index) {
      try {
        var listSubItem = [];
        var quantidade = produto.qtd ? produto.qtd : 1;
        var obs = "";

        if (produto.Adicional != null) {
          for (var i = 0; i < produto.Adicional.AdicionalGrupo.length; i++) {
            for (
              var y = 0;
              y < produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem.length;
              y++
            ) {
              var item =
                produto.Adicional.AdicionalGrupo[i].AdicionalGrupoItem[y];
              if (item.qtd > 0) {
                obs +=
                  (obs != "" ? "\r\n" : "") +
                  item.qtd +
                  "  " +
                  item.descricao +
                  (item.valor > 0
                    ? " - " + this.$utils.formatarNumero(item.valor)
                    : "");

                listSubItem.push({
                  id: 0,
                  id_pedido: 0,
                  id_pedido_item: 0,
                  id_adicional_grupo_item: item.id,
                  item: 0,
                  descricao: item.descricao,
                  qtd: item.qtd,
                  preco: item.valor,
                  total: 0,
                  desconto: 0,
                  acrescimo: 0,
                  cod_referencia: item.cod_referencia,
                  observacao: "",
                });
              }
            }
          }
        }
        obs += produto.observacao
          ? (obs != "" ? "\r\nObs: " : "") + produto.observacao
          : "";

        var em_branco = false;
        if (produto.em_branco !== undefined) {
          em_branco = produto.em_branco;
        }

        if (add === true) {
          var preco =
            produto.promocaoAtiva === true
              ? produto.preco_promocao
              : produto.preco;

          let itemAdicionar = {
            id: 0,
            id_pedido: 0,
            item: 0,
            id_produto: produto.id,
            id_estoque: produto.id_estoque,
            id_estoque_variacao: null,
            und: produto.und,
            nome: produto.nome,
            qtd: quantidade,
            preco: preco,
            valor_frete: 0,
            desconto: 0,
            acrescimo: 0,
            valor_outras: 0,
            total_sub_itens: 0,
            total: 0,
            cod_referencia: produto.cod_referencia,
            observacao: obs,
            Produto: produto,
            PedidoSubItem: listSubItem.length > 0 ? listSubItem : [],
            brinde: produto.brinde,
            aliqi: parseFloat(produto.ProdutoTributacao.aliqi),
            base_icms: 0,
            base_icms_sub: 0,
            comissao: 0,
            custo: produto.preco_custo,
            det_cod_barras: null,
            det_metragem: null,
            det_pesagem: null,
            det_tipo_embalagem: null,
            det_tolerancia: null,
            icms: parseFloat(produto.ProdutoTributacao.icms),
            id_vendedor: null,
            ipi: produto.ProdutoTributacao.ipi,
            mva: produto.ProdutoTributacao.mva,
            nitemped: null,
            peso_bruto: 0,
            peso_liquido: 0,
            qtd_entregue: 0,
            qtd_importada: 0,
            reducao: produto.ProdutoTributacao.reducao,
            st: produto.ProdutoTributacao.st,
            csosn: produto.ProdutoTributacao.csosn,
            tipo_prod: null,
            total_icms: 0,
            total_icms_sub: 0,
            total_ipi: 0,
            valor_seguro: 0,
            xped: null,
            em_branco: em_branco,
            id_estoque_st: null,
            EstoqueST: null,
          };

          if (
            produto.ProdutoTributacao &&
            produto.ProdutoTributacao.id_estoque_st &&
            produto.ProdutoTributacao.id_estoque_st !== null &&
            produto.ProdutoTributacao.id_estoque_st > 0
          ) {
            let tabelaEstados = await this.retornarTabelaEstados(
              produto.ProdutoTributacao.id_estoque_st
            );
            if (tabelaEstados !== null) {
              itemAdicionar.aliqi = tabelaEstados.aliqi;
              itemAdicionar.icms = tabelaEstados.aliq;
              itemAdicionar.mva = tabelaEstados.mva;
              itemAdicionar.reducao = tabelaEstados.reducao;
              itemAdicionar.st = tabelaEstados.st;
              itemAdicionar.csosn = tabelaEstados.csosn;
              itemAdicionar.id_estoque_st =
                produto.ProdutoTributacao.id_estoque_st;
              itemAdicionar.EstoqueST = tabelaEstados.estoqueST;
            }
          }

          this.pedido.PedidoItem.push(itemAdicionar);

          if (produto.em_branco === undefined || produto.em_branco === false) {
            setTimeout(() => {
              this.nextFocus(
                `PedidoItem[${this.pedido.PedidoItem.length - 1}]qtd`
              );

              if (this.pesquisaAdicionarExcluirProduto != "") {
                this.pesquisaAdicionarExcluirProduto = "";
                this.nextFocus("pesquisaAdicionarExcluirProduto");
              }

              MenuComponent.reinitialization();
            }, 100);
          }
        } else {
          this.pedido.PedidoItem[index].qtd = quantidade;
          this.pedido.PedidoItem[index].total_sub_itens = 0;
          this.pedido.PedidoItem[index].total = 0;
          this.pedido.PedidoItem[index].observacao = obs;
          this.pedido.PedidoItem[index].Produto = produto;
          this.pedido.PedidoItem[index].id_estoque = produto.id_estoque;
          this.pedido.PedidoItem[index].PedidoSubItem = null;
          this.pedido.PedidoItem[index].PedidoSubItem =
            listSubItem.length > 0 ? listSubItem : [];

          toast.info("Produto atualizado com sucesso!", {
            timeout: 2000,
          });
        }

        this.pesquisaProduto = "";
        this.recalcularValores();
      } catch (error) {
        console.log(error);
      }
    },
    async retornarTabelaEstados(id) {
      let ufCliente = this.pedido.PedidoCliente.PedidoEndereco.uf;
      try {
        let filter =
          "?$filter=id_estoque_st eq " +
          id +
          " and uf eq '" +
          ufCliente +
          "' and simples_nac eq '0'";
        let retOdata = await this.$store.dispatch("stUf/getStUfOData", filter);
        if (retOdata.value !== null && retOdata.value.length > 0) {
          let stUF = retOdata.value[0];

          filter = "?$filter=id eq " + id;
          let retOdataEstoqueSt = await this.$store.dispatch(
            "estoqueSt/getEstoqueStOData",
            filter
          );

          if (
            retOdataEstoqueSt.value !== null &&
            retOdataEstoqueSt.value.length > 0
          ) {
            stUF.estoqueST = retOdataEstoqueSt.value[0];
          }

          return stUF;
        }
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    modalTransportadoras(exibir) {
      this.exibirTransportadoras = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_transportadoras_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTransportadoras");
          },
          /*close*/ () => {
            this.modalTransportadoras(false);
          }
        );
      }
    },
    selecionarTransportadora(transportadora) {
      this.pedido.id_transportadora = transportadora.id;
      this.pedido.Transportadora.nome = transportadora.nome;
      toast.info("Transportadora / Entregador selecionado com sucesso!", {
        timeout: 2000,
      });
    },
    modalMotoristas(exibir) {
      this.exibirMotoristas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_motoristas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarMotoristas");
          },
          /*close*/ () => {
            this.modalMotoristas(false);
          }
        );
      }
    },
    selecionarMotorista(motorista) {
      this.pedido.id_motorista = motorista.id;
      this.pedido.Motorista.nome = motorista.nome;
      toast.info("Motorista selecionado com sucesso!", {
        timeout: 2000,
      });
    },
    modalVendedores(exibir) {
      this.exibirVendedores = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_vendedores_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVendedores");
          },
          /*close*/ () => {
            this.modalVendedores(false);
          }
        );
      }
    },
    selecionarVendedor(vendedor) {
      this.pedido.id_vendedor = vendedor.id;
      this.pedido.Vendedor.nome = vendedor.nome;
      this.pedido.comissao_per = vendedor.comissao;
      this.recalcularValores();
      toast.info("Vendedor selecionado com sucesso!", {
        timeout: 2000,
      });
    },
    modalVendedoresItem(exibir) {
      this.exibirVendedoresItem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_vendedores_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVendedores");
          },
          /*close*/ () => {
            this.modalVendedoresItem(false);
          }
        );
      }
    },
    selecionarVendedorItem(vendedor) {
      this.idVendedorPedidoItem = vendedor.id;
      this.comissaoVendedorPedidoItem = vendedor.comissao;
      this.nomeVendedorPedidoItem = vendedor.nome.toUpperCase();
    },
    modalCidades(exibir) {
      this.exibirCidades = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cidades",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCidades");
          },
          /*close*/ () => {
            this.modalCidades(false);
          }
        );
      }
    },
    exibirModalCidades(exibir, index) {
      this.pesquisaCidadeIndex = index;
      this.modalCidades(exibir);
    },
    confirmarCidade(cidade) {
      if (this.pesquisaCidadeIndex === 0) {
        this.pedido.PedidoCliente.PedidoEndereco.cidade = cidade.cidade;
        this.pedido.PedidoCliente.PedidoEndereco.cod_cidade = cidade.codcidade;
        this.pedido.PedidoCliente.PedidoEndereco.uf = cidade.uf;
        this.pedido.PedidoCliente.PedidoEndereco.cod_pais = "1058";
        this.pedido.PedidoCliente.PedidoEndereco.pais = "BRASIL";
      }
      if (this.pesquisaCidadeIndex === 1) {
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cidade = cidade.cidade;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_cidade =
          cidade.codcidade;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.uf = cidade.uf;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_pais = "1058";
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.pais = "BRASIL";
      }
    },
    modalPaises(exibir) {
      this.exibirPaises = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_paises",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarPaises");
          },
          /*close*/ () => {
            this.modalPaises(false);
          }
        );
      }
    },
    exibirModalPaises(exibir, index) {
      this.pesquisaPaisIndex = index;
      this.modalPaises(exibir);
    },
    confirmarPais(pais) {
      if (this.pesquisaPaisIndex === 0) {
        this.pedido.PedidoCliente.PedidoEndereco.cod_pais = pais.codbacen;
        this.pedido.PedidoCliente.PedidoEndereco.pais = pais.descricao;
      }
      if (this.pesquisaPaisIndex === 1) {
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_pais =
          pais.codbacen;
        this.pedido.PedidoCliente.PedidoEnderecoEntrega.pais = pais.descricao;
      }
    },
    async pesquisarCep(index) {
      this.loadingCep = true;
      if (index === 0) {
        if (
          this.pedido.PedidoCliente.PedidoEndereco.cep !== null &&
          this.pedido.PedidoCliente.PedidoEndereco.cep != ""
        ) {
          try {
            var ret = await this.$store.dispatch(
              "cep/getCep",
              this.pedido.PedidoCliente.PedidoEndereco.cep
            );
            if (ret.Data !== null) {
              this.pedido.PedidoCliente.PedidoEndereco.endereco =
                ret.Data.logradouro;
              this.pedido.PedidoCliente.PedidoEndereco.bairro = ret.Data.bairro;
              this.pedido.PedidoCliente.PedidoEndereco.complemento =
                ret.Data.complemento;
              this.pedido.PedidoCliente.PedidoEndereco.cod_cidade =
                ret.Data.ibge;
              this.pedido.PedidoCliente.PedidoEndereco.cidade = ret.Data
                .localidade
                ? ret.Data.localidade.toUpperCase()
                : "";
              this.pedido.PedidoCliente.PedidoEndereco.uf = ret.Data.uf;
              this.pedido.PedidoCliente.PedidoEndereco.pais = "BRASIL";
              this.pedido.PedidoCliente.PedidoEndereco.cod_pais = "1058";
            }
          } catch (error) {
            await this.$swal.showInvalidAlert(
              "Não foi possível localizar o CEP!"
            );
          }
        }
      }
      if (index === 1) {
        if (
          this.pedido.PedidoCliente.PedidoEnderecoEntrega.cep !== null &&
          this.pedido.PedidoCliente.PedidoEnderecoEntrega.cep != ""
        ) {
          try {
            var retEntrega = await this.$store.dispatch(
              "cep/getCep",
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.cep
            );
            if (retEntrega.Data !== null) {
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.endereco =
                retEntrega.Data.logradouro;
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.bairro =
                retEntrega.Data.bairro;
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.complemento =
                retEntrega.Data.complemento;
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_cidade =
                retEntrega.Data.ibge;
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.cidade =
                retEntrega.Data.localidade
                  ? retEntrega.Data.localidade.toUpperCase()
                  : "";
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.uf =
                retEntrega.Data.uf;
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.pais = "BRASIL";
              this.pedido.PedidoCliente.PedidoEnderecoEntrega.cod_pais = "1058";
            }
          } catch (error) {
            await this.$swal.showInvalidAlert(
              "Não foi possível localizar o CEP!"
            );
          }
        }
      }
      this.loadingCep = false;
    },
    async limparPedido() {
      this.pedido = JSON.parse(JSON.stringify(pedidoInicializado));

      this.pesquisaProduto = "";
      this.pesquisaAdicionarExcluirProduto = "";
      this.idCliente = 0;
      this.indexPedidoPagamento = -1;
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];

      this.pedido.data_emissao = new Date();
      this.pedido.data_entrega = new Date();
      this.pedido.data_ped_compra = new Date();

      this.pedido.data_inicio_preparo = new Date();
      this.pedido.tempo_preparo = "00:00:00";
      this.pedido.data_cancelamento = new Date();
    },
    async carregarConfiguracoes() {
      try {
        var ret = await this.$store.dispatch(
          "configuracao/getConfiguracaoOData",
          "?$select=formula_basecalculo,formula_icms_sub,st_00,st_10,st_20,st_30,st_40,st_41,st_50,st_51,st_60,st_70,st_90"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.configuracao = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarPedido(id) {
      this.errosGerais = {};
      try {
        var ret = await this.$store.dispatch("pedido/getPedido", id);
        if (ret.Success === true) {
          this.pedido = ret.Data;

          this.pedido.peso_bruto =
            this.pedido.peso_bruto != null
              ? parseFloat(this.pedido.peso_bruto)
              : 0;
          this.pedido.peso_liquido =
            this.pedido.peso_liquido != null
              ? parseFloat(this.pedido.peso_liquido)
              : 0;

          this.pedido.utiliza_icms_sub = this.$utils.stringToBoolean(
            this.pedido.utiliza_icms_sub
          );

          if (this.pedido.Transportadora === null) {
            this.pedido.Transportadora = {
              nome: "",
            };
          }

          if (this.pedido.Motorista === null) {
            this.pedido.Motorista = {
              nome: "",
            };
          }

          if (this.pedido.Vendedor === null) {
            this.pedido.Vendedor = {
              nome: "",
            };
          }

          if (this.pedido.Condicao === null) {
            this.pedido.Condicao = {
              condicoes: "",
            };
          }

          if (this.pedido.PedidoCliente != null) {
            if (this.pedido.PedidoCliente.id_cliente != null) {
              try {
                var retCli = await this.$store.dispatch(
                  "cliente/getCliente",
                  this.pedido.PedidoCliente.id_cliente
                );
                if (retCli.Success === true) {
                  this.pedido.PedidoCliente.Cliente = retCli.Data;
                }
              } catch (error) {
                this.errosGerais = error;
              }
            }

            if (this.pedido.PedidoCliente.PedidoEndereco === null) {
              this.pedido.PedidoCliente.PedidoEndereco = {
                id: 0,
                id_pedido: 0,
                id_pedido_cliente: 0,
                id_cliente_endereco: null,
                descricao: "Casa",
                endereco: "",
                complemento: "",
                bairro: "",
                numero: "",
                cep: "",
                cidade: "",
                cod_cidade: "",
                uf: "SP",
                pais: "",
                cod_pais: "",
                latitude: "",
                longitude: "",
              };
            }
          }

          this.carregarAnexos();

          setTimeout(MenuComponent.reinitialization, 500);
        }
      } catch (error) {
        this.errosGerais = error;
      }
      this.loading = false;
    },
    getSituacaoColor(situacao) {
      if (situacao.toUpperCase() === "FATURADO") {
        return "bg-success";
      } else if (situacao.toUpperCase() === "ATRASADO") {
        return "bg-danger";
      } else if (situacao.toUpperCase() === "ENTREGUE") {
        return "bg-info";
      } else if (situacao.toUpperCase() === "PENDENTE") {
        return "bg-primary";
      } else {
        return "bg-dark";
      }
    },
    getTipoColor(tipo) {
      if (tipo.toUpperCase() === "DELIVERY") {
        return "bg-info";
      } else if (tipo.toUpperCase() === "AGENDAMENTO") {
        return "bg-warning";
      } else if (tipo.toUpperCase() === "RETIRADA") {
        return "bg-primary";
      } else {
        return "bg-dark";
      }
    },
    getEspeciePagamento(especie) {
      if (especie === "1") {
        // Dinheiro
        return "media/icons/duotune/finance/fin003.svg";
      } else if (especie === "2") {
        // Cheque
        return "media/icons/duotune/files/fil003.svg";
      } else if (especie === "3") {
        // Cartão de Crédito
        return "media/icons/duotune/finance/fin002.svg";
      } else if (especie === "4") {
        // Cartão de Débito
        return "media/icons/duotune/finance/fin002.svg";
      } else if (especie === "5") {
        // Crédito Loja / A PRAZO / Convênio / T.E.F
        return "media/icons/duotune/coding/cod002.svg";
      } else if (especie === "10") {
        // Vale Alimentação
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "11") {
        // Vale Refeição
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "12") {
        // Vale Presente
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "13") {
        // Vale Combustível
        return "media/icons/duotune/ecommerce/ecm011.svg";
      } else if (especie === "17") {
        // PIX
        return "media/icons/duotune/finance/fin010.svg";
      } else {
        // Outros
        return "media/icons/duotune/finance/fin008.svg";
      }
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async asyncData() {
      try {
        this.loading = true;
        await this.carregarConfiguracoes();
        if (
          (this.$route.name.includes("movimentacao/pedidos/editar") &&
            this.$route.params.id !== undefined) ||
          this.idPedido !== 0
        ) {
          this.add = false;

          const id =
            this.modal === true
              ? this.idPedido
              : parseInt(this.$route.params.id);

          if ((await this.abrirPedido(id)) === false) {
            await this.carregarPedido(id);
          }
          this.recalcularValores();
        } else if (
          this.$route.name.includes("movimentacao/pedidos/editar") ||
          (this.idPedido === 0 && this.modal === true)
        ) {
          this.add = true;
          if ((await this.abrirPedido(0)) === false) {
            await this.limparPedido();
          }

          if (this.pedido.PedidoCliente.id_cliente === null) {
            this.modalClientes(true);
          }
        }

        this.tableProdutoHeader = this.tableProdutoHeader.filter(
          (item) => item.key !== "csosn" || this.user.User.Emitente.crt === 1
        );

        this.tableProdutoHeader = this.tableProdutoHeader.filter(
          (item) => item.key !== "cst" || this.user.User.Emitente.crt !== 1
        );

        this.loading = false;
        this.confirmouCadastro = true;
        this.carregarSituacoes();
        this.carregarCategorias();
        this.carregarTipos();
        this.carregarLocais();
        this.carregarPedidoItemDetPesagens();
        this.carregarPedidoItemDetTolerancias();
        this.carregarPedidoItemDetTipoEmbalagens();
        this.carregarPedidoItemDetCodBarras();
        this.carregarPedidoItemDetMetragens();
        this.carregarTiposProduto();
        this.carregarLabelDescricao();

        setTimeout(MenuComponent.reinitialization, 500);
      } catch (error) {
        console.log(error);
      }
    },
    focusAviso(value) {
      if (typeof value.onClick === "function") {
        this.tabFocus(value.tab, value.tabID);
        if (value.indices && value.indices.length > 0) {
          this.indices = value.indices;
        } else {
          this.indices = [];
        }
        value.onClick();
        setTimeout(() => {
          this.nextFocus(value.elemento);
        }, 800);
      } else {
        this.tabFocus(value.tab, value.tabID);
        this.nextFocus(value.elemento);
      }
    },
    mapperModal() {
      pedidoMapper.ped_compra[2] = this.modalEditarPedidoCompra.bind(
        this,
        true
      );
      pedidoMapper.data_ped_compra[2] = this.modalEditarPedidoCompra.bind(
        this,
        true
      );
      pedidoMapper.PedidoItemid_vendedor[2] =
        this.editarPedidoVendedorProduto.bind(this, null);
      pedidoMapper.PedidoItemcomissao[2] =
        this.editarPedidoVendedorProduto.bind(this, null);
      pedidoMapper.PedidoItemxped[2] = this.editarPedidoCompraProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItemnitemped[2] = this.editarPedidoCompraProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItemobservacao[2] = this.editarObservacoesProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItempeso_bruto[2] = this.editarPedidoPesoProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItempeso_liquido[2] =
        this.editarPedidoPesoProduto.bind(this, null);
      pedidoMapper.PedidoItemdet_pesagem[2] = this.editarDetalhesProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItemdet_tolerancia[2] =
        this.editarDetalhesProduto.bind(this, null);
      pedidoMapper.PedidoItemdet_tipo_embalagem[2] =
        this.editarDetalhesProduto.bind(this, null);
      pedidoMapper.PedidoItemdet_cod_barras[2] =
        this.editarDetalhesProduto.bind(this, null);
      pedidoMapper.PedidoItemdet_metragem[2] = this.editarDetalhesProduto.bind(
        this,
        null
      );
      pedidoMapper.PedidoItemid_estoque_st[2] =
        this.editarPedidoTabelaEstadosProduto.bind(this, null);
    },
    async abrirPedido(id_pedido) {
      let result = false;

      const id_usuario = this.user.User.id;
      const pedidosSalvos = this.getPedidosSalvos();
      const pedidoSavo = pedidosSalvos[id_usuario] || {};
      const pedidoSalvoExistente =
        Object.keys(pedidoSavo).length !== 0 &&
        Object.prototype.hasOwnProperty.call(pedidoSavo, id_pedido);

      if (id_pedido === 0) {
        if (pedidoSalvoExistente) {
          await this.$swal.showQuestionAlert(
            "Existe uma inclusão de pedido em andamento! Deseja continuar a edição?",
            async (alert) => {
              if (alert.isConfirmed) {
                this.pedido = JSON.parse(JSON.stringify(pedidoSavo[id_pedido]));

                this.removerAnexosPendentes();
                result = true;
              } else {
                this.limparPedidoLocalStorage(id_usuario, id_pedido);
              }
            }
          );
        }
      } else {
        const pedidoEmEdicao = await this.verificaControleEdicao(id_pedido);
        const pedidoEmEdicaoEncontrado =
          Object.keys(pedidoEmEdicao).length !== 0;

        if (pedidoEmEdicaoEncontrado) {
          if (pedidoEmEdicao.id_usuario !== id_usuario) {
            await this.$swal.showQuestionAlert(
              "Existe uma edição do pedido Nº " +
                id_pedido +
                " em andamento pelo usuário " +
                pedidoEmEdicao.Usuario.nome +
                "! Se você continuar as alterações anteriores serão descartadas! Tem certeza que deseja editar mesmo assim?",
              async (alert) => {
                if (alert.isConfirmed) {
                  this.limparPedidoLocalStorage(
                    pedidoEmEdicao.id_usuario,
                    id_pedido
                  );
                  await this.insertControleEdicao(id_pedido);
                } else {
                  this.limparPedidoLocalStorage(id_usuario, id_pedido);
                  if (this.modal === true) {
                    this.$emit("cancelarPedido", false);
                  } else {
                    this.$router.push("/movimentacao/pedidos/consultar");
                  }
                }
              }
            );
          } else {
            await this.insertControleEdicao(id_pedido);

            if (pedidoSalvoExistente) {
              await this.$swal.showQuestionAlert(
                "Existe uma edição do pedido Nº " +
                  id_pedido +
                  " em andamento! Deseja continuar a edição?",
                (alert) => {
                  if (alert.isConfirmed) {
                    this.pedido = JSON.parse(
                      JSON.stringify(pedidoSavo[id_pedido])
                    );

                    this.removerAnexosPendentes();
                    result = true;
                  } else {
                    this.limparPedidoLocalStorage(id_usuario, id_pedido);
                  }
                }
              );
            }
          }
        } else {
          this.limparPedidoLocalStorage(id_usuario, id_pedido);
          await this.insertControleEdicao(id_pedido);
        }
      }

      return result;
    },
    removerAnexosPendentes() {
      this.pedido.PedidoAnexo = this.pedido.PedidoAnexo.filter((anexo) => {
        return !("status" in anexo && anexo.status === "ready");
      });
    },
    async verificaControleEdicao(id_edicao) {
      let result = {};
      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/getControleEdicaoOData",
          "?$filter=id_edicao eq " +
            id_edicao +
            " and modulo eq 'Pedidos'" +
            "&$expand=Usuario($select=nome)"
        );
        if (ret.value !== null && ret.value.length > 0) {
          result = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }

      return result;
    },
    async insertControleEdicao(id_edicao) {
      await this.deleteControleEdicao(id_edicao);

      var controleEdicao = {
        id: 0,
        id_edicao: id_edicao,
        id_usuario: this.user.User.id,
        modulo: "Pedidos",
      };

      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/postControleEdicao",
          controleEdicao
        );
      } catch (error) {
        console.log(error);
      }
    },
    async deleteControleEdicao(id_edicao) {
      var controleEdicao = {
        id_edicao: id_edicao,
        modulo: "Pedidos",
      };

      try {
        var ret = await this.$store.dispatch(
          "controleEdicao/deleteControleEdicaoIdEdicao",
          controleEdicao
        );
      } catch (error) {
        console.log(error);
      }
    },
    limparPedidoLocalStorage(id_usuario, id_pedido) {
      const pedidosSalvos = this.getPedidosSalvos();

      if (Object.prototype.hasOwnProperty.call(pedidosSalvos, id_usuario)) {
        delete pedidosSalvos[id_usuario][id_pedido];

        if (Object.keys(pedidosSalvos[id_usuario]).length === 0) {
          delete pedidosSalvos[id_usuario];
        }

        localStorage.setItem("pedidosSalvos", JSON.stringify(pedidosSalvos));
      }
    },
    salvarPedidoLocalStorage() {
      const pedidosSalvos = this.getPedidosSalvos();
      const id_usuario = this.user.User.id;
      const id_pedido = this.pedido.id;

      if (!Object.prototype.hasOwnProperty.call(pedidosSalvos, id_usuario)) {
        pedidosSalvos[id_usuario] = {};
      }

      var pedidoBackup = JSON.parse(JSON.stringify(this.pedido));
      pedidoBackup.PedidoAnexo = pedidoBackup.PedidoAnexo.filter((anexo) => {
        return !("status" in anexo && anexo.status === "ready");
      });

      pedidosSalvos[id_usuario][id_pedido] = pedidoBackup;
      localStorage.setItem("pedidosSalvos", JSON.stringify(pedidosSalvos));
    },
    getPedidosSalvos() {
      return JSON.parse(localStorage.getItem("pedidosSalvos")) || {};
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.SituacaoPedido.Consultar") {
            this.consultarSituacaoPedido = true;
          }

          if (element.regra === "Permitir.CategoriaPedido.Consultar") {
            this.consultarCategoriaPedido = true;
          }

          if (element.regra === "Permitir.TipoPedido.Consultar") {
            this.consultarTipoPedido = true;
          }

          if (element.regra === "Permitir.LocalPedido.Consultar") {
            this.consultarLocalPedido = true;
          }

          if (element.regra === "Permitir.PedidoAnexo.Consultar") {
            this.consultarPedidoAnexo = true;
          }
          if (element.regra === "Permitir.PedidoAnexo.Incluir") {
            this.adicionarPedidoAnexo = true;
          }
          if (element.regra === "Permitir.PedidoAnexo.Excluir") {
            this.excluirPedidoAnexo = true;
          }

          if (element.regra === "Permitir.PedidoItemDetPesagem.Consultar") {
            this.consultarPedidoItemDetPesagem = true;
          }

          if (element.regra === "Permitir.PedidoItemDetTolerancia.Consultar") {
            this.consultarPedidoItemDetTolerancia = true;
          }

          if (
            element.regra === "Permitir.PedidoItemDetTipoEmbalagem.Consultar"
          ) {
            this.consultarPedidoItemDetTipoEmbalagem = true;
          }

          if (element.regra === "Permitir.PedidoItemDetCodBarras.Consultar") {
            this.consultarPedidoItemDetCodBarras = true;
          }

          if (element.regra === "Permitir.PedidoItemDetMetragem.Consultar") {
            this.consultarPedidoItemDetMetragem = true;
          }

          if (element.regra === "Permitir.TipoProduto.Consultar") {
            this.consultarTipoProduto = true;
          }
        });
      }
    },
  },
  watch: {
    pedido: {
      deep: true,
      handler() {
        this.salvarPedidoLocalStorage();
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.fullPath.includes("movimentacao/pedidos/editar")) {
      this.asyncData();
    }
    next(); // Importante chamar next() para continuar a navegação
  },
  async mounted() {
    await this.verificarRestricoes();
    this.keyListener = (e) => {
      // Utilizar o metakey como combinação além do ctrl
      //para manter a compatibilidade com o mac
      if (e.key === "a" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopPropagation();
        this.adicionarProdutoPedido();
      } else if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        e.stopPropagation();
        this.modalProdutos(true);
      } else if (e.key === "F3") {
        e.preventDefault();
        e.stopPropagation();
        this.modalProdutos(true);
      } else if (e.key === "F5") {
        e.preventDefault();
        e.stopPropagation();
        this.adicionarProdutoPedido();
      } else if (e.key === "F10") {
        e.preventDefault();
        e.stopPropagation();
        this.modalPedidoRecalcularValores(true);
      } else if (e.key === "F11") {
        e.preventDefault();
        e.stopPropagation();
        this.modalAlterarPrecoVenda(true);
      } else if (e.key === "+") {
        e.preventDefault();
        e.stopPropagation();
        this.pedidoAdicionarExcluirProduto(0);
      } else if (e.key === "-") {
        e.preventDefault();
        e.stopPropagation();
        this.pedidoAdicionarExcluirProduto(1);
      }
    };

    window.addEventListener("keydown", this.keyListener);

    this.asyncData();
    this.mapperModal();
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.keyListener);

    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      backdrop.remove();
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      consultarTipoProduto: false,
      consultarPedidoItemDetPesagem: false,
      consultarPedidoItemDetTolerancia: false,
      consultarPedidoItemDetTipoEmbalagem: false,
      consultarPedidoItemDetCodBarras: false,
      consultarPedidoItemDetMetragem: false,
      consultarPedidoAnexo: false,
      adicionarPedidoAnexo: false,
      excluirPedidoAnexo: false,
      consultarSituacaoPedido: false,
      consultarCategoriaPedido: false,
      consultarTipoPedido: false,
      consultarLocalPedido: false,
      disableUpload: false,
      indices: [],
      timeOut: null,
      modalComponent: null,
      exibirKits: false,
      exibirTabelaEstados: false,
      exibirEditarProdutoObservacoes: false,
      exibirEditarProdutoDetalhes: false,
      exibirEditarPedidoPesoItem: false,
      exibirEditarPedidoVendedorItem: false,
      exibirEditarPedidoTabelaEstadosItem: false,
      exibirEditarPedidoCompraItem: false,
      exibirEditarPedidoCompra: false,
      exibirEditarPedidoAnexo: false,
      exibirPedidoIncluirExcluir: false,
      exibirPedidoRecalcularValores: false,
      exibirAdicionarPedidoBrinde: false,
      labelDescricao: [],
      configuracao: {},
      situacoes: [],
      categorias: [],
      tipos: [],
      locais: [],
      pesagens: [],
      tolerancias: [],
      tipoEmbalagens: [],
      codBarras: [],
      metragens: [],
      tiposProduto: [],
      addItemBranco: false,
      exibirTiposProduto: false,
      exibirPedidoItemDetMetragens: false,
      exibirPedidoItemDetCodBarras: false,
      exibirPedidoItemDetTipoEmbalagens: false,
      exibirPedidoItemDetTolerancias: false,
      exibirPedidoItemDetPesagens: false,
      exibirLocaisPedido: false,
      exibirTiposPedido: false,
      exibirCategoriasPedido: false,
      exibirSituacoesPedido: false,
      exibirCustos: false,
      exibirContas: false,
      adicionalProduto: null,
      produtoEstoque: null,
      pesquisaProduto: "",
      pesquisaAdicionarExcluirProduto: "",
      idCliente: 0,
      indexPedidoPagamento: -1,
      idModalCliente: 0,
      exibirCliente: false,
      exibirClientes: false,
      exibirProdutos: false,
      exibirProdutosBrinde: false,
      exibirTransportadoras: false,
      exibirMotoristas: false,
      exibirVendedores: false,
      exibirVendedoresItem: false,
      exibirPedidoPagamento: false,
      exibirPedidoReceber: false,
      exibirPedidoReceberModal: false,
      exibirEstoques: false,
      exibirAdicional: false,
      exibirDesconto: false,
      exibirAlterarPrecoVenda: false,
      confirmouCadastro: true,
      loading: false,
      loadingCep: false,
      exibirPagamento: false,
      loadingPagamento: false,
      loadingProduto: false,
      add: false,
      addPedidoItem: true,
      nomeProdutoBrinde: "",
      qtdProdutoBrinde: 0,
      produtoBrinde: null,
      indexEdicaoPedidoItem: -1,
      pesoBrutoPedidoItem: 0,
      pesoLiquidoPedidoItem: 0,
      estoqueStPedidoItem: null,
      idVendedorPedidoItem: null,
      nomeVendedorPedidoItem: "",
      comissaoVendedorPedidoItem: 0,
      numeroPedidoCompraPedidoItem: "",
      itemPedidoCompraPedidoItem: "",
      detPesagemPedidoItem: "",
      detToleranciaPedidoItem: "",
      detTipoEmbalagemPedidoItem: "",
      detCodBarrasPedidoItem: "",
      detMetragemPedidoItem: "",
      observacaoPedidoItem: "",
      totalDescontoModal: 0,
      labelTotal: "",
      exibirRemoverDesconto: false,
      exibirLabelRadioExcluir: false,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      errosValidacaoItem: [],
      exibirCidades: false,
      cidadeSelecionada: null,
      exibirPaises: false,
      paisSelecionado: null,
      pesquisaEnderecoIndex: 0,
      pesquisaCidadeIndex: 0,
      pesquisaPaisIndex: 0,
      pedido: JSON.parse(JSON.stringify(pedidoInicializado)),
      consultaCep: {
        cep: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cod_cidade: "",
        cidade: "",
        uf: "SP",
        pais: "",
        cod_pais: "",
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      tableProdutoHeader: [
        {
          name: "Item",
          key: "item",
          sortable: true,
        },
        {
          name: "Código",
          key: "id_produto",
          sortable: true,
        },
        {
          key: "imagem",
          sortable: false,
        },
        {
          name: "Nome do Produto",
          key: "nome",
          sortable: true,
        },
        {
          name: "UND",
          key: "und",
          sortable: true,
        },
        {
          name: "Qtd",
          key: "qtd",
          sortable: true,
        },
        {
          name: "Preço",
          key: "preco",
          sortable: true,
        },
        {
          name: "SubItens",
          key: "total_sub_itens",
          sortable: true,
        },
        {
          name: "Total",
          key: "total",
          sortable: true,
        },
        {
          name: "Tipo Prod.",
          key: "tipo_prod",
          sortable: true,
        },
        {
          name: "IPI",
          key: "ipi",
          sortable: true,
        },
        {
          name: "Desconto",
          key: "desconto",
          sortable: true,
        },
        {
          name: "Acréscimo",
          key: "acrescimo",
          sortable: true,
        },
        {
          name: "CST",
          key: "cst",
          sortable: true,
        },
        {
          name: "CSOSN",
          key: "csosn",
          sortable: true,
        },
        {
          name: "ICMS",
          key: "icms",
          sortable: true,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
    };
  },
};
</script>

<style>
.text-quebrar-linha {
  white-space: pre-line;
}
</style>
